import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  Date: any;
  DateTime: any;
  GenericScalar: any;
  JSONString: any;
};

export type AddItem = {
  __typename?: 'AddItem';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type AddWishlistItem = {
  __typename?: 'AddWishlistItem';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type AttributoMultiploType = {
  __typename?: 'AttributoMultiploType';
  chiave?: Maybe<Scalars['String']>;
  valori?: Maybe<Array<Maybe<ValoreAttributoNode>>>;
};

export type AttributoNode = {
  __typename?: 'AttributoNode';
  alias: Scalars['String'];
  /** Gli attributi visualizzati nella categoria */
  categorie: CategoriaNodeConnection;
  chiave: Scalars['String'];
  children: Array<AttributoNode>;
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  nome: Scalars['String'];
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  ordine: Scalars['Int'];
  parent?: Maybe<AttributoNode>;
  pk?: Maybe<Scalars['Int']>;
  valori: Array<ValoreAttributoNode>;
};


export type AttributoNodeCategorieArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inHome?: InputMaybe<Scalars['Boolean']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  soloConMastersConDocumenti?: InputMaybe<Scalars['Boolean']>;
};

export type BreadcrumbType = {
  __typename?: 'BreadcrumbType';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type CarrelloNode = {
  __typename?: 'CarrelloNode';
  correlati?: Maybe<Array<Maybe<ProdottoNode>>>;
  hasOmaggio?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<RigaCarrelloNode>>>;
  numProdotti?: Maybe<Scalars['Int']>;
  prezzo?: Maybe<Scalars['Float']>;
  promoApplicata?: Maybe<PromozioneNode>;
  promoDipendenti?: Maybe<Scalars['Boolean']>;
  scontoAssoluto?: Maybe<Scalars['Float']>;
  scontoBundles?: Maybe<ScontoBundlesType>;
  totaleScontato?: Maybe<Scalars['Float']>;
};

export type CategoriaHelpOnlineDetailNode = {
  __typename?: 'CategoriaHelpOnlineDetailNode';
  categoria?: Maybe<CategoriaHelpOnlineNode>;
  categorie?: Maybe<Array<Maybe<CategoriaHelpOnlineNode>>>;
};

export type CategoriaHelpOnlineNode = {
  __typename?: 'CategoriaHelpOnlineNode';
  adminUrl?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrl?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  descrizione?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  noindex: Scalars['Boolean'];
  nome?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  risposte?: Maybe<Array<Maybe<RispostaHelpOnlineNode>>>;
  risposteHelpOnline: Array<RispostaHelpOnlineNode>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEnGb?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoH1?: Maybe<Scalars['String']>;
  seoH1En?: Maybe<Scalars['String']>;
  seoH1EnGb?: Maybe<Scalars['String']>;
  seoH1Es?: Maybe<Scalars['String']>;
  seoH1It?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEnGb?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  visibileInCheckout: Scalars['Boolean'];
};

export type CategoriaNewsNode = {
  __typename?: 'CategoriaNewsNode';
  adminUrl?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrl?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  depth: Scalars['Int'];
  descrizione?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCatalogo?: Maybe<Scalars['Boolean']>;
  lft: Scalars['Int'];
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  news: Array<NewsNode>;
  noindex: Scalars['Boolean'];
  nome?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  rgt: Scalars['Int'];
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEnGb?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoH1?: Maybe<Scalars['String']>;
  seoH1En?: Maybe<Scalars['String']>;
  seoH1EnGb?: Maybe<Scalars['String']>;
  seoH1Es?: Maybe<Scalars['String']>;
  seoH1It?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEnGb?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  treeId: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type CategoriaNode = Node & {
  __typename?: 'CategoriaNode';
  /** A list of compatible accessories for the products in the flyer. */
  accessoriCompatibili?: Maybe<Array<Maybe<ProdottoNode>>>;
  adminUrl?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  attivo: Scalars['Boolean'];
  /** Gli attributi visualizzati nella categoria */
  attributi: Array<AttributoNode>;
  boxSottotitolo?: Maybe<Scalars['String']>;
  boxSottotitoloEn?: Maybe<Scalars['String']>;
  boxSottotitoloEnGb?: Maybe<Scalars['String']>;
  boxSottotitoloEs?: Maybe<Scalars['String']>;
  boxSottotitoloIt?: Maybe<Scalars['String']>;
  boxTesto?: Maybe<Scalars['String']>;
  boxTestoEn?: Maybe<Scalars['String']>;
  boxTestoEnGb?: Maybe<Scalars['String']>;
  boxTestoEs?: Maybe<Scalars['String']>;
  boxTestoIt?: Maybe<Scalars['String']>;
  boxTitolo?: Maybe<Scalars['String']>;
  boxTitoloEn?: Maybe<Scalars['String']>;
  boxTitoloEnGb?: Maybe<Scalars['String']>;
  boxTitoloEs?: Maybe<Scalars['String']>;
  boxTitoloIt?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlEn?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlEnGb?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlEs?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlIt?: Maybe<Scalars['String']>;
  chiave: Scalars['String'];
  children?: Maybe<Array<Maybe<CategoriaNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  depth: Scalars['Int'];
  descrizione?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioneVolantino?: Maybe<Scalars['String']>;
  descrizioneVolantinoEn?: Maybe<Scalars['String']>;
  descrizioneVolantinoEnGb?: Maybe<Scalars['String']>;
  descrizioneVolantinoEs?: Maybe<Scalars['String']>;
  descrizioneVolantinoIt?: Maybe<Scalars['String']>;
  googleProductCategory?: Maybe<Scalars['Int']>;
  guidaBreve?: Maybe<Scalars['String']>;
  guidaDettagliata?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** The main image for the flyer subcategory page. */
  immagineVolantino?: Maybe<Scalars['String']>;
  /** A list of URLs for the subcategory images. */
  immaginiVolantinoDigitale?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Categoria visualizzata in homepage sotto alla hero */
  inHome: Scalars['Boolean'];
  /** Categoria visualizzabile nel menu principale */
  inMenu: Scalars['Boolean'];
  invisibile: Scalars['Int'];
  lft: Scalars['Int'];
  /** Sottocategoria visibile nella pagina della categoria padre */
  listingVisibileInPadre: Scalars['Boolean'];
  mainImage?: Maybe<Scalars['String']>;
  masterprodottoSet: Array<MasterProdottoDocumentiNode>;
  masters: Array<MasterProdottoDocumentiNode>;
  mastersCorrelati: Array<MasterProdottoDocumentiNode>;
  mastersOfferta: Array<MasterProdottoDocumentiNode>;
  mastersStaticizzati: Array<MasterProdottoDocumentiNode>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  noindex: Scalars['Boolean'];
  noindexEn: Scalars['Boolean'];
  noindexEnGb: Scalars['Boolean'];
  noindexEs: Scalars['Boolean'];
  noindexIt: Scalars['Boolean'];
  nome: Scalars['String'];
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  numeroProdotti?: Maybe<Scalars['Int']>;
  offertaMarketingBox?: Maybe<OffertaMarketingBoxNode>;
  ordine: Scalars['Int'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  pagine: PaginaNodeConnection;
  parent?: Maybe<CategoriaNode>;
  path?: Maybe<Scalars['String']>;
  pathEn?: Maybe<Scalars['String']>;
  pathEnGb?: Maybe<Scalars['String']>;
  pathEs?: Maybe<Scalars['String']>;
  pathIt?: Maybe<Scalars['String']>;
  /** Language-specific URL for the flyer's PDF. */
  pdfUrl?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  /** A list of plus points for the subcategory. */
  plusPoints?: Maybe<Array<Maybe<PlusPointNode>>>;
  previewImage?: Maybe<Scalars['String']>;
  prodottiLanding?: Maybe<Array<Maybe<ProdottoNode>>>;
  prodottiTopDelMese?: Maybe<Array<Maybe<ProdottoNode>>>;
  /** Regola per l'associazione automatica dei prodotti a questa categoria */
  regolaAssociazioneMaster?: Maybe<CategorieCategoriaRegolaAssociazioneMasterChoices>;
  rgt: Scalars['Int'];
  rilevanza: Scalars['Int'];
  rilevanzaTotale?: Maybe<Scalars['Int']>;
  rootMenuSecondario?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEnGb?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoH1?: Maybe<Scalars['String']>;
  seoH1En?: Maybe<Scalars['String']>;
  seoH1EnGb?: Maybe<Scalars['String']>;
  seoH1Es?: Maybe<Scalars['String']>;
  seoH1It?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEnGb?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  siblings?: Maybe<Array<Maybe<CategoriaNode>>>;
  slug: Scalars['String'];
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  sottoTitolo?: Maybe<Scalars['String']>;
  sottoTitoloEn?: Maybe<Scalars['String']>;
  sottoTitoloEnGb?: Maybe<Scalars['String']>;
  sottoTitoloEs?: Maybe<Scalars['String']>;
  sottoTitoloIt?: Maybe<Scalars['String']>;
  /** Structured data for the technical comparison table. */
  tabellaCompatibilita?: Maybe<Array<Maybe<TabellaCompatibilitaCategoriaNode>>>;
  /** Structured data for the technical comparison table. */
  tabellaDatiTecnici?: Maybe<TabellaDatiTecniciNode>;
  template?: Maybe<Scalars['String']>;
  treeId: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
  valoriAttributo: Array<ValoreAttributoNode>;
  visibileDal?: Maybe<Scalars['DateTime']>;
  visibileFinoal?: Maybe<Scalars['DateTime']>;
  voceMenu: Scalars['String'];
  voceMenuEn?: Maybe<Scalars['String']>;
  voceMenuEnGb?: Maybe<Scalars['String']>;
  voceMenuEs?: Maybe<Scalars['String']>;
  voceMenuIt?: Maybe<Scalars['String']>;
  volantini: Array<VolantinoNode>;
  volantinoVisualizzato?: Maybe<VolantinoNode>;
  /** Name entity wikidata per schema categoria */
  wikidataName?: Maybe<Scalars['String']>;
  /** Url wikidata per schema categoria */
  wikidataUrl?: Maybe<Scalars['String']>;
};


export type CategoriaNodePagineArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tipologia?: InputMaybe<PagesPaginaTipologiaChoices>;
};

export type CategoriaNodeConnection = {
  __typename?: 'CategoriaNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoriaNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CategoriaNode` and its cursor. */
export type CategoriaNodeEdge = {
  __typename?: 'CategoriaNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CategoriaNode>;
};

export type CategoriaVideoTutorialNode = {
  __typename?: 'CategoriaVideoTutorialNode';
  adminUrl?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  videoTutorial: Array<VideoTutorialNode>;
};

export type CategoriaWarrantyNode = {
  __typename?: 'CategoriaWarrantyNode';
  nome?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum CategorieCategoriaRegolaAssociazioneMasterChoices {
  /** In promozione flash */
  FlashPromotion = 'FLASH_PROMOTION',
  /** In promozione (non flash) */
  Promotion = 'PROMOTION'
}

export type ChangeItemSize = {
  __typename?: 'ChangeItemSize';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CheckoutNode = {
  __typename?: 'CheckoutNode';
  indirizzoFatturazione?: Maybe<IndirizzoNode>;
  indirizzoSpedizione?: Maybe<IndirizzoNode>;
  items?: Maybe<Array<Maybe<RigaCheckoutNode>>>;
  prezzo?: Maybe<Scalars['Float']>;
  promoApplicata?: Maybe<PromozioneNode>;
  promoDipendenti?: Maybe<Scalars['Boolean']>;
  rivenditore?: Maybe<RivenditoreNode>;
  rivenditori?: Maybe<Array<Maybe<RivenditoreNode>>>;
  scontoAssoluto?: Maybe<Scalars['Float']>;
  scontoBundles?: Maybe<ScontoBundlesType>;
  scontoPercentuale?: Maybe<Scalars['Float']>;
  sistemaPagamento?: Maybe<SistemaPagamentoNode>;
  sistemaSpedizione?: Maybe<SistemaSpedizioneNode>;
  sistemiPagamento?: Maybe<Array<Maybe<GroupedSistemaPagamentoNode>>>;
  sistemiSpedizione?: Maybe<Array<Maybe<SistemaSpedizioneNode>>>;
  totaleProdottiScontato?: Maybe<Scalars['Float']>;
  totaleScontato?: Maybe<Scalars['Float']>;
  totaleScontatoNetto?: Maybe<Scalars['Float']>;
  totaleSenzaPromozioni?: Maybe<Scalars['Float']>;
};

export type CompatibilitaGruppoNode = {
  __typename?: 'CompatibilitaGruppoNode';
  image?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<CompatibilitaProdottoNode>>>;
};

export type CompatibilitaProdottoNode = {
  __typename?: 'CompatibilitaProdottoNode';
  compatibilita?: Maybe<Array<Maybe<Scalars['String']>>>;
  nome?: Maybe<Scalars['String']>;
  prodotti?: Maybe<Array<Maybe<Scalars['String']>>>;
  rif?: Maybe<Scalars['String']>;
};

export type CompleteSignIn = {
  __typename?: 'CompleteSignIn';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CreateAddress = {
  __typename?: 'CreateAddress';
  message?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CreateAddressInput = {
  cap: Scalars['String'];
  citta: Scalars['String'];
  cognome: Scalars['String'];
  indirizzo: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isFatturazione: Scalars['Boolean'];
  nome: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Scalars['Int']>;
  provincia: Scalars['String'];
  stato: Scalars['String'];
  telefono: Scalars['String'];
};

export type CreateAdesioneB2C = {
  __typename?: 'CreateAdesioneB2C';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CreateAdesioneB2CInput = {
  bonifico?: InputMaybe<Scalars['Boolean']>;
  bonificoAgenzia?: InputMaybe<Scalars['String']>;
  bonificoBanca?: InputMaybe<Scalars['String']>;
  bonificoIban?: InputMaybe<Scalars['String']>;
  cellulare: Scalars['String'];
  circuito: Scalars['String'];
  codice: Scalars['String'];
  cognome: Scalars['String'];
  concessione?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  nome: Scalars['String'];
  paypal?: InputMaybe<Scalars['Boolean']>;
  privacy?: InputMaybe<Scalars['Boolean']>;
  ragioneSociale?: InputMaybe<Scalars['String']>;
  setefi?: InputMaybe<Scalars['Boolean']>;
};

export type CreateContattoCustom = {
  __typename?: 'CreateContattoCustom';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CreateContattoInput = {
  azienda?: InputMaybe<Scalars['String']>;
  cap: Scalars['String'];
  cognome: Scalars['String'];
  comune: Scalars['String'];
  email: Scalars['String'];
  marketing?: InputMaybe<Scalars['Boolean']>;
  messaggio: Scalars['String'];
  motivo: Scalars['Int'];
  nazione: Scalars['Int'];
  nome: Scalars['String'];
  privacy: Scalars['Boolean'];
  provincia?: InputMaybe<Scalars['String']>;
  telefono: Scalars['String'];
};

export type CreateContattoManuale = {
  __typename?: 'CreateContattoManuale';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CreateContattoManualeInput = {
  cap: Scalars['String'];
  classi: Scalars['String'];
  cognome: Scalars['String'];
  comune: Scalars['String'];
  email: Scalars['String'];
  linee: Scalars['String'];
  lingua: Scalars['String'];
  marketing?: InputMaybe<Scalars['Boolean']>;
  nazione: Scalars['Int'];
  nome: Scalars['String'];
  privacy: Scalars['Boolean'];
  prodotto: Scalars['String'];
  provincia?: InputMaybe<Scalars['String']>;
  telefono: Scalars['String'];
  via: Scalars['String'];
};

export type CreateIndirizzo = {
  __typename?: 'CreateIndirizzo';
  indirizzo?: Maybe<IndirizzoNode>;
};

export type CreateUtente = {
  __typename?: 'CreateUtente';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  statusCode?: Maybe<Scalars['Int']>;
  utente?: Maybe<UtenteNode>;
};

/** Represents a single product row in the comparison table. */
export type DatiTecniciProdottoNode = {
  __typename?: 'DatiTecniciProdottoNode';
  prodotto?: Maybe<ProdottoNode>;
  valori?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DeleteUtente = {
  __typename?: 'DeleteUtente';
  message?: Maybe<Scalars['String']>;
};

export type DescrizioneAggiuntivaProdottoNode = {
  __typename?: 'DescrizioneAggiuntivaProdottoNode';
  id: Scalars['ID'];
  image?: Maybe<ImageNode>;
  imageLingua?: Maybe<ImageNode>;
  imageLinguaEn?: Maybe<ImageNode>;
  imageLinguaEnGb?: Maybe<ImageNode>;
  imageLinguaEs?: Maybe<ImageNode>;
  imageLinguaIt?: Maybe<ImageNode>;
  prodotto: ProdottoNode;
  testo?: Maybe<Scalars['String']>;
  testoEn?: Maybe<Scalars['String']>;
  testoEnGb?: Maybe<Scalars['String']>;
  testoEs?: Maybe<Scalars['String']>;
  testoIt?: Maybe<Scalars['String']>;
};

export type DocumentoNode = {
  __typename?: 'DocumentoNode';
  attivo: Scalars['Boolean'];
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  news: NewsNode;
  ordinamento: Scalars['Int'];
  pk?: Maybe<Scalars['Int']>;
  titolo?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEnGb?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type DocumentoProdottoNode = {
  __typename?: 'DocumentoProdottoNode';
  attivo: Scalars['Boolean'];
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lingua: Array<LinguaDocumentoProdottoNode>;
  lingue?: Maybe<Array<Maybe<LinguaDocumentoProdottoNode>>>;
  master: Array<MasterProdottoDocumentiNode>;
  modified?: Maybe<Scalars['DateTime']>;
  nomeDocumento?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  pk?: Maybe<Scalars['Int']>;
  prodotto: Array<ProdottoNode>;
  /** Un titolo che potrebbe venir mostrato in scheda prodotto */
  titolo?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FamigliaSistemaPagamentoNode = {
  __typename?: 'FamigliaSistemaPagamentoNode';
  alias?: Maybe<Scalars['String']>;
  chiave?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  ordine: Scalars['Int'];
  pk?: Maybe<Scalars['Int']>;
  sistemiPagamento: Array<SistemaPagamentoNode>;
};

export type FeedbackMutation = {
  __typename?: 'FeedbackMutation';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type GroupedSistemaPagamentoNode = {
  __typename?: 'GroupedSistemaPagamentoNode';
  children?: Maybe<Array<Maybe<SistemaPagamentoNode>>>;
  descrizione?: Maybe<Scalars['String']>;
  famiglia?: Maybe<FamigliaSistemaPagamentoNode>;
  pk?: Maybe<Scalars['Int']>;
  rivenditore?: Maybe<RivenditoreNode>;
};

export type HrefLangType = {
  __typename?: 'HrefLangType';
  href?: Maybe<Scalars['String']>;
  hrefLang?: Maybe<Scalars['String']>;
};

export type ImageNode = {
  __typename?: 'ImageNode';
  FileSize?: Maybe<Scalars['BigInt']>;
  Height?: Maybe<Scalars['Float']>;
  Transparent: Scalars['Boolean'];
  Width?: Maybe<Scalars['Float']>;
  alt?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  dateTaken?: Maybe<Scalars['DateTime']>;
  defaultAltText?: Maybe<Scalars['String']>;
  defaultCaption?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descrizioniAggiuntive: Array<DescrizioneAggiuntivaProdottoNode>;
  descrizioniAggiuntiveAsInLingua: Array<DescrizioneAggiuntivaProdottoNode>;
  descrizioniAggiuntiveAsInLinguaEn: Array<DescrizioneAggiuntivaProdottoNode>;
  descrizioniAggiuntiveAsInLinguaEnGb: Array<DescrizioneAggiuntivaProdottoNode>;
  descrizioniAggiuntiveAsInLinguaEs: Array<DescrizioneAggiuntivaProdottoNode>;
  descrizioniAggiuntiveAsInLinguaIt: Array<DescrizioneAggiuntivaProdottoNode>;
  file?: Maybe<Scalars['String']>;
  hasAllMandatoryData: Scalars['Boolean'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Disabilita ogni controllo dei permessi per questo file. Il file sarà accessibile da chiunque */
  isPublic: Scalars['Boolean'];
  /** MIME type of uploaded content */
  mimeType: Scalars['String'];
  modifiedAt: Scalars['DateTime'];
  mustAlwaysPublishAuthorCredit: Scalars['Boolean'];
  mustAlwaysPublishCopyright: Scalars['Boolean'];
  name: Scalars['String'];
  offertamarketingbox: Array<OffertaMarketingBoxNode>;
  originalFilename?: Maybe<Scalars['String']>;
  owner?: Maybe<UtenteNode>;
  pagina: PaginaNodeConnection;
  paginaPreviews: PaginaNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  pluspointSet: Array<PlusPointNode>;
  popup: Array<PopupNode>;
  popupMobile: Array<PopupNode>;
  sha1: Scalars['String'];
  sistemiPagamento: Array<SistemaPagamentoNode>;
  subjectLocation: Scalars['String'];
  uploadedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  valoriAttributi: Array<ValoreAttributoNode>;
  videonews: Array<VideoNewsNode>;
  volantiniImmagini: Array<VolantinoNode>;
  volantino: Array<VolantinoNode>;
  volantinoPreviews: Array<VolantinoNode>;
  width?: Maybe<Scalars['Int']>;
};


export type ImageNodePaginaArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tipologia?: InputMaybe<PagesPaginaTipologiaChoices>;
};


export type ImageNodePaginaPreviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tipologia?: InputMaybe<PagesPaginaTipologiaChoices>;
};

export type ImmagineProdottoType = {
  __typename?: 'ImmagineProdottoType';
  descrizione?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
};

export type IndirizzoInput = {
  cap: Scalars['String'];
  citta: Scalars['String'];
  cognome: Scalars['String'];
  indirizzo: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isFatturazione: Scalars['Boolean'];
  nazione: Scalars['Int'];
  nome: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  provincia: Scalars['String'];
  telefono: Scalars['String'];
};

export type IndirizzoNode = {
  __typename?: 'IndirizzoNode';
  cancellato: Scalars['Boolean'];
  cap?: Maybe<Scalars['String']>;
  citta?: Maybe<Scalars['String']>;
  cognome?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  frazione?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idOld?: Maybe<Scalars['Float']>;
  indirizzo?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  isFatturazione: Scalars['Boolean'];
  modified?: Maybe<Scalars['DateTime']>;
  nazione: NazioneNode;
  nome?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  numeroCivico?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  presso?: Maybe<Scalars['String']>;
  provincia?: Maybe<Scalars['String']>;
  ragioneSociale?: Maybe<Scalars['String']>;
  telefono?: Maybe<Scalars['String']>;
  telefono2?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  utente: UtenteNode;
};

export type InteresseNewsletterNode = {
  __typename?: 'InteresseNewsletterNode';
  alias?: Maybe<Scalars['String']>;
  /** Categoria relativa all' interesse */
  categoria: NewsletterInteresseNewsletterCategoriaChoices;
  descrizione?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mailchimpInterestId?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  pk?: Maybe<Scalars['Int']>;
  utenti: UtenteNodeConnection;
};


export type InteresseNewsletterNodeUtentiArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type LandingNewsletterInput = {
  captcha: Scalars['String'];
  cognome?: InputMaybe<Scalars['String']>;
  consensoProfilazione?: InputMaybe<Scalars['Boolean']>;
  dataDiNascita?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  interessi?: InputMaybe<Scalars['String']>;
  landing?: InputMaybe<Scalars['String']>;
  nome?: InputMaybe<Scalars['String']>;
  privato?: InputMaybe<Scalars['Boolean']>;
};

export type LandingNewsletterSubscription = {
  __typename?: 'LandingNewsletterSubscription';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type LinguaDocumentoProdottoNode = {
  __typename?: 'LinguaDocumentoProdottoNode';
  /** Un titolo che potrebbe venir mostrato in scheda prodotto */
  codice?: Maybe<Scalars['String']>;
  documenti: Array<DocumentoProdottoNode>;
  id: Scalars['ID'];
  ordinamento: Scalars['Int'];
  titolo?: Maybe<Scalars['String']>;
};

export type ListingNewsEmakInformaNode = {
  __typename?: 'ListingNewsEmakInformaNode';
  news?: Maybe<Array<Maybe<NewsEmakInformaNode>>>;
  paginator?: Maybe<NewsPaginatorNode>;
  root?: Maybe<PaginaNode>;
};

export type ListingNewsNode = {
  __typename?: 'ListingNewsNode';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoria?: Maybe<CategoriaNewsNode>;
  categorie?: Maybe<Array<Maybe<CategoriaNewsNode>>>;
  news?: Maybe<Array<Maybe<NewsNode>>>;
  paginator?: Maybe<NewsPaginatorNode>;
  root?: Maybe<PaginaNode>;
};

export type ListingVideoTutorialNode = {
  __typename?: 'ListingVideoTutorialNode';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoria?: Maybe<CategoriaVideoTutorialNode>;
  categorie?: Maybe<Array<Maybe<CategoriaVideoTutorialNode>>>;
  paginator?: Maybe<NewsPaginatorNode>;
  root?: Maybe<PaginaNode>;
  videos?: Maybe<Array<Maybe<VideoTutorialNode>>>;
};

export type Logout = {
  __typename?: 'Logout';
  status?: Maybe<Scalars['Boolean']>;
};

export type MasterProdottoDocumentiNode = {
  __typename?: 'MasterProdottoDocumentiNode';
  alias?: Maybe<Scalars['String']>;
  attivo: Scalars['Boolean'];
  categoriaSet: CategoriaNodeConnection;
  categorie: CategoriaNodeConnection;
  categorieAsStaticizzati: CategoriaNodeConnection;
  categorieCorrelate: CategoriaNodeConnection;
  categorieOfferta: CategoriaNodeConnection;
  codice: Scalars['String'];
  created?: Maybe<Scalars['DateTime']>;
  documenti?: Maybe<Array<Maybe<DocumentoProdottoNode>>>;
  id: Scalars['ID'];
  masterCorrelati: Array<MasterProdottoDocumentiNode>;
  masterprodottoSet: Array<MasterProdottoDocumentiNode>;
  modified?: Maybe<Scalars['DateTime']>;
  /** Indica se il prodotto ha una nota allegata */
  notaRuote: Scalars['Boolean'];
  ordinamento: Scalars['Int'];
  pk?: Maybe<Scalars['Int']>;
  prodotti: Array<ProdottoNode>;
};


export type MasterProdottoDocumentiNodeCategoriaSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inHome?: InputMaybe<Scalars['Boolean']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  soloConMastersConDocumenti?: InputMaybe<Scalars['Boolean']>;
};


export type MasterProdottoDocumentiNodeCategorieArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inHome?: InputMaybe<Scalars['Boolean']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  soloConMastersConDocumenti?: InputMaybe<Scalars['Boolean']>;
};


export type MasterProdottoDocumentiNodeCategorieAsStaticizzatiArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inHome?: InputMaybe<Scalars['Boolean']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  soloConMastersConDocumenti?: InputMaybe<Scalars['Boolean']>;
};


export type MasterProdottoDocumentiNodeCategorieCorrelateArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inHome?: InputMaybe<Scalars['Boolean']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  soloConMastersConDocumenti?: InputMaybe<Scalars['Boolean']>;
};


export type MasterProdottoDocumentiNodeCategorieOffertaArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inHome?: InputMaybe<Scalars['Boolean']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  soloConMastersConDocumenti?: InputMaybe<Scalars['Boolean']>;
};

export type MotivazioneContattoCustomNode = {
  __typename?: 'MotivazioneContattoCustomNode';
  alias: Scalars['String'];
  chiave?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  emailDestinatario: Scalars['String'];
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  nomeDestinatario?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  ordine: Scalars['Int'];
  pk?: Maybe<Scalars['Int']>;
};

export type MotivazioneResoNode = {
  __typename?: 'MotivazioneResoNode';
  alias: Scalars['String'];
  chiave?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
};

export type MotivazioniNazioniNode = {
  __typename?: 'MotivazioniNazioniNode';
  motivazioniContattoCustom?: Maybe<Array<Maybe<MotivazioneContattoCustomNode>>>;
  nazioni?: Maybe<Array<Maybe<NazioneNode>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addItem?: Maybe<AddItem>;
  addWishlistItem?: Maybe<AddWishlistItem>;
  changeItemSize?: Maybe<ChangeItemSize>;
  completeSignIn?: Maybe<CompleteSignIn>;
  createAddress?: Maybe<CreateAddress>;
  createAdesioneB2c?: Maybe<CreateAdesioneB2C>;
  createContattoCustom?: Maybe<CreateContattoCustom>;
  createContattoManuale?: Maybe<CreateContattoManuale>;
  createIndirizzo?: Maybe<CreateIndirizzo>;
  createUtente?: Maybe<CreateUtente>;
  deleteUtente?: Maybe<DeleteUtente>;
  feedback?: Maybe<FeedbackMutation>;
  landingNewsletterSubscription?: Maybe<LandingNewsletterSubscription>;
  logout?: Maybe<Logout>;
  myAccountChangePassword?: Maybe<MyAccountChangePassword>;
  myAccountDeleteIndirizzo?: Maybe<MyAccountDeleteIndirizzo>;
  myAccountEdit?: Maybe<MyAccountEdit>;
  myAccountSetIndirizzoDefault?: Maybe<MyAccountSetIndirizzoDefault>;
  newsletterSubscription?: Maybe<NewsletterSubscription>;
  recuperaPassword?: Maybe<RecuperaPassword>;
  removeItem?: Maybe<RemoveItem>;
  removePromoCode?: Maybe<RemovePromoCode>;
  removeWishlistItem?: Maybe<RemoveWishlistItem>;
  resetPassword?: Maybe<ResetPassword>;
  richiediReso?: Maybe<RichiediReso>;
  setCheckout?: Maybe<SetCheckout>;
  setIndirizzi?: Maybe<SetIndirizzi>;
  setModalitaSpedizione?: Maybe<SetModalitaSpedizione>;
  setPromoCode?: Maybe<SetPromoCode>;
  setSistemaPagamento?: Maybe<SetSistemaPagamento>;
  socialAuth?: Maybe<SocialAuthMutation>;
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  validaCodicePostale?: Maybe<ValidaCodicePostale>;
  validaIndirizzo?: Maybe<ValidaIndirizzo>;
};


export type MutationAddItemArgs = {
  idProdotto?: InputMaybe<Scalars['Int']>;
  quantita?: InputMaybe<Scalars['Int']>;
};


export type MutationAddWishlistItemArgs = {
  idProdotto?: InputMaybe<Scalars['Int']>;
};


export type MutationChangeItemSizeArgs = {
  idProdottoNew?: InputMaybe<Scalars['Int']>;
  idProdottoOld?: InputMaybe<Scalars['Int']>;
  omaggio?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCompleteSignInArgs = {
  ambienteLavoro?: InputMaybe<Scalars['Int']>;
  birthdate?: InputMaybe<Scalars['String']>;
  professionista?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateAddressArgs = {
  address: CreateAddressInput;
};


export type MutationCreateAdesioneB2cArgs = {
  adesioneInput: CreateAdesioneB2CInput;
};


export type MutationCreateContattoCustomArgs = {
  contattoInput: CreateContattoInput;
};


export type MutationCreateContattoManualeArgs = {
  contattoInput: CreateContattoManualeInput;
};


export type MutationCreateIndirizzoArgs = {
  input: IndirizzoInput;
};


export type MutationCreateUtenteArgs = {
  input: SignInInput;
};


export type MutationFeedbackArgs = {
  idRisposta: Scalars['ID'];
  utile: Scalars['Boolean'];
};


export type MutationLandingNewsletterSubscriptionArgs = {
  input: LandingNewsletterInput;
};


export type MutationMyAccountChangePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationMyAccountDeleteIndirizzoArgs = {
  pk?: InputMaybe<Scalars['Int']>;
};


export type MutationMyAccountEditArgs = {
  input: UtenteInput;
};


export type MutationMyAccountSetIndirizzoDefaultArgs = {
  pk?: InputMaybe<Scalars['Int']>;
};


export type MutationNewsletterSubscriptionArgs = {
  email: Scalars['String'];
};


export type MutationRecuperaPasswordArgs = {
  email: Scalars['String'];
};


export type MutationRemoveItemArgs = {
  idProdotto?: InputMaybe<Scalars['Int']>;
  omaggio?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveWishlistItemArgs = {
  idProdotto?: InputMaybe<Scalars['Int']>;
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationRichiediResoArgs = {
  richiestaReso: RichiediResoInput;
};


export type MutationSetCheckoutArgs = {
  idRivenditore: Scalars['Int'];
  idSistemaPagamento: Scalars['Int'];
};


export type MutationSetIndirizziArgs = {
  indirizzoFatturazione?: InputMaybe<Scalars['Int']>;
  indirizzoSpedizione?: InputMaybe<Scalars['Int']>;
  same?: InputMaybe<Scalars['Boolean']>;
  spedizione?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetModalitaSpedizioneArgs = {
  idModalitaSpedizione?: InputMaybe<Scalars['Int']>;
  idRivenditore?: InputMaybe<Scalars['Int']>;
};


export type MutationSetPromoCodeArgs = {
  promoCode?: InputMaybe<Scalars['String']>;
};


export type MutationSetSistemaPagamentoArgs = {
  idSistemaPagamento?: InputMaybe<Scalars['Int']>;
};


export type MutationSocialAuthArgs = {
  accessToken: Scalars['String'];
  provider: Scalars['String'];
};


export type MutationTokenAuthArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationValidaCodicePostaleArgs = {
  carrierCode: Scalars['String'];
  countryCode: Scalars['String'];
  postalCode: Scalars['String'];
  stateCode: Scalars['String'];
};


export type MutationValidaIndirizzoArgs = {
  address: ValidaIndirizzoInput;
};

export type MyAccountChangePassword = {
  __typename?: 'MyAccountChangePassword';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type MyAccountDeleteIndirizzo = {
  __typename?: 'MyAccountDeleteIndirizzo';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type MyAccountEdit = {
  __typename?: 'MyAccountEdit';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type MyAccountSetIndirizzoDefault = {
  __typename?: 'MyAccountSetIndirizzoDefault';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type NazioneNode = {
  __typename?: 'NazioneNode';
  alias: Scalars['String'];
  attiva: Scalars['Boolean'];
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  indirizzi: Array<IndirizzoNode>;
  isoCode: Scalars['String'];
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
};

export type NewsEmakInformaNode = {
  __typename?: 'NewsEmakInformaNode';
  adminUrl?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrl?: Maybe<Scalars['String']>;
  correlati?: Maybe<Array<Maybe<NewsEmakInformaNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Date']>;
  dataOraPubblicazione: Scalars['DateTime'];
  id: Scalars['ID'];
  inListing: Scalars['Boolean'];
  isExportable: Scalars['Boolean'];
  mainImage?: Maybe<Scalars['String']>;
  messaggio?: Maybe<Scalars['String']>;
  messaggioEn?: Maybe<Scalars['String']>;
  messaggioEnGb?: Maybe<Scalars['String']>;
  messaggioEs?: Maybe<Scalars['String']>;
  messaggioIt?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  noindex: Scalars['Boolean'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEnGb?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoH1?: Maybe<Scalars['String']>;
  seoH1En?: Maybe<Scalars['String']>;
  seoH1EnGb?: Maybe<Scalars['String']>;
  seoH1Es?: Maybe<Scalars['String']>;
  seoH1It?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEnGb?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  sottotitolo?: Maybe<Scalars['String']>;
  sottotitoloEn?: Maybe<Scalars['String']>;
  sottotitoloEnGb?: Maybe<Scalars['String']>;
  sottotitoloEs?: Maybe<Scalars['String']>;
  sottotitoloIt?: Maybe<Scalars['String']>;
  sottotitoloListing?: Maybe<Scalars['String']>;
  sottotitoloListingEn?: Maybe<Scalars['String']>;
  sottotitoloListingEnGb?: Maybe<Scalars['String']>;
  sottotitoloListingEs?: Maybe<Scalars['String']>;
  sottotitoloListingIt?: Maybe<Scalars['String']>;
  tempoLettura: Scalars['BigInt'];
  testo?: Maybe<Scalars['String']>;
  testoEn?: Maybe<Scalars['String']>;
  testoEnGb?: Maybe<Scalars['String']>;
  testoEs?: Maybe<Scalars['String']>;
  testoIt?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEnGb?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  titoloListing?: Maybe<Scalars['String']>;
  titoloListingEn?: Maybe<Scalars['String']>;
  titoloListingEnGb?: Maybe<Scalars['String']>;
  titoloListingEs?: Maybe<Scalars['String']>;
  titoloListingIt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type NewsNode = {
  __typename?: 'NewsNode';
  adminUrl?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrl?: Maybe<Scalars['String']>;
  categoria?: Maybe<CategoriaNewsNode>;
  categorie: Array<CategoriaNewsNode>;
  contenutoIndicizzabile?: Maybe<Scalars['String']>;
  correlati?: Maybe<Array<Maybe<NewsNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Date']>;
  dataOraPubblicazione: Scalars['DateTime'];
  documenti: Array<DocumentoNode>;
  documentiVisibili?: Maybe<Array<Maybe<DocumentoNode>>>;
  evisionId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  inListing: Scalars['Boolean'];
  isExportable: Scalars['Boolean'];
  listingVideos?: Maybe<VideoNewsNode>;
  mainImage?: Maybe<Scalars['String']>;
  messaggio?: Maybe<Scalars['String']>;
  messaggioEn?: Maybe<Scalars['String']>;
  messaggioEnGb?: Maybe<Scalars['String']>;
  messaggioEs?: Maybe<Scalars['String']>;
  messaggioIt?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  noindex: Scalars['Boolean'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEnGb?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoH1?: Maybe<Scalars['String']>;
  seoH1En?: Maybe<Scalars['String']>;
  seoH1EnGb?: Maybe<Scalars['String']>;
  seoH1Es?: Maybe<Scalars['String']>;
  seoH1It?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEnGb?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  sottotitolo?: Maybe<Scalars['String']>;
  sottotitoloEn?: Maybe<Scalars['String']>;
  sottotitoloEnGb?: Maybe<Scalars['String']>;
  sottotitoloEs?: Maybe<Scalars['String']>;
  sottotitoloIt?: Maybe<Scalars['String']>;
  sottotitoloListing?: Maybe<Scalars['String']>;
  sottotitoloListingEn?: Maybe<Scalars['String']>;
  sottotitoloListingEnGb?: Maybe<Scalars['String']>;
  sottotitoloListingEs?: Maybe<Scalars['String']>;
  sottotitoloListingIt?: Maybe<Scalars['String']>;
  tempoLettura: Scalars['BigInt'];
  testo?: Maybe<Scalars['String']>;
  testoEn?: Maybe<Scalars['String']>;
  testoEnGb?: Maybe<Scalars['String']>;
  testoEs?: Maybe<Scalars['String']>;
  testoIt?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEnGb?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  titoloListing?: Maybe<Scalars['String']>;
  titoloListingEn?: Maybe<Scalars['String']>;
  titoloListingEnGb?: Maybe<Scalars['String']>;
  titoloListingEs?: Maybe<Scalars['String']>;
  titoloListingIt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  video: Array<VideoNewsNode>;
};

export type NewsPaginatorNode = {
  __typename?: 'NewsPaginatorNode';
  count?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
  itemsPerPage?: Maybe<Scalars['Int']>;
  numPages?: Maybe<Scalars['Int']>;
  pages?: Maybe<Array<Maybe<PageNode>>>;
};

/** An enumeration. */
export enum NewsletterInteresseNewsletterCategoriaChoices {
  /** Ambiente di lavoro */
  Ambiente = 'AMBIENTE',
  /** Ambiente di lavoro giardinaggio */
  AmbienteGiardinaggio = 'AMBIENTE_GIARDINAGGIO',
  /** Attività di interesse */
  Attivita = 'ATTIVITA'
}

export type NewsletterSubscription = {
  __typename?: 'NewsletterSubscription';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

export type ObtainJsonWebToken = {
  __typename?: 'ObtainJSONWebToken';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  user?: Maybe<UtenteNode>;
};

export type OffertaMarketingBoxNode = {
  __typename?: 'OffertaMarketingBoxNode';
  categoriaSet: CategoriaNodeConnection;
  ctaLabel?: Maybe<Scalars['String']>;
  ctaLabelEn?: Maybe<Scalars['String']>;
  ctaLabelEnGb?: Maybe<Scalars['String']>;
  ctaLabelEs?: Maybe<Scalars['String']>;
  ctaLabelIt?: Maybe<Scalars['String']>;
  /** Tooltip */
  helper?: Maybe<Scalars['String']>;
  /** Tooltip */
  helperEn?: Maybe<Scalars['String']>;
  /** Tooltip */
  helperEnGb?: Maybe<Scalars['String']>;
  /** Tooltip */
  helperEs?: Maybe<Scalars['String']>;
  /** Tooltip */
  helperIt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageSolo: Scalars['Boolean'];
  intro?: Maybe<Scalars['String']>;
  introEn?: Maybe<Scalars['String']>;
  introEnGb?: Maybe<Scalars['String']>;
  introEs?: Maybe<Scalars['String']>;
  introIt?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  prezzo?: Maybe<Scalars['Int']>;
  prezzoScontato?: Maybe<Scalars['Int']>;
  sottotitolo?: Maybe<Scalars['String']>;
  testo?: Maybe<Scalars['String']>;
  testoEn?: Maybe<Scalars['String']>;
  testoEnGb?: Maybe<Scalars['String']>;
  testoEs?: Maybe<Scalars['String']>;
  testoIt?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEnGb?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  visibileDal?: Maybe<Scalars['DateTime']>;
  visibileFinoal?: Maybe<Scalars['DateTime']>;
};


export type OffertaMarketingBoxNodeCategoriaSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inHome?: InputMaybe<Scalars['Boolean']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  soloConMastersConDocumenti?: InputMaybe<Scalars['Boolean']>;
};

export type OrdineNode = Node & {
  __typename?: 'OrdineNode';
  aliasScontoBundles?: Maybe<Scalars['String']>;
  cf?: Maybe<Scalars['String']>;
  codice?: Maybe<Scalars['String']>;
  cognome?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['String']>;
  dataFattura?: Maybe<Scalars['Date']>;
  dataRicevuta?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  fatturaRichiesta: Scalars['Boolean'];
  giacenzaScalata: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  importoTasseSulTotaleScontato: Scalars['Float'];
  includiMessaggio: Scalars['Boolean'];
  indirizzoFatturazione?: Maybe<IndirizzoNode>;
  indirizzoSpedizione?: Maybe<IndirizzoNode>;
  marginalita: Scalars['Float'];
  messaggio?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  noteConsegna?: Maybe<Scalars['String']>;
  numeroFattura?: Maybe<Scalars['Int']>;
  numeroOdv?: Maybe<Scalars['String']>;
  numeroRicevuta?: Maybe<Scalars['Int']>;
  pagina?: Maybe<PaginaNode>;
  paymentId?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
  percentualeTassazione: Scalars['Float'];
  peso?: Maybe<Scalars['Float']>;
  piva?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  prezzoTotale?: Maybe<Scalars['Float']>;
  prezzoTotaleScontato: Scalars['Float'];
  prezzoTotaleScontatoNetto: Scalars['Float'];
  privato: Scalars['Boolean'];
  promoCode?: Maybe<Scalars['String']>;
  promozione?: Maybe<PromozioneNode>;
  promozioneValoreAssoluto: Scalars['Float'];
  promozioneValorePercentuale: Scalars['Float'];
  ragioneSociale?: Maybe<Scalars['String']>;
  rendibile?: Maybe<Scalars['Boolean']>;
  righeOrdine?: Maybe<Array<Maybe<RigaOrdineNode>>>;
  rivenditore?: Maybe<RivenditoreNode>;
  scontoBundles: Scalars['Float'];
  sdi?: Maybe<Scalars['String']>;
  securitytoken?: Maybe<Scalars['String']>;
  sistemaPagamento?: Maybe<SistemaPagamentoNode>;
  sistemaSpedizione?: Maybe<SistemaSpedizioneNode>;
  stato: StatoNode;
  trackingUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  utente?: Maybe<UtenteNode>;
  valuta: ValutaNode;
};

export type OrdineNodeConnection = {
  __typename?: 'OrdineNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrdineNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrdineNode` and its cursor. */
export type OrdineNodeEdge = {
  __typename?: 'OrdineNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrdineNode>;
};

/** An enumeration. */
export enum OrdiniRigaOrdineTipologiaChoices {
  /** prodotto */
  Prodotto = 'PRODOTTO',
  /** spedizione */
  Spedizione = 'SPEDIZIONE'
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PageNode = {
  __typename?: 'PageNode';
  href?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['String']>;
};

export type PagebuilderPlaceholderNode = {
  __typename?: 'PagebuilderPlaceholderNode';
  created?: Maybe<Scalars['DateTime']>;
  draft: Scalars['Boolean'];
  id: Scalars['ID'];
  jsonDraft?: Maybe<Scalars['String']>;
  jsonPublished?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  lang?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  objectId?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PagesPaginaStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

/** An enumeration. */
export enum PagesPaginaTipologiaChoices {
  /** Pagina */
  Page = 'PAGE',
  /** Pagina applicazione */
  PageApp = 'PAGE_APP',
  /** Pagine Entità */
  PageAppMany = 'PAGE_APP_MANY'
}

export type PaginaNode = Node & {
  __typename?: 'PaginaNode';
  adminUrl?: Maybe<Scalars['String']>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlEn?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlEnGb?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlEs?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlIt?: Maybe<Scalars['String']>;
  categorie?: Maybe<Array<Maybe<CategoriaNode>>>;
  categorieLanding?: Maybe<Array<Maybe<CategoriaNode>>>;
  chiave?: Maybe<Scalars['String']>;
  chiaveMenu?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<PaginaNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  ctaLabel?: Maybe<Scalars['String']>;
  ctaLabelEn?: Maybe<Scalars['String']>;
  ctaLabelEnGb?: Maybe<Scalars['String']>;
  ctaLabelEs?: Maybe<Scalars['String']>;
  ctaLabelIt?: Maybe<Scalars['String']>;
  ctaUrl?: Maybe<Scalars['String']>;
  ctaUrlEn?: Maybe<Scalars['String']>;
  ctaUrlEnGb?: Maybe<Scalars['String']>;
  ctaUrlEs?: Maybe<Scalars['String']>;
  ctaUrlIt?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  hreflangs?: Maybe<Array<Maybe<HrefLangType>>>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  inRicerca: Scalars['Boolean'];
  inSitemap: Scalars['Boolean'];
  intro?: Maybe<Scalars['String']>;
  introEn?: Maybe<Scalars['String']>;
  introEnGb?: Maybe<Scalars['String']>;
  introEs?: Maybe<Scalars['String']>;
  introIt?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  migrata: Scalars['Boolean'];
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modificaUrl?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  noindex: Scalars['Boolean'];
  noindexEn: Scalars['Boolean'];
  noindexEnGb: Scalars['Boolean'];
  noindexEs: Scalars['Boolean'];
  noindexIt: Scalars['Boolean'];
  /** Visibile nelle breadcrumbs */
  nome?: Maybe<Scalars['String']>;
  /** Visibile nelle breadcrumbs */
  nomeEn?: Maybe<Scalars['String']>;
  /** Visibile nelle breadcrumbs */
  nomeEnGb?: Maybe<Scalars['String']>;
  /** Visibile nelle breadcrumbs */
  nomeEs?: Maybe<Scalars['String']>;
  /** Visibile nelle breadcrumbs */
  nomeIt?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  parent?: Maybe<PaginaNode>;
  path?: Maybe<Scalars['String']>;
  pathEn?: Maybe<Scalars['String']>;
  pathEnGb?: Maybe<Scalars['String']>;
  pathEs?: Maybe<Scalars['String']>;
  pathIt?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  prodotti: Array<ProdottoNode>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  seo?: Maybe<SeoType>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEnGb?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoH1?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEnGb?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  siblings?: Maybe<Array<Maybe<PaginaNode>>>;
  slug?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  statoPubblicazione: PagesPaginaStatoPubblicazioneChoices;
  template?: Maybe<Scalars['String']>;
  /** Usato per le pagine migrate */
  testo?: Maybe<Scalars['String']>;
  tipologia: PagesPaginaTipologiaChoices;
  titolo: Scalars['String'];
  titoloEn?: Maybe<Scalars['String']>;
  titoloEnGb?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
};

export type PaginaNodeConnection = {
  __typename?: 'PaginaNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaginaNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PaginaNode` and its cursor. */
export type PaginaNodeEdge = {
  __typename?: 'PaginaNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PaginaNode>;
};

export type PlusPointNode = {
  __typename?: 'PlusPointNode';
  categoria?: Maybe<CategoriaNode>;
  descrizione: Scalars['String'];
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  immagine?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  pk?: Maybe<Scalars['Int']>;
  prodotto?: Maybe<ProdottoNode>;
  titolo?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEnGb?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
};

export type PopupNode = {
  __typename?: 'PopupNode';
  ctaLabel1?: Maybe<Scalars['String']>;
  ctaLabel1En?: Maybe<Scalars['String']>;
  ctaLabel1EnGb?: Maybe<Scalars['String']>;
  ctaLabel1Es?: Maybe<Scalars['String']>;
  ctaLabel1It?: Maybe<Scalars['String']>;
  ctaLabel2?: Maybe<Scalars['String']>;
  ctaLabel2En?: Maybe<Scalars['String']>;
  ctaLabel2EnGb?: Maybe<Scalars['String']>;
  ctaLabel2Es?: Maybe<Scalars['String']>;
  ctaLabel2It?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  linkedObjectId1?: Maybe<Scalars['Int']>;
  linkedObjectId2?: Maybe<Scalars['Int']>;
  mobileImage?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  titolo?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEnGb?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  url1?: Maybe<Scalars['String']>;
  url2?: Maybe<Scalars['String']>;
  /** Data e ora fino a quando sarà visibile (non obbligatorio) */
  visibilitaAl?: Maybe<Scalars['DateTime']>;
  /** Data e ora da quando sarà visibile (non obbligatorio) */
  visibilitaDal?: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export enum ProdottiStatoProdottoAzioneChoices {
  /** 200 */
  A_200 = 'A_200',
  /** 301 */
  A_301 = 'A_301',
  /** 404 */
  A_404 = 'A_404'
}

export type ProdottoNode = {
  __typename?: 'ProdottoNode';
  accessoriCorrelati: Array<ProdottoNode>;
  adminUrl?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  associati: Array<ProdottoNode>;
  attributi?: Maybe<Array<Maybe<AttributoMultiploType>>>;
  boughtTogether?: Maybe<Array<Maybe<ProdottoNode>>>;
  bundle: Scalars['Boolean'];
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlEn?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlEnGb?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlEs?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrlIt?: Maybe<Scalars['String']>;
  categoria?: Maybe<CategoriaNode>;
  categoriaCompatibili?: Maybe<CategoriaNode>;
  categorieCorrelate?: Maybe<Array<Maybe<CategoriaNode>>>;
  codice?: Maybe<Scalars['String']>;
  costoSpedizioneVolume: Scalars['Float'];
  created?: Maybe<Scalars['DateTime']>;
  defaultMaster: Scalars['Boolean'];
  descrizione?: Maybe<Scalars['String']>;
  descrizioneBreve?: Maybe<Scalars['String']>;
  descrizioneBreveEn?: Maybe<Scalars['String']>;
  descrizioneBreveEnGb?: Maybe<Scalars['String']>;
  descrizioneBreveEs?: Maybe<Scalars['String']>;
  descrizioneBreveIt?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioniAggiuntive: Array<DescrizioneAggiuntivaProdottoNode>;
  detailImages?: Maybe<Array<Maybe<ImmagineProdottoType>>>;
  details?: Maybe<Array<Maybe<Scalars['String']>>>;
  disponibile?: Maybe<Scalars['Boolean']>;
  documenti?: Maybe<Array<Maybe<DocumentoProdottoNode>>>;
  ecotassa: Scalars['Float'];
  id: Scalars['ID'];
  inPromoBundle?: Maybe<Scalars['Boolean']>;
  isAbbigliamento?: Maybe<Scalars['Boolean']>;
  isAccessorio?: Maybe<Scalars['Boolean']>;
  isLubrificante?: Maybe<Scalars['Boolean']>;
  isPwDouble: Scalars['Boolean'];
  labelTendina?: Maybe<Scalars['String']>;
  lancio: Scalars['Boolean'];
  linkVideo?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  master: MasterProdottoDocumentiNode;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  /** Visualizza nei listing e in scheda prodotto quando manca alla scadenza della promozione. */
  mostraCounter: Scalars['Boolean'];
  noindex: Scalars['Boolean'];
  noindexEn: Scalars['Boolean'];
  noindexEnGb: Scalars['Boolean'];
  noindexEs: Scalars['Boolean'];
  noindexIt: Scalars['Boolean'];
  nome: Scalars['String'];
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  notaRuote?: Maybe<Scalars['Boolean']>;
  novita?: Maybe<Scalars['Boolean']>;
  ordinamento: Scalars['Int'];
  ordinamentoTopDelMese: Scalars['Int'];
  pagina?: Maybe<PaginaNode>;
  pagine: PaginaNodeConnection;
  /** Peso espresso in KG */
  peso?: Maybe<Scalars['Float']>;
  pk?: Maybe<Scalars['Int']>;
  plusPoints?: Maybe<Array<Maybe<PlusPointNode>>>;
  previewImage?: Maybe<Scalars['String']>;
  prezzo?: Maybe<Scalars['Float']>;
  prezzoOmnibus?: Maybe<Scalars['Float']>;
  prezzoScontato?: Maybe<Scalars['Float']>;
  prezzoSellin?: Maybe<Scalars['Float']>;
  prezzoUnitario?: Maybe<Scalars['Float']>;
  prezzoUnitarioScontato?: Maybe<Scalars['Float']>;
  prodottiAssociati: Array<ProdottoNode>;
  prodottiCompatibili?: Maybe<Array<Maybe<ProdottoNode>>>;
  prodottiCorrelati: Array<ProdottoNode>;
  prodottiTendina?: Maybe<Array<Maybe<ProdottoNode>>>;
  promo?: Maybe<Scalars['Boolean']>;
  promoApplicata?: Maybe<PromozioneNode>;
  promoBundle?: Maybe<PromozioneNode>;
  promozioni: Array<PromozioneNode>;
  promozioniAbbinate: Array<PromozioneNode>;
  promozioniNegative: Array<PromozioneNode>;
  rating: Scalars['Float'];
  rif?: Maybe<Scalars['String']>;
  righeWishlist: Array<RigaWishlistNode>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEnGb?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoH1?: Maybe<Scalars['String']>;
  seoH1En?: Maybe<Scalars['String']>;
  seoH1EnGb?: Maybe<Scalars['String']>;
  seoH1Es?: Maybe<Scalars['String']>;
  seoH1It?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEnGb?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  showFormato?: Maybe<Scalars['Boolean']>;
  showGuidaTaglie?: Maybe<Scalars['Boolean']>;
  showTaglia?: Maybe<Scalars['Boolean']>;
  sistemiSpedizione: Array<SistemaSpedizioneNode>;
  slug: Scalars['String'];
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  stato?: Maybe<StatoProdottoNode>;
  suggestedForYou?: Maybe<Array<Maybe<ProdottoNode>>>;
  tabellaMotori?: Maybe<DescrizioneAggiuntivaProdottoNode>;
  topDelMese: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
  use?: Maybe<ValoreAttributoNode>;
  utilizzo?: Maybe<Scalars['String']>;
  valuta?: Maybe<ValutaNode>;
  videoImages?: Maybe<Array<Maybe<ImmagineProdottoType>>>;
  visibileAl?: Maybe<Scalars['DateTime']>;
  visibileDal?: Maybe<Scalars['DateTime']>;
  volantini?: Maybe<Array<Maybe<VolantinoNode>>>;
};


export type ProdottoNodePagineArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tipologia?: InputMaybe<PagesPaginaTipologiaChoices>;
};

export type ProdottoWarrantyNode = {
  __typename?: 'ProdottoWarrantyNode';
  categoria?: Maybe<CategoriaWarrantyNode>;
  nome?: Maybe<Scalars['String']>;
};

export type PromozioneNode = {
  __typename?: 'PromozioneNode';
  al: Scalars['DateTime'];
  alias?: Maybe<Scalars['String']>;
  attiva: Scalars['Boolean'];
  /** Prezzo di partenza utilizzato per l'applicazione dello sconto (valido solo su contesto 'Prodotto') */
  campoPrezzo?: Maybe<PromozioniPromozioneCampoPrezzoChoices>;
  codice?: Maybe<Scalars['String']>;
  /** Per attivare la promo è necessario inserire il codice in fase di checkout. */
  conCodice: Scalars['Boolean'];
  context: PromozioniPromozioneContextChoices;
  corrieri: Array<SistemaSpedizioneNode>;
  created?: Maybe<Scalars['DateTime']>;
  dal: Scalars['DateTime'];
  descrizione?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioneProdotto?: Maybe<Scalars['String']>;
  descrizioneProdottoEn?: Maybe<Scalars['String']>;
  descrizioneProdottoEnGb?: Maybe<Scalars['String']>;
  descrizioneProdottoEs?: Maybe<Scalars['String']>;
  descrizioneProdottoIt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ignoraDisponibilitaProdotti: Scalars['Boolean'];
  /** Numero di prodotti a carrello necessari per attivare la promo. */
  limiteNumeroProdotti: Scalars['Int'];
  /** Numero di volte che può essere usata la promo dal singolo utente. (0 per disattivare) */
  limiteNumeroUtilizzi: Scalars['Int'];
  /** Spesa minima necessaria per attivare la promozione. */
  limiteSpesa: Scalars['Float'];
  /** La promo è attivabile avendo a carrello solo prodotti presenti in promo. */
  limiteStrettoProdotti: Scalars['Boolean'];
  logicaApplicazione?: Maybe<PromozioniPromozioneLogicaApplicazioneChoices>;
  modified?: Maybe<Scalars['DateTime']>;
  /** Visualizza nei listing e in scheda prodotto quando manca alla scadenza della promozione. */
  mostraCounter: Scalars['Boolean'];
  /** Numero di volte che è stata utilizzata questa promo. In creazione lasciare a 0. */
  numeroUtilizzi: Scalars['Int'];
  ordini: OrdineNodeConnection;
  percentuale?: Maybe<Scalars['Boolean']>;
  pk?: Maybe<Scalars['Int']>;
  prodotti: Array<ProdottoNode>;
  prodottiAbbinati: Array<ProdottoNode>;
  prodottiBundle?: Maybe<Array<Maybe<ProdottoNode>>>;
  prodottiNegativi: Array<ProdottoNode>;
  promoDipendenti?: Maybe<Scalars['Boolean']>;
  regolaArrotondamenti?: Maybe<PromozioniPromozioneRegolaArrotondamentiChoices>;
  /** Per le promo valide solo per gli utenti associati definisce quando create automaticamente l'associazone con l'utente. */
  regolaAssociazioneUtente?: Maybe<PromozioniPromozioneRegolaAssociazioneUtenteChoices>;
  righeOrdine: Array<RigaOrdineNode>;
  /** Soglia peso massimo. */
  sogliaPesoMassimo: Scalars['Float'];
  /** La promo è attivabile solo da utenti iscritti alla newsletter. */
  soloIscrittiNewsletter: Scalars['Boolean'];
  titolo?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEnGb?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  tuttiGliUtenti: Scalars['Boolean'];
  tuttiICorrieri: Scalars['Boolean'];
  tuttiIProdotti: Scalars['Boolean'];
  utenti: UtenteNodeConnection;
  utentiAbilitati: UtenteNodeConnection;
  valore?: Maybe<Scalars['Float']>;
};


export type PromozioneNodeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PromozioneNodeUtentiArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PromozioneNodeUtentiAbilitatiArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum PromozioniPromozioneCampoPrezzoChoices {
  /** Prezzo */
  Prezzo = 'PREZZO',
  /** Prezzo unitario (di listino) */
  PrezzoUnitario = 'PREZZO_UNITARIO'
}

/** An enumeration. */
export enum PromozioniPromozioneContextChoices {
  /** Checkout */
  Checkout = 'CHECKOUT',
  /** InviaPromoCode */
  Inviapromocode = 'INVIAPROMOCODE',
  /** Prodotto */
  Prodotto = 'PRODOTTO',
  /** SistemaSpedizione */
  Sistemaspedizione = 'SISTEMASPEDIZIONE'
}

/** An enumeration. */
export enum PromozioniPromozioneLogicaApplicazioneChoices {
  /** Prodotti contemporaneamente presenti a carrello */
  ProdottiAbbinati = 'PRODOTTI_ABBINATI',
  /** Standard */
  Standard = 'STANDARD'
}

/** An enumeration. */
export enum PromozioniPromozioneRegolaArrotondamentiChoices {
  /** Valore intero inferiore */
  TruncateToLowerInt = 'TRUNCATE_TO_LOWER_INT',
  /** Arrotondamento ad intero 0, 5 o 9 */
  ZeroFiveNineEnding = 'ZERO_FIVE_NINE_ENDING'
}

/** An enumeration. */
export enum PromozioniPromozioneRegolaAssociazioneUtenteChoices {
  /** Associa all'utente che si registra sia alla newsletter che al sito */
  Newsletter = 'NEWSLETTER',
  /** Associa all'utente in fase di registrazione */
  Registrazione = 'REGISTRAZIONE'
}

export type Query = {
  __typename?: 'Query';
  cart?: Maybe<CarrelloNode>;
  categoria?: Maybe<CategoriaNode>;
  categoriaHelpOnline?: Maybe<CategoriaHelpOnlineDetailNode>;
  categorie?: Maybe<CategoriaNodeConnection>;
  categorieByParent?: Maybe<Array<Maybe<CategoriaNode>>>;
  categorieHelpOnline?: Maybe<Array<Maybe<CategoriaHelpOnlineNode>>>;
  categorieRicercaManuali?: Maybe<Array<Maybe<CategoriaNode>>>;
  checkout?: Maybe<CheckoutNode>;
  garanzieUtente?: Maybe<Array<Maybe<WarrantyNode>>>;
  interessiUtente?: Maybe<Array<Maybe<InteresseNewsletterNode>>>;
  last3News?: Maybe<Array<Maybe<NewsNode>>>;
  lastPromoPopup?: Maybe<PopupNode>;
  listingNews?: Maybe<ListingNewsNode>;
  listingNewsEmakInforma?: Maybe<ListingNewsEmakInformaNode>;
  listingVideoTutorial?: Maybe<ListingVideoTutorialNode>;
  me?: Maybe<UtenteNode>;
  motivazioniNazioni?: Maybe<MotivazioniNazioniNode>;
  motivazioniReso?: Maybe<Array<Maybe<MotivazioneResoNode>>>;
  nazioniManuali?: Maybe<Array<Maybe<NazioneNode>>>;
  newsBySlug?: Maybe<NewsNode>;
  newsEmakInformaBySlug?: Maybe<NewsEmakInformaNode>;
  ordine?: Maybe<OrdineNode>;
  ordineCheckout?: Maybe<OrdineNode>;
  ordini?: Maybe<OrdineNodeConnection>;
  pagina?: Maybe<PaginaNode>;
  paginaByPk?: Maybe<PaginaNode>;
  pagine?: Maybe<PaginaNodeConnection>;
  prezziProdotti?: Maybe<Array<Maybe<ProdottoNode>>>;
  prodotti?: Maybe<Array<Maybe<ProdottoNode>>>;
  prodottiByIds?: Maybe<Array<Maybe<ProdottoNode>>>;
  prodottiRicercaManuali?: Maybe<Array<Maybe<MasterProdottoDocumentiNode>>>;
  prodottiTendina?: Maybe<Array<Maybe<ProdottoNode>>>;
  prodottiTopDelMese?: Maybe<Array<Maybe<CategoriaNode>>>;
  prodotto?: Maybe<ProdottoNode>;
  prodottoByPk?: Maybe<ProdottoNode>;
  rivenditoriGeolocated?: Maybe<Array<Maybe<RivenditoreNode>>>;
  sistemiSpedizione?: Maybe<Array<Maybe<SistemaSpedizioneNode>>>;
  sottocategoriaVolantino?: Maybe<CategoriaNode>;
  video?: Maybe<VideoTutorialNode>;
  volantino?: Maybe<VolantinoNode>;
  wishlist?: Maybe<WishlistNode>;
};


export type QueryCategoriaArgs = {
  path?: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCategoriaHelpOnlineArgs = {
  categoriaSlug: Scalars['String'];
};


export type QueryCategorieArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inHome?: InputMaybe<Scalars['Boolean']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  soloConMastersConDocumenti?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCategorieByParentArgs = {
  inMenu?: InputMaybe<Scalars['Boolean']>;
  parentId: Scalars['Int'];
};


export type QueryListingNewsArgs = {
  params?: InputMaybe<Scalars['GenericScalar']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryListingNewsEmakInformaArgs = {
  params?: InputMaybe<Scalars['GenericScalar']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryListingVideoTutorialArgs = {
  params?: InputMaybe<Scalars['GenericScalar']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryNewsBySlugArgs = {
  preview?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};


export type QueryNewsEmakInformaBySlugArgs = {
  preview?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};


export type QueryOrdineArgs = {
  codice: Scalars['String'];
};


export type QueryOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginaArgs = {
  chiave?: InputMaybe<Scalars['String']>;
  contentTypeId?: InputMaybe<Scalars['Int']>;
  includeSelf?: InputMaybe<Scalars['Boolean']>;
  objectId?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  withChildren?: InputMaybe<Scalars['Boolean']>;
  withSiblings?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPaginaByPkArgs = {
  pk: Scalars['Int'];
  preview?: InputMaybe<Scalars['Boolean']>;
  withChildren?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPagineArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tipologia?: InputMaybe<PagesPaginaTipologiaChoices>;
};


export type QueryPrezziProdottiArgs = {
  ids: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryProdottiByIdsArgs = {
  ids: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryProdottiRicercaManualiArgs = {
  idCategoria: Scalars['Int'];
};


export type QueryProdottiTendinaArgs = {
  ids: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryProdottoArgs = {
  preview?: InputMaybe<Scalars['Boolean']>;
  slug?: Scalars['String'];
};


export type QueryProdottoByPkArgs = {
  pk: Scalars['Int'];
};


export type QueryRivenditoriGeolocatedArgs = {
  utenteGeo: Scalars['String'];
};


export type QuerySottocategoriaVolantinoArgs = {
  preview?: InputMaybe<Scalars['Boolean']>;
  slug?: Scalars['String'];
  slugVolantino?: Scalars['String'];
};


export type QueryVideoArgs = {
  preview?: InputMaybe<Scalars['Boolean']>;
  slug?: Scalars['String'];
};


export type QueryVolantinoArgs = {
  preview?: InputMaybe<Scalars['Boolean']>;
  slug?: Scalars['String'];
};

export type RecuperaPassword = {
  __typename?: 'RecuperaPassword';
  status?: Maybe<Scalars['Boolean']>;
  statusCode?: Maybe<Scalars['Int']>;
};

export type RemoveItem = {
  __typename?: 'RemoveItem';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type RemovePromoCode = {
  __typename?: 'RemovePromoCode';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type RemoveWishlistItem = {
  __typename?: 'RemoveWishlistItem';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type ResetPassword = {
  __typename?: 'ResetPassword';
  status?: Maybe<Scalars['Boolean']>;
  statusCode?: Maybe<Scalars['Int']>;
};

export type RichiediReso = {
  __typename?: 'RichiediReso';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type RichiediResoInput = {
  motivo: Scalars['String'];
  note: Scalars['String'];
  ordine: Scalars['Int'];
  righe: Scalars['GenericScalar'];
};

export type RigaCarrelloNode = {
  __typename?: 'RigaCarrelloNode';
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  omaggio?: Maybe<Scalars['Boolean']>;
  pk?: Maybe<Scalars['Int']>;
  prodotto?: Maybe<VarianteProdottoNode>;
  quantita?: Maybe<Scalars['Int']>;
  sessionKey?: Maybe<SessionType>;
  utente?: Maybe<UtenteNode>;
};

export type RigaCheckoutNode = {
  __typename?: 'RigaCheckoutNode';
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  omaggio: Scalars['Boolean'];
  pk?: Maybe<Scalars['Int']>;
  prodotto?: Maybe<VarianteProdottoNode>;
  quantita?: Maybe<Scalars['Int']>;
  utente: UtenteNode;
};

export type RigaOrdineNode = {
  __typename?: 'RigaOrdineNode';
  codiceProdotto?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  descrizione?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  nomeCategoriaWa?: Maybe<Scalars['String']>;
  nomeMacrocategoriaWa?: Maybe<Scalars['String']>;
  nomePromoWa?: Maybe<Scalars['String']>;
  omaggio: Scalars['Boolean'];
  ordine: OrdineNode;
  peso?: Maybe<Scalars['Float']>;
  pk?: Maybe<Scalars['Int']>;
  posizione?: Maybe<Scalars['String']>;
  prezzoSellinUnitario: Scalars['Float'];
  prezzoTotale: Scalars['Float'];
  prezzoTotaleScontato: Scalars['Float'];
  prezzoUnitario: Scalars['Float'];
  prezzoUnitarioScontato: Scalars['Float'];
  prodotto?: Maybe<VarianteProdottoNode>;
  promozione?: Maybe<PromozioneNode>;
  promozioneValoreAssoluto: Scalars['Float'];
  promozioneValorePercentuale: Scalars['Float'];
  quantitaOrdinata: Scalars['Int'];
  quantitaSpedita?: Maybe<Scalars['Int']>;
  tipologia: OrdiniRigaOrdineTipologiaChoices;
};

export type RigaWishlistNode = {
  __typename?: 'RigaWishlistNode';
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  omaggio: Scalars['Boolean'];
  pk?: Maybe<Scalars['Int']>;
  prodotto?: Maybe<ProdottoNode>;
  quantita: Scalars['Int'];
  sessionKey?: Maybe<Scalars['String']>;
  utente?: Maybe<UtenteNode>;
};

export type RispostaHelpOnlineNode = {
  __typename?: 'RispostaHelpOnlineNode';
  adminUrl?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrl?: Maybe<Scalars['String']>;
  categoria: CategoriaHelpOnlineNode;
  created: Scalars['DateTime'];
  domanda?: Maybe<Scalars['String']>;
  domandaEn?: Maybe<Scalars['String']>;
  domandaEnGb?: Maybe<Scalars['String']>;
  domandaEs?: Maybe<Scalars['String']>;
  domandaIt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  noindex: Scalars['Boolean'];
  nome?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  nonUtile: Scalars['Int'];
  ordinamento: Scalars['Int'];
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  risposta?: Maybe<Scalars['String']>;
  rispostaEn?: Maybe<Scalars['String']>;
  rispostaEnGb?: Maybe<Scalars['String']>;
  rispostaEs?: Maybe<Scalars['String']>;
  rispostaIt?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEnGb?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoH1?: Maybe<Scalars['String']>;
  seoH1En?: Maybe<Scalars['String']>;
  seoH1EnGb?: Maybe<Scalars['String']>;
  seoH1Es?: Maybe<Scalars['String']>;
  seoH1It?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEnGb?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  utile: Scalars['Int'];
  /** Data e ora di fine visibilità */
  visibileAl?: Maybe<Scalars['DateTime']>;
  /** Data e ora di inizio visibilità */
  visibileDal?: Maybe<Scalars['DateTime']>;
};

export type RivenditoreNode = {
  __typename?: 'RivenditoreNode';
  attivoPromoCoupon: Scalars['Boolean'];
  bonifico?: Maybe<Scalars['String']>;
  cap?: Maybe<Scalars['String']>;
  cf?: Maybe<Scalars['String']>;
  checkout: Scalars['Boolean'];
  citta?: Maybe<Scalars['String']>;
  codiceEmak?: Maybe<Scalars['String']>;
  codiceRif?: Maybe<Scalars['String']>;
  cognome?: Maybe<Scalars['String']>;
  consensoMkt: Scalars['Boolean'];
  consensoProfilazione: Scalars['Boolean'];
  created?: Maybe<Scalars['DateTime']>;
  customerIdStripe?: Maybe<Scalars['String']>;
  dataDiNascita?: Maybe<Scalars['Date']>;
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  emailConfermata: Scalars['Boolean'];
  fax?: Maybe<Scalars['String']>;
  guest: Scalars['Boolean'];
  id: Scalars['ID'];
  idOld?: Maybe<Scalars['Float']>;
  indirizzi: Array<IndirizzoNode>;
  indirizzo?: Maybe<Scalars['String']>;
  interessi: Array<InteresseNewsletterNode>;
  isActive: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  /** Attribuisce all'utente tutti i privilegi, senza che sia necessario assegnarli esplicitamente. */
  isSuperuser: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  latitudine?: Maybe<Scalars['String']>;
  longitudine?: Maybe<Scalars['String']>;
  luogoDiNascita?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  nota?: Maybe<Scalars['String']>;
  ordini: OrdineNodeConnection;
  password: Scalars['String'];
  paypalPassword?: Maybe<Scalars['String']>;
  paypalSignature?: Maybe<Scalars['String']>;
  paypalUsername?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
  piva?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  privato: Scalars['Boolean'];
  professione?: Maybe<Scalars['String']>;
  professionista: Scalars['Boolean'];
  promozioni: Array<PromozioneNode>;
  promozioniAbilitate: Array<PromozioneNode>;
  provincia?: Maybe<Scalars['String']>;
  ragioneSociale?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  righeCarrello: Array<RigaCarrelloNode>;
  righeCheckout: Array<RigaCheckoutNode>;
  righeWishlist: Array<RigaWishlistNode>;
  rivenditore?: Maybe<RivenditoreNode>;
  satispayBearer?: Maybe<Scalars['String']>;
  sdi?: Maybe<Scalars['String']>;
  sesso?: Maybe<Scalars['String']>;
  setefiCommerciante?: Maybe<Scalars['String']>;
  setefiPassword?: Maybe<Scalars['String']>;
  setefiUsername?: Maybe<Scalars['String']>;
  sistemiPagamento?: Maybe<Array<Maybe<SistemaPagamentoNode>>>;
  sistemiPagamentoGrouped?: Maybe<Array<Maybe<GroupedSistemaPagamentoNode>>>;
  stripeAccountid?: Maybe<Scalars['String']>;
  stripePrivatekey?: Maybe<Scalars['String']>;
  stripePublickey?: Maybe<Scalars['String']>;
  telefono?: Maybe<Scalars['String']>;
  unicreditHash?: Maybe<Scalars['String']>;
  unicreditTid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  utentePtr: UtenteNode;
  warranty: Array<WarrantyNode>;
};


export type RivenditoreNodeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ScontoBundlesType = {
  __typename?: 'ScontoBundlesType';
  promoApplicata?: Maybe<PromozioneNode>;
  scontoAssoluto?: Maybe<Scalars['Float']>;
};

export type SeoType = {
  __typename?: 'SeoType';
  canonicalUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  h1?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  noindex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type SessionType = {
  __typename?: 'SessionType';
  expireDate: Scalars['DateTime'];
  righeCarrello: Array<RigaCarrelloNode>;
  sessionData: Scalars['String'];
  sessionKey: Scalars['String'];
};

export type SetCheckout = {
  __typename?: 'SetCheckout';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type SetIndirizzi = {
  __typename?: 'SetIndirizzi';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type SetModalitaSpedizione = {
  __typename?: 'SetModalitaSpedizione';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type SetPromoCode = {
  __typename?: 'SetPromoCode';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type SetSistemaPagamento = {
  __typename?: 'SetSistemaPagamento';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type SignInInput = {
  cf?: InputMaybe<Scalars['String']>;
  cognome: Scalars['String'];
  consensoMkt?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  guest?: InputMaybe<Scalars['Boolean']>;
  nome: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  pec?: InputMaybe<Scalars['String']>;
  piva?: InputMaybe<Scalars['String']>;
  privato: Scalars['Boolean'];
  ragioneSociale?: InputMaybe<Scalars['String']>;
  sdi?: InputMaybe<Scalars['String']>;
};

export type SistemaPagamentoNode = {
  __typename?: 'SistemaPagamentoNode';
  alias?: Maybe<Scalars['String']>;
  attivo: Scalars['Boolean'];
  className: Scalars['String'];
  created?: Maybe<Scalars['DateTime']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  famiglia?: Maybe<FamigliaSistemaPagamentoNode>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  ordini: OrdineNodeConnection;
  pk?: Maybe<Scalars['Int']>;
};


export type SistemaPagamentoNodeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SistemaSpedizioneNode = {
  __typename?: 'SistemaSpedizioneNode';
  alias?: Maybe<Scalars['String']>;
  /** Integrazione con api del carrier */
  carrier?: Maybe<Scalars['String']>;
  chiave?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  default: Scalars['Boolean'];
  descrizione?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneEstesa?: Maybe<Scalars['String']>;
  descrizioneEstesaEn?: Maybe<Scalars['String']>;
  descrizioneEstesaEnGb?: Maybe<Scalars['String']>;
  descrizioneEstesaEs?: Maybe<Scalars['String']>;
  descrizioneEstesaIt?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  /** Se abilitato esclude tutti gli altri sistemi di spedizione, altrimenti è in alternativa */
  esclusivo: Scalars['Boolean'];
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  ordini: OrdineNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  prezzo?: Maybe<Scalars['Float']>;
  prezzoScontato?: Maybe<Scalars['Float']>;
  prodottiSpedibili: Array<ProdottoNode>;
  promoApplicata?: Maybe<PromozioneNode>;
  promozioni: Array<PromozioneNode>;
  scontoAssoluto?: Maybe<Scalars['Float']>;
  scontoPercentuale?: Maybe<Scalars['Boolean']>;
  valoreAttributo?: Maybe<ValoreAttributoNode>;
};


export type SistemaSpedizioneNodeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SocialAuthMutation = {
  __typename?: 'SocialAuthMutation';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UtenteNode>;
};

export type StatoNode = Node & {
  __typename?: 'StatoNode';
  alias: Scalars['String'];
  azione?: Maybe<Scalars['String']>;
  chiave?: Maybe<Scalars['String']>;
  className: Scalars['String'];
  colorBackend?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  fatturato: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  isPreventivo: Scalars['Boolean'];
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  ordini: OrdineNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  statiConsentiti: StatoNodeConnection;
  statoSet: StatoNodeConnection;
  visibileInListing: Scalars['Boolean'];
};


export type StatoNodeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StatoNodeStatiConsentitiArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StatoNodeStatoSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type StatoNodeConnection = {
  __typename?: 'StatoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StatoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StatoNode` and its cursor. */
export type StatoNodeEdge = {
  __typename?: 'StatoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StatoNode>;
};

export type StatoProdottoNode = {
  __typename?: 'StatoProdottoNode';
  acquistabile: Scalars['Boolean'];
  /** Un alias che identifichi lo stato */
  alias: Scalars['String'];
  /** Un alias che identifichi lo stato */
  aliasEn?: Maybe<Scalars['String']>;
  /** Un alias che identifichi lo stato */
  aliasEnGb?: Maybe<Scalars['String']>;
  /** Un alias che identifichi lo stato */
  aliasEs?: Maybe<Scalars['String']>;
  /** Un alias che identifichi lo stato */
  aliasIt?: Maybe<Scalars['String']>;
  azione?: Maybe<ProdottiStatoProdottoAzioneChoices>;
  codice: Scalars['String'];
  created: Scalars['DateTime'];
  escludiSconti: Scalars['Boolean'];
  id: Scalars['ID'];
  inListing: Scalars['Boolean'];
  infoDescrizione?: Maybe<Scalars['String']>;
  infoDescrizioneEn?: Maybe<Scalars['String']>;
  infoDescrizioneEnGb?: Maybe<Scalars['String']>;
  infoDescrizioneEs?: Maybe<Scalars['String']>;
  infoDescrizioneIt?: Maybe<Scalars['String']>;
  infoTitolo?: Maybe<Scalars['String']>;
  infoTitoloEn?: Maybe<Scalars['String']>;
  infoTitoloEnGb?: Maybe<Scalars['String']>;
  infoTitoloEs?: Maybe<Scalars['String']>;
  infoTitoloIt?: Maybe<Scalars['String']>;
  /** 0 se non limitato */
  limiteAcquisto: Scalars['Int'];
  modified: Scalars['DateTime'];
  prodotti: Array<ProdottoNode>;
};

export type TabellaCompatibilitaCategoriaNode = {
  __typename?: 'TabellaCompatibilitaCategoriaNode';
  dati?: Maybe<Array<Maybe<CompatibilitaGruppoNode>>>;
  descrizione?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
};

/** Represents the entire technical data table structure. */
export type TabellaDatiTecniciNode = {
  __typename?: 'TabellaDatiTecniciNode';
  attributi?: Maybe<Array<Maybe<Scalars['String']>>>;
  prodotti?: Maybe<Array<Maybe<DatiTecniciProdottoNode>>>;
};

export type UtenteInput = {
  cf?: InputMaybe<Scalars['String']>;
  cognome?: InputMaybe<Scalars['String']>;
  consensoMkt?: InputMaybe<Scalars['Boolean']>;
  consensoProfilazione?: InputMaybe<Scalars['Boolean']>;
  dataDiNascita?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  interessi?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nome?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  pec?: InputMaybe<Scalars['String']>;
  piva?: InputMaybe<Scalars['String']>;
  privato?: InputMaybe<Scalars['Boolean']>;
  professionista?: InputMaybe<Scalars['Boolean']>;
  ragioneSociale?: InputMaybe<Scalars['String']>;
  sdi?: InputMaybe<Scalars['String']>;
};

export type UtenteNode = Node & {
  __typename?: 'UtenteNode';
  cf?: Maybe<Scalars['String']>;
  cognome?: Maybe<Scalars['String']>;
  consensoMkt: Scalars['Boolean'];
  consensoProfilazione: Scalars['Boolean'];
  created?: Maybe<Scalars['DateTime']>;
  customerIdStripe?: Maybe<Scalars['String']>;
  dataDiNascita?: Maybe<Scalars['Date']>;
  dataPrimoOrdine?: Maybe<Scalars['String']>;
  dataUltimoOrdine?: Maybe<Scalars['String']>;
  dateJoined: Scalars['DateTime'];
  edit?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  emailConfermata: Scalars['Boolean'];
  guest: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  idOld?: Maybe<Scalars['Float']>;
  indirizzi: Array<IndirizzoNode>;
  indirizziFatturazione?: Maybe<Array<Maybe<IndirizzoNode>>>;
  indirizziSpedizione?: Maybe<Array<Maybe<IndirizzoNode>>>;
  interessi: Array<InteresseNewsletterNode>;
  isActive: Scalars['Boolean'];
  isImpersonate?: Maybe<Scalars['Boolean']>;
  isRivenditore?: Maybe<Scalars['Boolean']>;
  isStaff: Scalars['Boolean'];
  /** Attribuisce all'utente tutti i privilegi, senza che sia necessario assegnarli esplicitamente. */
  isSuperuser: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  luogoDiNascita?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  numeroProdottiWishlist?: Maybe<Scalars['Int']>;
  ordini: OrdineNodeConnection;
  pec?: Maybe<Scalars['String']>;
  piva?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  privato: Scalars['Boolean'];
  professione?: Maybe<Scalars['String']>;
  professionista: Scalars['Boolean'];
  progressoProfilo?: Maybe<Scalars['Int']>;
  promozioni: Array<PromozioneNode>;
  promozioniAbilitate: Array<PromozioneNode>;
  ragioneSociale?: Maybe<Scalars['String']>;
  righeCarrello: Array<RigaCarrelloNode>;
  righeCheckout: Array<RigaCheckoutNode>;
  righeWishlist: Array<RigaWishlistNode>;
  rivenditore?: Maybe<RivenditoreNode>;
  sdi?: Maybe<Scalars['String']>;
  sesso?: Maybe<Scalars['String']>;
  showToolbar?: Maybe<Scalars['Boolean']>;
  tipoUtente?: Maybe<Scalars['String']>;
  ultimoOrdine?: Maybe<OrdineNode>;
  username: Scalars['String'];
  warranty: Array<WarrantyNode>;
};


export type UtenteNodeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UtenteNodeConnection = {
  __typename?: 'UtenteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UtenteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UtenteNode` and its cursor. */
export type UtenteNodeEdge = {
  __typename?: 'UtenteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UtenteNode>;
};

export type ValidaCodicePostale = {
  __typename?: 'ValidaCodicePostale';
  details?: Maybe<Scalars['JSONString']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type ValidaIndirizzo = {
  __typename?: 'ValidaIndirizzo';
  details?: Maybe<Scalars['JSONString']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type ValidaIndirizzoInput = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  postalCode: Scalars['String'];
  street: Scalars['String'];
};

export type ValoreAttributoNode = {
  __typename?: 'ValoreAttributoNode';
  alias: Scalars['String'];
  attributo?: Maybe<AttributoNode>;
  categorie: CategoriaNodeConnection;
  children: Array<ValoreAttributoNode>;
  codice: Scalars['String'];
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  nome: Scalars['String'];
  nomeEn?: Maybe<Scalars['String']>;
  nomeEnGb?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  ordine: Scalars['Int'];
  parent?: Maybe<ValoreAttributoNode>;
  pk?: Maybe<Scalars['Int']>;
  sistemiSpedizione: Array<SistemaSpedizioneNode>;
  slug: Scalars['String'];
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
};


export type ValoreAttributoNodeCategorieArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inHome?: InputMaybe<Scalars['Boolean']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  soloConMastersConDocumenti?: InputMaybe<Scalars['Boolean']>;
};

export type ValutaNode = {
  __typename?: 'ValutaNode';
  alias: Scalars['String'];
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isoCode: Scalars['String'];
  modified?: Maybe<Scalars['DateTime']>;
  ordini: OrdineNodeConnection;
  setefiCode?: Maybe<Scalars['String']>;
  simbolo: Scalars['String'];
};


export type ValutaNodeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type VarianteProdottoNode = {
  __typename?: 'VarianteProdottoNode';
  prodotto?: Maybe<ProdottoNode>;
};

export type VideoNewsNode = {
  __typename?: 'VideoNewsNode';
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** Es: e2780IjFa5A */
  idYoutube?: Maybe<Scalars['String']>;
  image?: Maybe<ImageNode>;
  modified?: Maybe<Scalars['DateTime']>;
  news: NewsNode;
  ordinamento: Scalars['Int'];
};

export type VideoTutorialNode = {
  __typename?: 'VideoTutorialNode';
  adminUrl?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrl?: Maybe<Scalars['String']>;
  categoria?: Maybe<CategoriaVideoTutorialNode>;
  categorie: Array<CategoriaVideoTutorialNode>;
  correlati?: Maybe<Array<Maybe<VideoTutorialNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** Es: e2780IjFa5A */
  idYoutube?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  noindex: Scalars['Boolean'];
  ordinamento: Scalars['Int'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEnGb?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoH1?: Maybe<Scalars['String']>;
  seoH1En?: Maybe<Scalars['String']>;
  seoH1EnGb?: Maybe<Scalars['String']>;
  seoH1Es?: Maybe<Scalars['String']>;
  seoH1It?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEnGb?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  sottotitolo?: Maybe<Scalars['String']>;
  sottotitoloEn?: Maybe<Scalars['String']>;
  sottotitoloEnGb?: Maybe<Scalars['String']>;
  sottotitoloEs?: Maybe<Scalars['String']>;
  sottotitoloIt?: Maybe<Scalars['String']>;
  testo?: Maybe<Scalars['String']>;
  testoEn?: Maybe<Scalars['String']>;
  testoEnGb?: Maybe<Scalars['String']>;
  testoEs?: Maybe<Scalars['String']>;
  testoIt?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEnGb?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  videoCorrelati: Array<VideoTutorialNode>;
  videotutorial: Array<VideoTutorialNode>;
};

/** An enumeration. */
export enum VolantiniVolantinoStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

export type VolantinoNode = {
  __typename?: 'VolantinoNode';
  adminUrl?: Maybe<Scalars['String']>;
  /** URL relativo. Valorizzato con l'URL dell'elemento se lasciato vuoto. */
  canonicalUrl?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEnGb?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  immagine?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  introEn?: Maybe<Scalars['String']>;
  introEnGb?: Maybe<Scalars['String']>;
  introEs?: Maybe<Scalars['String']>;
  introIt?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  noindex: Scalars['Boolean'];
  pagina?: Maybe<PaginaNode>;
  /** URL to the language-specific PDF file. */
  pdfUrl?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  prodotti: Array<ProdottoNode>;
  seoDescription?: Maybe<Scalars['String']>;
  seoH1?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugEn?: Maybe<Scalars['String']>;
  slugEnGb?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  sottocategorie?: Maybe<Array<Maybe<CategoriaNode>>>;
  statoPubblicazione: VolantiniVolantinoStatoPubblicazioneChoices;
  /** Structured data for the technical comparison table. */
  tabellaCompatibilita?: Maybe<Array<Maybe<TabellaCompatibilitaCategoriaNode>>>;
  titolo: Scalars['String'];
  titoloEn?: Maybe<Scalars['String']>;
  titoloEnGb?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  /** Data e ora fino a quando sarà visibile il contenuto (non obbligatorio) */
  visibilitaAl?: Maybe<Scalars['DateTime']>;
  /** Data e ora da quando sarà visibile il contenuto (non obbligatorio) */
  visibilitaDal?: Maybe<Scalars['DateTime']>;
};

export type WarrantyNode = {
  __typename?: 'WarrantyNode';
  created?: Maybe<Scalars['DateTime']>;
  dataAcquisto?: Maybe<Scalars['Date']>;
  dataScadenza?: Maybe<Scalars['Date']>;
  descrizione: Scalars['String'];
  durata?: Maybe<Scalars['Int']>;
  estesa: Scalars['Boolean'];
  id: Scalars['ID'];
  modello: Scalars['String'];
  modified?: Maybe<Scalars['DateTime']>;
  numeroSerie: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  prodotto?: Maybe<ProdottoWarrantyNode>;
  productRegistrationId: Scalars['String'];
  /** e.g: '/it' */
  url: Scalars['String'];
  utente?: Maybe<UtenteNode>;
};

export type WishlistNode = {
  __typename?: 'WishlistNode';
  items?: Maybe<Array<Maybe<RigaWishlistNode>>>;
};

export type CreateAdesioneB2CMutationVariables = Exact<{
  adesioneInput: CreateAdesioneB2CInput;
}>;


export type CreateAdesioneB2CMutation = { __typename?: 'Mutation', createAdesioneB2c?: { __typename?: 'CreateAdesioneB2C', status?: boolean | null, message?: string | null } | null };

export type AddItemMutationVariables = Exact<{
  idProdotto: Scalars['Int'];
  quantita: Scalars['Int'];
}>;


export type AddItemMutation = { __typename?: 'Mutation', addItem?: { __typename?: 'AddItem', status?: boolean | null, message?: string | null } | null };

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = { __typename?: 'Query', cart?: { __typename?: 'CarrelloNode', totaleScontato?: number | null, prezzo?: number | null, scontoAssoluto?: number | null, hasOmaggio?: boolean | null, items?: Array<{ __typename?: 'RigaCarrelloNode', omaggio?: boolean | null, quantita?: number | null, prodotto?: { __typename?: 'VarianteProdottoNode', prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, promoApplicata?: { __typename?: 'PromozioneNode', pk?: number | null, codice?: string | null, alias?: string | null, titolo?: string | null, descrizione?: string | null, valore?: number | null, percentuale?: boolean | null, promoDipendenti?: boolean | null } | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null } | null } | null> | null, promoApplicata?: { __typename?: 'PromozioneNode', pk?: number | null, codice?: string | null, alias?: string | null, titolo?: string | null, descrizione?: string | null, valore?: number | null, percentuale?: boolean | null, promoDipendenti?: boolean | null } | null, correlati?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null> | null, scontoBundles?: { __typename?: 'ScontoBundlesType', scontoAssoluto?: number | null, promoApplicata?: { __typename?: 'PromozioneNode', alias?: string | null } | null } | null } | null };

export type RemoveItemMutationVariables = Exact<{
  idProdotto: Scalars['Int'];
  omaggio: Scalars['Boolean'];
}>;


export type RemoveItemMutation = { __typename?: 'Mutation', removeItem?: { __typename?: 'RemoveItem', status?: boolean | null, message?: string | null } | null };

export type SetPromoCodeMutationVariables = Exact<{
  promoCode: Scalars['String'];
}>;


export type SetPromoCodeMutation = { __typename?: 'Mutation', setPromoCode?: { __typename?: 'SetPromoCode', status?: boolean | null, message?: string | null } | null };

export type RemovePromoCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type RemovePromoCodeMutation = { __typename?: 'Mutation', removePromoCode?: { __typename?: 'RemovePromoCode', status?: boolean | null, message?: string | null } | null };

export type ChangeItemSizeMutationVariables = Exact<{
  idProdottoNew?: InputMaybe<Scalars['Int']>;
  idProdottoOld?: InputMaybe<Scalars['Int']>;
  omaggio?: InputMaybe<Scalars['Boolean']>;
}>;


export type ChangeItemSizeMutation = { __typename?: 'Mutation', changeItemSize?: { __typename?: 'ChangeItemSize', status?: boolean | null, message?: string | null } | null };

export type HomeDataQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeDataQuery = { __typename?: 'Query', categorie?: { __typename?: 'CategoriaNodeConnection', edges: Array<{ __typename?: 'CategoriaNodeEdge', node?: { __typename?: 'CategoriaNode', pk?: number | null, boxTitolo?: string | null, url?: string | null, previewImage?: string | null } | null } | null> } | null, prodottiTopDelMese?: Array<{ __typename?: 'CategoriaNode', pk?: number | null, boxTitolo?: string | null, prodottiTopDelMese?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null> | null } | null> | null };

export type CategoriaQueryVariables = Exact<{
  path: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type CategoriaQuery = { __typename?: 'Query', categoria?: { __typename?: 'CategoriaNode', pk?: number | null, nome: string, descrizione?: string | null, guidaBreve?: string | null, guidaDettagliata?: string | null, sottoTitolo?: string | null, url?: string | null, mainImage?: string | null, depth: number, template?: string | null, adminUrl?: string | null, model?: number | null, boxTitolo?: string | null, alias: string, modelClass?: string | null, offertaMarketingBox?: { __typename?: 'OffertaMarketingBoxNode', intro?: string | null, helper?: string | null, image?: string | null, url?: string | null, ctaLabel?: string | null, name?: string | null, description?: string | null } | null, parent?: { __typename?: 'CategoriaNode', pk?: number | null, nome: string, url?: string | null, alias: string, boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null, children?: Array<{ __typename?: 'CategoriaNode', pk?: number | null, nome: string, url?: string | null, previewImage?: string | null, depth: number, numeroProdotti?: number | null } | null> | null, siblings?: Array<{ __typename?: 'CategoriaNode', pk?: number | null, nome: string, url?: string | null } | null> | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null, h1?: string | null } | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null } | null> | null } | null } | null };

export type CategorieQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieQuery = { __typename?: 'Query', categorie?: { __typename?: 'CategoriaNodeConnection', edges: Array<{ __typename?: 'CategoriaNodeEdge', node?: { __typename?: 'CategoriaNode', pk?: number | null, path?: string | null } | null } | null> } | null };

export type CheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutQuery = { __typename?: 'Query', checkout?: { __typename?: 'CheckoutNode', totaleSenzaPromozioni?: number | null, scontoAssoluto?: number | null, totaleScontato?: number | null, scontoPercentuale?: number | null, totaleScontatoNetto?: number | null, totaleProdottiScontato?: number | null, items?: Array<{ __typename?: 'RigaCheckoutNode', quantita?: number | null, prodotto?: { __typename?: 'VarianteProdottoNode', prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null } | null } | null> | null, promoApplicata?: { __typename?: 'PromozioneNode', pk?: number | null, codice?: string | null, alias?: string | null, titolo?: string | null, descrizione?: string | null, valore?: number | null, percentuale?: boolean | null, promoDipendenti?: boolean | null } | null, sistemiSpedizione?: Array<{ __typename?: 'SistemaSpedizioneNode', pk?: number | null, alias?: string | null, chiave?: string | null, nome?: string | null, descrizione?: string | null, descrizioneEstesa?: string | null, prezzo?: number | null, prezzoScontato?: number | null, scontoPercentuale?: boolean | null, scontoAssoluto?: number | null, promoApplicata?: { __typename?: 'PromozioneNode', pk?: number | null, codice?: string | null, alias?: string | null, titolo?: string | null, descrizione?: string | null, valore?: number | null, percentuale?: boolean | null } | null } | null> | null, sistemaSpedizione?: { __typename?: 'SistemaSpedizioneNode', pk?: number | null, alias?: string | null, chiave?: string | null, nome?: string | null, descrizione?: string | null, descrizioneEstesa?: string | null, prezzo?: number | null, prezzoScontato?: number | null, scontoPercentuale?: boolean | null, scontoAssoluto?: number | null, promoApplicata?: { __typename?: 'PromozioneNode', pk?: number | null, codice?: string | null, alias?: string | null, titolo?: string | null, descrizione?: string | null, valore?: number | null, percentuale?: boolean | null } | null } | null, sistemaPagamento?: { __typename?: 'SistemaPagamentoNode', pk?: number | null, alias?: string | null, nome?: string | null, descrizione?: string | null } | null, indirizzoSpedizione?: { __typename?: 'IndirizzoNode', pk?: number | null, nome?: string | null, cognome?: string | null, indirizzo?: string | null, provincia?: string | null, note?: string | null, citta?: string | null, cap?: string | null, telefono?: string | null } | null, indirizzoFatturazione?: { __typename?: 'IndirizzoNode', pk?: number | null, nome?: string | null, cognome?: string | null, indirizzo?: string | null, provincia?: string | null, note?: string | null, citta?: string | null, cap?: string | null, telefono?: string | null } | null, sistemiPagamento?: Array<{ __typename?: 'GroupedSistemaPagamentoNode', pk?: number | null, descrizione?: string | null, rivenditore?: { __typename?: 'RivenditoreNode', pk?: number | null } | null, famiglia?: { __typename?: 'FamigliaSistemaPagamentoNode', nome?: string | null, chiave?: string | null } | null } | null> | null, rivenditori?: Array<{ __typename?: 'RivenditoreNode', ragioneSociale?: string | null, indirizzo?: string | null, citta?: string | null, provincia?: string | null, longitudine?: string | null, latitudine?: string | null, pk?: number | null, sistemiPagamento?: Array<{ __typename?: 'SistemaPagamentoNode', pk?: number | null, alias?: string | null, nome?: string | null, descrizione?: string | null, famiglia?: { __typename?: 'FamigliaSistemaPagamentoNode', nome?: string | null } | null } | null> | null } | null> | null, rivenditore?: { __typename?: 'RivenditoreNode', ragioneSociale?: string | null, pk?: number | null, indirizzo?: string | null, citta?: string | null, provincia?: string | null, sistemiPagamentoGrouped?: Array<{ __typename?: 'GroupedSistemaPagamentoNode', pk?: number | null, descrizione?: string | null, rivenditore?: { __typename?: 'RivenditoreNode', pk?: number | null } | null, famiglia?: { __typename?: 'FamigliaSistemaPagamentoNode', nome?: string | null, chiave?: string | null } | null } | null> | null } | null, scontoBundles?: { __typename?: 'ScontoBundlesType', scontoAssoluto?: number | null, promoApplicata?: { __typename?: 'PromozioneNode', alias?: string | null } | null } | null } | null };

export type SetModalitaSpedizioneMutationVariables = Exact<{
  idModalitaSpedizione: Scalars['Int'];
  idRivenditore?: InputMaybe<Scalars['Int']>;
}>;


export type SetModalitaSpedizioneMutation = { __typename?: 'Mutation', setModalitaSpedizione?: { __typename?: 'SetModalitaSpedizione', status?: boolean | null, message?: string | null } | null };

export type SetIndirizziMutationVariables = Exact<{
  indirizzoSpedizione?: InputMaybe<Scalars['Int']>;
  indirizzoFatturazione?: InputMaybe<Scalars['Int']>;
  same?: InputMaybe<Scalars['Boolean']>;
  spedizione?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetIndirizziMutation = { __typename?: 'Mutation', setIndirizzi?: { __typename?: 'SetIndirizzi', status?: boolean | null, message?: string | null } | null };

export type CreateIndirizzoMutationVariables = Exact<{
  input: IndirizzoInput;
}>;


export type CreateIndirizzoMutation = { __typename?: 'Mutation', createIndirizzo?: { __typename?: 'CreateIndirizzo', indirizzo?: { __typename?: 'IndirizzoNode', nome?: string | null, cognome?: string | null, indirizzo?: string | null, isFatturazione: boolean } | null } | null };

export type SetCheckoutMutationVariables = Exact<{
  idRivenditore: Scalars['Int'];
  idSistemaPagamento: Scalars['Int'];
}>;


export type SetCheckoutMutation = { __typename?: 'Mutation', setCheckout?: { __typename?: 'SetCheckout', url?: string | null, status?: boolean | null, message?: string | null } | null };

export type SetSistemaPagamentoMutationVariables = Exact<{
  idSistemaPagamento: Scalars['Int'];
}>;


export type SetSistemaPagamentoMutation = { __typename?: 'Mutation', setSistemaPagamento?: { __typename?: 'SetSistemaPagamento', status?: boolean | null, message?: string | null } | null };

export type SistemiSpedizioneQueryVariables = Exact<{ [key: string]: never; }>;


export type SistemiSpedizioneQuery = { __typename?: 'Query', sistemiSpedizione?: Array<{ __typename?: 'SistemaSpedizioneNode', pk?: number | null, alias?: string | null, chiave?: string | null, nome?: string | null, descrizioneEstesa?: string | null, prezzo?: number | null, prezzoScontato?: number | null } | null> | null };

export type RivenditoriGeolocatedQueryVariables = Exact<{
  utenteGeo: Scalars['String'];
}>;


export type RivenditoriGeolocatedQuery = { __typename?: 'Query', rivenditoriGeolocated?: Array<{ __typename?: 'RivenditoreNode', ragioneSociale?: string | null, indirizzo?: string | null, citta?: string | null, provincia?: string | null, pk?: number | null, latitudine?: string | null, longitudine?: string | null, sistemiPagamento?: Array<{ __typename?: 'SistemaPagamentoNode', pk?: number | null, alias?: string | null, nome?: string | null, descrizione?: string | null, image?: string | null, famiglia?: { __typename?: 'FamigliaSistemaPagamentoNode', nome?: string | null } | null } | null> | null } | null> | null };

export type CreateAddressMutationVariables = Exact<{
  address: CreateAddressInput;
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', createAddress?: { __typename?: 'CreateAddress', status?: boolean | null, message?: string | null, pk?: number | null } | null };

export type ValidaIndirizzoMutationVariables = Exact<{
  address: ValidaIndirizzoInput;
}>;


export type ValidaIndirizzoMutation = { __typename?: 'Mutation', validaIndirizzo?: { __typename?: 'ValidaIndirizzo', status?: boolean | null, message?: string | null, valid?: boolean | null, details?: any | null } | null };

export type ValidaCodicePostaleMutationVariables = Exact<{
  postalCode: Scalars['String'];
  countryCode: Scalars['String'];
  stateCode: Scalars['String'];
  carrierCode: Scalars['String'];
}>;


export type ValidaCodicePostaleMutation = { __typename?: 'Mutation', validaCodicePostale?: { __typename?: 'ValidaCodicePostale', status?: boolean | null, message?: string | null, valid?: boolean | null, details?: any | null } | null };

export type CategorieHelpOnlineQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieHelpOnlineQuery = { __typename?: 'Query', categorieHelpOnline?: Array<{ __typename?: 'CategoriaHelpOnlineNode', pk?: number | null, nome?: string | null, url?: string | null, descrizione?: string | null, risposte?: Array<{ __typename?: 'RispostaHelpOnlineNode', pk?: number | null, nome?: string | null, risposta?: string | null } | null> | null } | null> | null };

export type CategoriaHelpOnlineQueryVariables = Exact<{
  categoriaSlug: Scalars['String'];
}>;


export type CategoriaHelpOnlineQuery = { __typename?: 'Query', categoriaHelpOnline?: { __typename?: 'CategoriaHelpOnlineDetailNode', categorie?: Array<{ __typename?: 'CategoriaHelpOnlineNode', pk?: number | null, nome?: string | null, url?: string | null } | null> | null, categoria?: { __typename?: 'CategoriaHelpOnlineNode', pk?: number | null, nome?: string | null, url?: string | null, risposte?: Array<{ __typename?: 'RispostaHelpOnlineNode', pk?: number | null, nome?: string | null, risposta?: string | null, slug: string } | null> | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null } | null } | null } | null };

export type FeedbackMutationVariables = Exact<{
  idRisposta: Scalars['ID'];
  utile: Scalars['Boolean'];
}>;


export type FeedbackMutation = { __typename?: 'Mutation', feedback?: { __typename?: 'FeedbackMutation', status?: boolean | null, message?: string | null } | null };

export type CategorieRicercaManualiQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieRicercaManualiQuery = { __typename?: 'Query', categorieRicercaManuali?: Array<{ __typename?: 'CategoriaNode', pk?: number | null, nome: string } | null> | null };

export type GetCategorieByParentQueryVariables = Exact<{
  parentId: Scalars['Int'];
  inMenu?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCategorieByParentQuery = { __typename?: 'Query', categorieByParent?: Array<{ __typename?: 'CategoriaNode', pk?: number | null, nome: string } | null> | null };

export type ProdottiRicercaManualiQueryVariables = Exact<{
  idCategoria: Scalars['Int'];
}>;


export type ProdottiRicercaManualiQuery = { __typename?: 'Query', prodottiRicercaManuali?: Array<{ __typename?: 'MasterProdottoDocumentiNode', pk?: number | null, alias?: string | null, documenti?: Array<{ __typename?: 'DocumentoProdottoNode', pk?: number | null, url?: string | null, nomeDocumento?: string | null, lingue?: Array<{ __typename?: 'LinguaDocumentoProdottoNode', id: string, codice?: string | null } | null> | null } | null> | null } | null> | null };

export type NazioniManualiQueryVariables = Exact<{ [key: string]: never; }>;


export type NazioniManualiQuery = { __typename?: 'Query', nazioniManuali?: Array<{ __typename?: 'NazioneNode', pk?: number | null, nome?: string | null } | null> | null };

export type CreateContattoManualeMutationVariables = Exact<{
  contattoInput: CreateContattoManualeInput;
}>;


export type CreateContattoManualeMutation = { __typename?: 'Mutation', createContattoManuale?: { __typename?: 'CreateContattoManuale', status?: boolean | null, message?: string | null } | null };

export type NewsCardFragment = { __typename?: 'NewsNode', pk?: number | null, alias: string, titolo?: string | null, sottotitolo?: string | null, tempoLettura: any, previewImage?: string | null, url?: string | null, testo?: string | null, categoria?: { __typename?: 'CategoriaNewsNode', pk?: number | null, slug: string, alias: string, nome?: string | null } | null, listingVideos?: { __typename?: 'VideoNewsNode', idYoutube?: string | null } | null };

export type NewsEmakInformaCardFragment = { __typename?: 'NewsEmakInformaNode', pk?: number | null, alias: string, titolo?: string | null, sottotitolo?: string | null, tempoLettura: any, previewImage?: string | null, url?: string | null };

export type NewsBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type NewsBySlugQuery = { __typename?: 'Query', newsBySlug?: { __typename?: 'NewsNode', mainImage?: string | null, model?: number | null, modelClass?: string | null, adminUrl?: string | null, contenutoIndicizzabile?: string | null, pk?: number | null, alias: string, titolo?: string | null, sottotitolo?: string | null, tempoLettura: any, previewImage?: string | null, url?: string | null, testo?: string | null, documentiVisibili?: Array<{ __typename?: 'DocumentoNode', pk?: number | null, url?: string | null, titolo?: string | null } | null> | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null } | null> | null } | null, pagebuilders?: Array<{ __typename?: 'PagebuilderPlaceholderNode', key: string, text?: string | null, json_draft?: string | null, json_published?: string | null } | null> | null, correlati?: Array<{ __typename?: 'NewsNode', pk?: number | null, alias: string, titolo?: string | null, sottotitolo?: string | null, tempoLettura: any, previewImage?: string | null, url?: string | null, testo?: string | null, categoria?: { __typename?: 'CategoriaNewsNode', pk?: number | null, slug: string, alias: string, nome?: string | null } | null, listingVideos?: { __typename?: 'VideoNewsNode', idYoutube?: string | null } | null } | null> | null, categoria?: { __typename?: 'CategoriaNewsNode', pk?: number | null, slug: string, alias: string, nome?: string | null } | null, listingVideos?: { __typename?: 'VideoNewsNode', idYoutube?: string | null } | null } | null };

export type ListingNewsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  params?: InputMaybe<Scalars['GenericScalar']>;
}>;


export type ListingNewsQuery = { __typename?: 'Query', listingNews?: { __typename?: 'ListingNewsNode', canonicalUrl?: string | null, paginator?: { __typename?: 'NewsPaginatorNode', currentPage?: number | null, numPages?: number | null, itemsPerPage?: number | null, count?: number | null, pages?: Array<{ __typename?: 'PageNode', href?: string | null, page?: string | null } | null> | null } | null, news?: Array<{ __typename?: 'NewsNode', pk?: number | null, alias: string, titolo?: string | null, sottotitolo?: string | null, tempoLettura: any, previewImage?: string | null, url?: string | null, testo?: string | null, categoria?: { __typename?: 'CategoriaNewsNode', pk?: number | null, slug: string, alias: string, nome?: string | null } | null, listingVideos?: { __typename?: 'VideoNewsNode', idYoutube?: string | null } | null } | null> | null, categorie?: Array<{ __typename?: 'CategoriaNewsNode', pk?: number | null, nome?: string | null, url?: string | null, slug: string, isCatalogo?: boolean | null } | null> | null, categoria?: { __typename?: 'CategoriaNewsNode', pk?: number | null, slug: string, alias: string, nome?: string | null, descrizione?: string | null, isCatalogo?: boolean | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, mainImage?: string | null, descrizione?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null } | null } | null, root?: { __typename?: 'PaginaNode', url?: string | null } | null } | null };

export type NewsEmakInformaBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type NewsEmakInformaBySlugQuery = { __typename?: 'Query', newsEmakInformaBySlug?: { __typename?: 'NewsEmakInformaNode', mainImage?: string | null, model?: number | null, pk?: number | null, alias: string, titolo?: string | null, sottotitolo?: string | null, tempoLettura: any, previewImage?: string | null, url?: string | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null } | null, pagebuilders?: Array<{ __typename?: 'PagebuilderPlaceholderNode', key: string, text?: string | null, json_draft?: string | null, json_published?: string | null } | null> | null, correlati?: Array<{ __typename?: 'NewsEmakInformaNode', pk?: number | null, alias: string, titolo?: string | null, sottotitolo?: string | null, tempoLettura: any, previewImage?: string | null, url?: string | null } | null> | null } | null };

export type ListingNewsEmakInformaQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  params?: InputMaybe<Scalars['GenericScalar']>;
}>;


export type ListingNewsEmakInformaQuery = { __typename?: 'Query', listingNewsEmakInforma?: { __typename?: 'ListingNewsEmakInformaNode', paginator?: { __typename?: 'NewsPaginatorNode', currentPage?: number | null, numPages?: number | null, itemsPerPage?: number | null, count?: number | null, pages?: Array<{ __typename?: 'PageNode', href?: string | null, page?: string | null } | null> | null } | null, news?: Array<{ __typename?: 'NewsEmakInformaNode', pk?: number | null, alias: string, titolo?: string | null, sottotitolo?: string | null, tempoLettura: any, previewImage?: string | null, url?: string | null } | null> | null, root?: { __typename?: 'PaginaNode', url?: string | null } | null } | null };

export type Last3NewsQueryVariables = Exact<{ [key: string]: never; }>;


export type Last3NewsQuery = { __typename?: 'Query', last3News?: Array<{ __typename?: 'NewsNode', pk?: number | null, alias: string, titolo?: string | null, sottotitolo?: string | null, tempoLettura: any, previewImage?: string | null, url?: string | null, testo?: string | null, categoria?: { __typename?: 'CategoriaNewsNode', pk?: number | null, slug: string, alias: string, nome?: string | null } | null, listingVideos?: { __typename?: 'VideoNewsNode', idYoutube?: string | null } | null } | null> | null };

export type NewsletterSubscriptionMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type NewsletterSubscriptionMutation = { __typename?: 'Mutation', newsletterSubscription?: { __typename?: 'NewsletterSubscription', status?: boolean | null, message?: string | null } | null };

export type LandingNewsletterSubscriptionMutationVariables = Exact<{
  input: LandingNewsletterInput;
}>;


export type LandingNewsletterSubscriptionMutation = { __typename?: 'Mutation', landingNewsletterSubscription?: { __typename?: 'LandingNewsletterSubscription', status?: boolean | null, message?: string | null } | null };

export type OrdineCheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdineCheckoutQuery = { __typename?: 'Query', ordineCheckout?: { __typename?: 'OrdineNode', pk?: number | null, prezzoTotale?: number | null, codice?: string | null, created?: any | null, prezzoTotaleScontato: number, promozioneValorePercentuale: number, promozioneValoreAssoluto: number, promoCode?: string | null, scontoBundles: number, aliasScontoBundles?: string | null, promozione?: { __typename?: 'PromozioneNode', promoDipendenti?: boolean | null, codice?: string | null, valore?: number | null } | null, sistemaSpedizione?: { __typename?: 'SistemaSpedizioneNode', chiave?: string | null } | null, sistemaPagamento?: { __typename?: 'SistemaPagamentoNode', alias?: string | null } | null, rivenditore?: { __typename?: 'RivenditoreNode', email: string, indirizzo?: string | null, citta?: string | null, provincia?: string | null, ragioneSociale?: string | null, bonifico?: string | null } | null, righeOrdine?: Array<{ __typename?: 'RigaOrdineNode', omaggio: boolean, quantitaOrdinata: number, prezzoTotaleScontato: number, tipologia: OrdiniRigaOrdineTipologiaChoices, prodotto?: { __typename?: 'VarianteProdottoNode', prodotto?: { __typename?: 'ProdottoNode', notaRuote?: boolean | null, pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null } | null } | null> | null } | null };

export type OrdiniQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdiniQuery = { __typename?: 'Query', ordini?: { __typename?: 'OrdineNodeConnection', edges: Array<{ __typename?: 'OrdineNodeEdge', node?: { __typename?: 'OrdineNode', pk?: number | null, data?: string | null, created?: any | null, codice?: string | null, prezzoTotaleScontato: number, trackingUrl?: string | null, url?: string | null, stato: { __typename?: 'StatoNode', nome?: string | null, alias: string, chiave?: string | null }, sistemaSpedizione?: { __typename?: 'SistemaSpedizioneNode', nome?: string | null, chiave?: string | null } | null, righeOrdine?: Array<{ __typename?: 'RigaOrdineNode', pk?: number | null, tipologia: OrdiniRigaOrdineTipologiaChoices, prodotto?: { __typename?: 'VarianteProdottoNode', prodotto?: { __typename?: 'ProdottoNode', nome: string, previewImage?: string | null } | null } | null } | null> | null } | null } | null> } | null };

export type OrdineQueryVariables = Exact<{
  codice: Scalars['String'];
}>;


export type OrdineQuery = { __typename?: 'Query', ordine?: { __typename?: 'OrdineNode', pk?: number | null, data?: string | null, codice?: string | null, url?: string | null, rendibile?: boolean | null, trackingUrl?: string | null, prezzoTotale?: number | null, prezzoTotaleScontato: number, promozioneValoreAssoluto: number, rivenditore?: { __typename?: 'RivenditoreNode', ragioneSociale?: string | null, telefono?: string | null, email: string, url?: string | null } | null, indirizzoSpedizione?: { __typename?: 'IndirizzoNode', nome?: string | null, cognome?: string | null, indirizzo?: string | null, numeroCivico?: string | null, cap?: string | null, citta?: string | null, provincia?: string | null } | null, indirizzoFatturazione?: { __typename?: 'IndirizzoNode', nome?: string | null, cognome?: string | null, indirizzo?: string | null, numeroCivico?: string | null, cap?: string | null, citta?: string | null, provincia?: string | null } | null, sistemaSpedizione?: { __typename?: 'SistemaSpedizioneNode', nome?: string | null, chiave?: string | null } | null, sistemaPagamento?: { __typename?: 'SistemaPagamentoNode', nome?: string | null, famiglia?: { __typename?: 'FamigliaSistemaPagamentoNode', nome?: string | null } | null } | null, stato: { __typename?: 'StatoNode', nome?: string | null, alias: string, chiave?: string | null }, righeOrdine?: Array<{ __typename?: 'RigaOrdineNode', pk?: number | null, tipologia: OrdiniRigaOrdineTipologiaChoices, quantitaOrdinata: number, prezzoUnitario: number, prezzoUnitarioScontato: number, prezzoTotaleScontato: number, omaggio: boolean, prodotto?: { __typename?: 'VarianteProdottoNode', prodotto?: { __typename?: 'ProdottoNode', nome: string, promo?: boolean | null, pk?: number | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, codice?: string | null, disponibile?: boolean | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null } | null } | null } | null> | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null } | null } | null };

export type PaginaQueryVariables = Exact<{
  chiave?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  contentTypeId?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
  withChildren?: InputMaybe<Scalars['Boolean']>;
  withSiblings?: InputMaybe<Scalars['Boolean']>;
  includeSelf?: InputMaybe<Scalars['Boolean']>;
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type PaginaQuery = { __typename?: 'Query', pagina?: { __typename?: 'PaginaNode', pk?: number | null, model?: number | null, modelClass?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, url?: string | null, chiave?: string | null, mainImage?: string | null, previewImage?: string | null, template?: string | null, adminUrl?: string | null, visibile?: boolean | null, pubblicato?: boolean | null, visibilitaDal?: string | null, visibilitaAl?: string | null, testo?: string | null, intro?: string | null, ctaLabel?: string | null, ctaUrl?: string | null, children?: Array<{ __typename?: 'PaginaNode', pk?: number | null, titolo: string, nome?: string | null, mainImage?: string | null, previewImage?: string | null, url?: string | null, chiave?: string | null, descrizione?: string | null, icon?: string | null, modelClass?: string | null } | null> | null, siblings?: Array<{ __typename?: 'PaginaNode', pk?: number | null, titolo: string, nome?: string | null, mainImage?: string | null, previewImage?: string | null, url?: string | null, icon?: string | null } | null> | null, parent?: { __typename?: 'PaginaNode', titolo: string, url?: string | null, icon?: string | null } | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null } | null> | null, pagebuilders?: Array<{ __typename?: 'PagebuilderPlaceholderNode', key: string, text?: string | null, json_draft?: string | null, json_published?: string | null } | null> | null, categorie?: Array<{ __typename?: 'CategoriaNode', pk?: number | null, boxTitolo?: string | null, url?: string | null, previewImage?: string | null, depth: number, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, previewImage?: string | null } | null } | null> | null, categorieLanding?: Array<{ __typename?: 'CategoriaNode', pk?: number | null, nome: string, prodottiLanding?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null> | null } | null> | null } | null };

export type PaginaByPkQueryVariables = Exact<{
  pk: Scalars['Int'];
  withChildren?: InputMaybe<Scalars['Boolean']>;
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type PaginaByPkQuery = { __typename?: 'Query', paginaByPk?: { __typename?: 'PaginaNode', pk?: number | null, model?: number | null, modelClass?: string | null, titolo: string, nome?: string | null, descrizione?: string | null, url?: string | null, chiave?: string | null, mainImage?: string | null, previewImage?: string | null, template?: string | null, adminUrl?: string | null, visibile?: boolean | null, pubblicato?: boolean | null, visibilitaDal?: string | null, visibilitaAl?: string | null, testo?: string | null, children?: Array<{ __typename?: 'PaginaNode', pk?: number | null, titolo: string, nome?: string | null, mainImage?: string | null, previewImage?: string | null, url?: string | null, chiave?: string | null, descrizione?: string | null, icon?: string | null, modelClass?: string | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null } | null };

export type PagineCatchAllQueryVariables = Exact<{ [key: string]: never; }>;


export type PagineCatchAllQuery = { __typename?: 'Query', pagine?: { __typename?: 'PaginaNodeConnection', edges: Array<{ __typename?: 'PaginaNodeEdge', node?: { __typename?: 'PaginaNode', path?: string | null, slug?: string | null } | null } | null> } | null };

export type ProdottoCardFragment = { __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null };

export type PrezziProdottiQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type PrezziProdottiQuery = { __typename?: 'Query', prezziProdotti?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, prezzoUnitario?: number | null, prezzo?: number | null, prezzoScontato?: number | null, prezzoOmnibus?: number | null, inPromoBundle?: boolean | null } | null> | null };

export type ProdottiTendinaQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type ProdottiTendinaQuery = { __typename?: 'Query', prodottiTendina?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, showTaglia?: boolean | null, showFormato?: boolean | null, prodottiTendina?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, labelTendina?: string | null, rif?: string | null, url?: string | null, prezzoUnitario?: number | null, prezzoScontato?: number | null, prezzo?: number | null } | null> | null } | null> | null };

export type ProdottoCardQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type ProdottoCardQuery = { __typename?: 'Query', prodottoByPk?: { __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null };

export type ProdottiComparatoreQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type ProdottiComparatoreQuery = { __typename?: 'Query', prodottiByIds?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, nome: string, previewImage?: string | null, url?: string | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoScontato?: number | null, attributi?: Array<{ __typename?: 'AttributoMultiploType', chiave?: string | null, valori?: Array<{ __typename?: 'ValoreAttributoNode', pk?: number | null, nome: string, image?: string | null, attributo?: { __typename?: 'AttributoNode', nome: string } | null } | null> | null } | null> | null } | null> | null };

export type ChangeProdottoCardQueryVariables = Exact<{
  pk: Scalars['Int'];
  ids: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type ChangeProdottoCardQuery = { __typename?: 'Query', prodottoByPk?: { __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null, prezziProdotti?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, prezzoUnitario?: number | null, prezzo?: number | null, prezzoScontato?: number | null, prezzoOmnibus?: number | null, inPromoBundle?: boolean | null } | null> | null };

export type ProdottiQueryVariables = Exact<{ [key: string]: never; }>;


export type ProdottiQuery = { __typename?: 'Query', prodotti?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, alias: string, codice?: string | null, slug: string } | null> | null };

export type ProdottoQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProdottoQuery = { __typename?: 'Query', prodotto?: { __typename?: 'ProdottoNode', descrizioneBreve?: string | null, descrizione?: string | null, peso?: number | null, rif?: string | null, adminUrl?: string | null, modelClass?: string | null, isAccessorio?: boolean | null, isAbbigliamento?: boolean | null, showGuidaTaglie?: boolean | null, notaRuote?: boolean | null, isLubrificante?: boolean | null, pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, detailImages?: Array<{ __typename?: 'ImmagineProdottoType', pk?: number | null, image?: string | null } | null> | null, videoImages?: Array<{ __typename?: 'ImmagineProdottoType', pk?: number | null, descrizione?: string | null } | null> | null, attributi?: Array<{ __typename?: 'AttributoMultiploType', chiave?: string | null, valori?: Array<{ __typename?: 'ValoreAttributoNode', pk?: number | null, nome: string, image?: string | null, parent?: { __typename?: 'ValoreAttributoNode', pk?: number | null } | null, attributo?: { __typename?: 'AttributoNode', nome: string } | null } | null> | null } | null> | null, use?: { __typename?: 'ValoreAttributoNode', pk?: number | null, nome: string, image?: string | null } | null, documenti?: Array<{ __typename?: 'DocumentoProdottoNode', pk?: number | null, nomeDocumento?: string | null, url?: string | null, lingue?: Array<{ __typename?: 'LinguaDocumentoProdottoNode', codice?: string | null } | null> | null } | null> | null, plusPoints?: Array<{ __typename?: 'PlusPointNode', pk?: number | null, titolo?: string | null, descrizione: string, immagine?: string | null } | null> | null, volantini?: Array<{ __typename?: 'VolantinoNode', pk?: number | null, intro?: string | null, immagine?: string | null, url?: string | null } | null> | null, tabellaMotori?: { __typename?: 'DescrizioneAggiuntivaProdottoNode', testo?: string | null } | null, categorieCorrelate?: Array<{ __typename?: 'CategoriaNode', boxTitolo?: string | null, url?: string | null } | null> | null, prodottiCompatibili?: Array<{ __typename?: 'ProdottoNode', nome: string, url?: string | null, categoriaCompatibili?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, nome: string } | null } | null> | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null } | null, suggestedForYou?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null> | null, boughtTogether?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null> | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null } | null };

export type PromoBundleProdottoQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type PromoBundleProdottoQuery = { __typename?: 'Query', prodottoByPk?: { __typename?: 'ProdottoNode', promoBundle?: { __typename?: 'PromozioneNode', pk?: number | null, valore?: number | null, descrizioneProdotto?: string | null, prodottiBundle?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, nome: string, previewImage?: string | null, descrizioneBreve?: string | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null } | null> | null } | null } | null };

export type LastPromoPopupQueryVariables = Exact<{ [key: string]: never; }>;


export type LastPromoPopupQuery = { __typename?: 'Query', lastPromoPopup?: { __typename?: 'PopupNode', pk?: number | null, titolo?: string | null, descrizione?: string | null, image?: string | null, mobileImage?: string | null, ctaLabel1?: string | null, ctaLabel2?: string | null, url1?: string | null, url2?: string | null, linkedObjectId1?: number | null, linkedObjectId2?: number | null } | null };

export type MotivazioniResoQueryVariables = Exact<{ [key: string]: never; }>;


export type MotivazioniResoQuery = { __typename?: 'Query', motivazioniReso?: Array<{ __typename?: 'MotivazioneResoNode', pk?: number | null, nome?: string | null } | null> | null };

export type RichiediResoMutationVariables = Exact<{
  richiestaReso: RichiediResoInput;
}>;


export type RichiediResoMutation = { __typename?: 'Mutation', richiediReso?: { __typename?: 'RichiediReso', message?: string | null, status?: number | null } | null };

export type MotivazioniNazioniQueryVariables = Exact<{ [key: string]: never; }>;


export type MotivazioniNazioniQuery = { __typename?: 'Query', motivazioniNazioni?: { __typename?: 'MotivazioniNazioniNode', motivazioniContattoCustom?: Array<{ __typename?: 'MotivazioneContattoCustomNode', pk?: number | null, nome?: string | null, descrizione?: string | null } | null> | null, nazioni?: Array<{ __typename?: 'NazioneNode', pk?: number | null, nome?: string | null } | null> | null } | null };

export type CreateContattoCustomMutationVariables = Exact<{
  contattoInput: CreateContattoInput;
}>;


export type CreateContattoCustomMutation = { __typename?: 'Mutation', createContattoCustom?: { __typename?: 'CreateContattoCustom', status?: boolean | null, message?: string | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UtenteNode', pk?: number | null, email: string, nome?: string | null, cognome?: string | null, isStaff: boolean, edit?: boolean | null, showToolbar?: boolean | null, isImpersonate?: boolean | null, isRivenditore?: boolean | null, cf?: string | null, piva?: string | null, guest: boolean, privato: boolean, progressoProfilo?: number | null, dateJoined: any, dataPrimoOrdine?: string | null, dataUltimoOrdine?: string | null, numeroProdottiWishlist?: number | null, indirizziFatturazione?: Array<{ __typename?: 'IndirizzoNode', pk?: number | null, nome?: string | null, cognome?: string | null, indirizzo?: string | null, note?: string | null, provincia?: string | null, citta?: string | null, cap?: string | null, telefono?: string | null, isDefault: boolean, isFatturazione: boolean, nazione: { __typename?: 'NazioneNode', pk?: number | null, nome?: string | null, isoCode: string } } | null> | null, indirizziSpedizione?: Array<{ __typename?: 'IndirizzoNode', pk?: number | null, nome?: string | null, cognome?: string | null, indirizzo?: string | null, provincia?: string | null, note?: string | null, citta?: string | null, cap?: string | null, telefono?: string | null, isDefault: boolean, isFatturazione: boolean, nazione: { __typename?: 'NazioneNode', pk?: number | null, nome?: string | null, isoCode: string } } | null> | null } | null };

export type DashboardUtenteQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardUtenteQuery = { __typename?: 'Query', me?: { __typename?: 'UtenteNode', pk?: number | null, nome?: string | null, progressoProfilo?: number | null, cognome?: string | null, cf?: string | null, ragioneSociale?: string | null, piva?: string | null, sdi?: string | null, pec?: string | null, professionista: boolean, dataDiNascita?: any | null, ultimoOrdine?: { __typename?: 'OrdineNode', id: string, pk?: number | null, codice?: string | null, created?: any | null, prezzoTotaleScontato: number, trackingUrl?: string | null, url?: string | null, stato: { __typename?: 'StatoNode', pk?: number | null, nome?: string | null }, sistemaSpedizione?: { __typename?: 'SistemaSpedizioneNode', nome?: string | null, chiave?: string | null } | null, righeOrdine?: Array<{ __typename?: 'RigaOrdineNode', prodotto?: { __typename?: 'VarianteProdottoNode', prodotto?: { __typename?: 'ProdottoNode', previewImage?: string | null } | null } | null } | null> | null } | null, interessi: Array<{ __typename?: 'InteresseNewsletterNode', pk?: number | null }> } | null };

export type ProfiloUtenteQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfiloUtenteQuery = { __typename?: 'Query', me?: { __typename?: 'UtenteNode', pk?: number | null, progressoProfilo?: number | null, email: string, nome?: string | null, cognome?: string | null, privato: boolean, cf?: string | null, ragioneSociale?: string | null, piva?: string | null, sdi?: string | null, pec?: string | null, professionista: boolean, dataDiNascita?: any | null, interessi: Array<{ __typename?: 'InteresseNewsletterNode', pk?: number | null }> } | null };

export type PrivacyUtenteQueryVariables = Exact<{ [key: string]: never; }>;


export type PrivacyUtenteQuery = { __typename?: 'Query', me?: { __typename?: 'UtenteNode', pk?: number | null, consensoMkt: boolean, consensoProfilazione: boolean } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'Logout', status?: boolean | null } | null };

export type LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', tokenAuth?: { __typename?: 'ObtainJSONWebToken', token: string, user?: { __typename?: 'UtenteNode', pk?: number | null, nome?: string | null, cognome?: string | null, email: string } | null } | null };

export type SocialAuthMutationVariables = Exact<{
  provider: Scalars['String'];
  accessToken: Scalars['String'];
}>;


export type SocialAuthMutation = { __typename?: 'Mutation', socialAuth?: { __typename?: 'SocialAuthMutation', token?: string | null, user?: { __typename?: 'UtenteNode', id: string } | null } | null };

export type CreateUtenteMutationVariables = Exact<{
  input: SignInInput;
}>;


export type CreateUtenteMutation = { __typename?: 'Mutation', createUtente?: { __typename?: 'CreateUtente', message?: string | null, status?: boolean | null, statusCode?: number | null, utente?: { __typename?: 'UtenteNode', id: string, email: string, nome?: string | null, cognome?: string | null, ragioneSociale?: string | null } | null } | null };

export type InteresseUtenteQueryVariables = Exact<{ [key: string]: never; }>;


export type InteresseUtenteQuery = { __typename?: 'Query', interessiUtente?: Array<{ __typename?: 'InteresseNewsletterNode', pk?: number | null, alias?: string | null, descrizione?: string | null } | null> | null };

export type CompleteSignInMutationVariables = Exact<{
  professionista?: InputMaybe<Scalars['Boolean']>;
  birthdate?: InputMaybe<Scalars['String']>;
  ambienteLavoro?: InputMaybe<Scalars['Int']>;
}>;


export type CompleteSignInMutation = { __typename?: 'Mutation', completeSignIn?: { __typename?: 'CompleteSignIn', status?: boolean | null, message?: string | null } | null };

export type RecuperaPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RecuperaPasswordMutation = { __typename?: 'Mutation', recuperaPassword?: { __typename?: 'RecuperaPassword', status?: boolean | null, statusCode?: number | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPassword', status?: boolean | null, statusCode?: number | null } | null };

export type MyAccountEditMutationVariables = Exact<{
  input: UtenteInput;
}>;


export type MyAccountEditMutation = { __typename?: 'Mutation', myAccountEdit?: { __typename?: 'MyAccountEdit', status?: boolean | null, message?: string | null } | null };

export type MyAccountChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type MyAccountChangePasswordMutation = { __typename?: 'Mutation', myAccountChangePassword?: { __typename?: 'MyAccountChangePassword', status?: boolean | null, message?: string | null } | null };

export type MyAccountSetIndirizzoDefaultMutationVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type MyAccountSetIndirizzoDefaultMutation = { __typename?: 'Mutation', myAccountSetIndirizzoDefault?: { __typename?: 'MyAccountSetIndirizzoDefault', status?: boolean | null, message?: string | null } | null };

export type MyAccountDeleteIndirizzoMutationVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type MyAccountDeleteIndirizzoMutation = { __typename?: 'Mutation', myAccountDeleteIndirizzo?: { __typename?: 'MyAccountDeleteIndirizzo', status?: boolean | null, message?: string | null } | null };

export type DeleteUtenteMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUtenteMutation = { __typename?: 'Mutation', deleteUtente?: { __typename?: 'DeleteUtente', message?: string | null } | null };

export type GaranzieUtenteQueryVariables = Exact<{ [key: string]: never; }>;


export type GaranzieUtenteQuery = { __typename?: 'Query', garanzieUtente?: Array<{ __typename?: 'WarrantyNode', pk?: number | null, numeroSerie: string, created?: any | null, dataScadenza?: any | null, productRegistrationId: string, prodotto?: { __typename?: 'ProdottoWarrantyNode', nome?: string | null, categoria?: { __typename?: 'CategoriaWarrantyNode', nome?: string | null } | null } | null } | null> | null };

export type VideoQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type VideoQuery = { __typename?: 'Query', video?: { __typename?: 'VideoTutorialNode', pk?: number | null, titolo?: string | null, sottotitolo?: string | null, idYoutube?: string | null, adminUrl?: string | null, modelClass?: string | null, model?: number | null, categoria?: { __typename?: 'CategoriaVideoTutorialNode', nome?: string | null } | null, correlati?: Array<{ __typename?: 'VideoTutorialNode', titolo?: string | null, url?: string | null, idYoutube?: string | null, categoria?: { __typename?: 'CategoriaVideoTutorialNode', nome?: string | null } | null } | null> | null, pagebuilders?: Array<{ __typename?: 'PagebuilderPlaceholderNode', key: string, text?: string | null, json_draft?: string | null, json_published?: string | null } | null> | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null } | null> | null } | null } | null };

export type ListingVideoTutorialQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  params?: InputMaybe<Scalars['GenericScalar']>;
}>;


export type ListingVideoTutorialQuery = { __typename?: 'Query', listingVideoTutorial?: { __typename?: 'ListingVideoTutorialNode', canonicalUrl?: string | null, paginator?: { __typename?: 'NewsPaginatorNode', currentPage?: number | null, numPages?: number | null, itemsPerPage?: number | null, count?: number | null, pages?: Array<{ __typename?: 'PageNode', href?: string | null, page?: string | null } | null> | null } | null, videos?: Array<{ __typename?: 'VideoTutorialNode', pk?: number | null, titolo?: string | null, sottotitolo?: string | null, idYoutube?: string | null, adminUrl?: string | null, modelClass?: string | null, url?: string | null, model?: number | null, categoria?: { __typename?: 'CategoriaVideoTutorialNode', nome?: string | null } | null } | null> | null, categorie?: Array<{ __typename?: 'CategoriaVideoTutorialNode', pk?: number | null, nome?: string | null, url?: string | null, slug?: string | null } | null> | null, categoria?: { __typename?: 'CategoriaVideoTutorialNode', pk?: number | null, slug?: string | null, alias: string, nome?: string | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, mainImage?: string | null, descrizione?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null } | null } | null, root?: { __typename?: 'PaginaNode', url?: string | null } | null } | null };

export type VolantinoCardFragment = { __typename?: 'VolantinoNode', pk?: number | null, intro?: string | null, descrizione?: string | null, immagine?: string | null, pdfUrl?: string | null, sottocategorie?: Array<{ __typename?: 'CategoriaNode', nome: string, slug: string, descrizioneVolantino?: string | null, immaginiVolantinoDigitale?: Array<string | null> | null, immagineVolantino?: string | null } | null> | null };

export type VolantinoQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type VolantinoQuery = { __typename?: 'Query', volantino?: { __typename?: 'VolantinoNode', adminUrl?: string | null, modelClass?: string | null, pk?: number | null, intro?: string | null, descrizione?: string | null, immagine?: string | null, pdfUrl?: string | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null } | null> | null } | null, sottocategorie?: Array<{ __typename?: 'CategoriaNode', nome: string, slug: string, descrizioneVolantino?: string | null, immaginiVolantinoDigitale?: Array<string | null> | null, immagineVolantino?: string | null } | null> | null } | null };

export type SottocategoriaVolantinoQueryVariables = Exact<{
  slugVolantino: Scalars['String'];
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type SottocategoriaVolantinoQuery = { __typename?: 'Query', sottocategoriaVolantino?: { __typename?: 'CategoriaNode', nome: string, slug: string, descrizioneVolantino?: string | null, immagineVolantino?: string | null, pdfUrl?: string | null, plusPoints?: Array<{ __typename?: 'PlusPointNode', titolo?: string | null, descrizione: string, immagine?: string | null } | null> | null, tabellaDatiTecnici?: { __typename?: 'TabellaDatiTecniciNode', attributi?: Array<string | null> | null, prodotti?: Array<{ __typename?: 'DatiTecniciProdottoNode', valori?: Array<string | null> | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null } | null> | null } | null, accessoriCompatibili?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null> | null, volantinoVisualizzato?: { __typename?: 'VolantinoNode', slug: string, intro?: string | null, titolo: string, descrizione?: string | null, immagine?: string | null, url?: string | null, pdfUrl?: string | null, pagina?: { __typename?: 'PaginaNode', seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null } | null } | null } | null, tabellaCompatibilita?: Array<{ __typename?: 'TabellaCompatibilitaCategoriaNode', nome?: string | null, descrizione?: string | null, dati?: Array<{ __typename?: 'CompatibilitaGruppoNode', image?: string | null, products?: Array<{ __typename?: 'CompatibilitaProdottoNode', nome?: string | null, rif?: string | null, compatibilita?: Array<string | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type VolantinoPdfQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type VolantinoPdfQuery = { __typename?: 'Query', volantino?: { __typename?: 'VolantinoNode', adminUrl?: string | null, modelClass?: string | null, pk?: number | null, intro?: string | null, descrizione?: string | null, immagine?: string | null, pdfUrl?: string | null, sottocategorie?: Array<{ __typename?: 'CategoriaNode', nome: string, slug: string, descrizioneVolantino?: string | null, immaginiVolantinoDigitale?: Array<string | null> | null, immagineVolantino?: string | null, plusPoints?: Array<{ __typename?: 'PlusPointNode', titolo?: string | null, descrizione: string, immagine?: string | null } | null> | null, tabellaDatiTecnici?: { __typename?: 'TabellaDatiTecniciNode', attributi?: Array<string | null> | null, prodotti?: Array<{ __typename?: 'DatiTecniciProdottoNode', valori?: Array<string | null> | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null } | null> | null } | null } | null> | null, tabellaCompatibilita?: Array<{ __typename?: 'TabellaCompatibilitaCategoriaNode', nome?: string | null, descrizione?: string | null, dati?: Array<{ __typename?: 'CompatibilitaGruppoNode', image?: string | null, products?: Array<{ __typename?: 'CompatibilitaProdottoNode', nome?: string | null, rif?: string | null, compatibilita?: Array<string | null> | null, prodotti?: Array<string | null> | null } | null> | null } | null> | null } | null> | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', label?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null, noindex?: boolean | null, canonicalUrl?: string | null } | null, hreflangs?: Array<{ __typename?: 'HrefLangType', hrefLang?: string | null, href?: string | null } | null> | null } | null } | null };

export type WishlistQueryVariables = Exact<{ [key: string]: never; }>;


export type WishlistQuery = { __typename?: 'Query', wishlist?: { __typename?: 'WishlistNode', items?: Array<{ __typename?: 'RigaWishlistNode', prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, codice?: string | null, nome: string, previewImage?: string | null, url?: string | null, promo?: boolean | null, lancio: boolean, novita?: boolean | null, utilizzo?: string | null, disponibile?: boolean | null, details?: Array<string | null> | null, prezzo?: number | null, prezzoUnitario?: number | null, prezzoOmnibus?: number | null, prezzoScontato?: number | null, categoria?: { __typename?: 'CategoriaNode', alias: string, boxTitolo?: string | null, url?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null, parent?: { __typename?: 'CategoriaNode', boxTitolo?: string | null } | null } | null } | null } | null, stato?: { __typename?: 'StatoProdottoNode', codice: string, azione?: ProdottiStatoProdottoAzioneChoices | null, acquistabile: boolean } | null, valuta?: { __typename?: 'ValutaNode', isoCode: string, simbolo: string } | null } | null } | null> | null } | null };

export type WishlistButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type WishlistButtonQuery = { __typename?: 'Query', wishlist?: { __typename?: 'WishlistNode', items?: Array<{ __typename?: 'RigaWishlistNode', prodotto?: { __typename?: 'ProdottoNode', pk?: number | null } | null } | null> | null } | null };

export type AddWishlistItemMutationVariables = Exact<{
  idProdotto: Scalars['Int'];
}>;


export type AddWishlistItemMutation = { __typename?: 'Mutation', addWishlistItem?: { __typename?: 'AddWishlistItem', status?: boolean | null, message?: string | null } | null };

export type RemoveWishlistItemMutationVariables = Exact<{
  idProdotto: Scalars['Int'];
}>;


export type RemoveWishlistItemMutation = { __typename?: 'Mutation', removeWishlistItem?: { __typename?: 'RemoveWishlistItem', status?: boolean | null, message?: string | null } | null };

export const NewsCardFragmentDoc = gql`
    fragment NewsCard on NewsNode {
  pk
  alias
  titolo
  sottotitolo
  tempoLettura
  previewImage
  url
  testo
  categoria {
    pk
    slug
    alias
    nome
  }
  listingVideos {
    idYoutube
  }
}
    `;
export const NewsEmakInformaCardFragmentDoc = gql`
    fragment NewsEmakInformaCard on NewsEmakInformaNode {
  pk
  alias
  titolo
  sottotitolo
  tempoLettura
  previewImage
  url
}
    `;
export const ProdottoCardFragmentDoc = gql`
    fragment ProdottoCard on ProdottoNode {
  pk
  codice
  nome
  previewImage
  url
  promo
  lancio
  novita
  utilizzo
  disponibile
  details
  prezzo
  prezzoUnitario
  prezzoOmnibus
  prezzoScontato
  categoria {
    alias
    boxTitolo
    url
    parent {
      boxTitolo
      parent {
        boxTitolo
        parent {
          boxTitolo
        }
      }
    }
  }
  stato {
    codice
    azione
    acquistabile
  }
  valuta {
    isoCode
    simbolo
  }
}
    `;
export const VolantinoCardFragmentDoc = gql`
    fragment VolantinoCard on VolantinoNode {
  pk
  intro
  descrizione
  immagine
  pdfUrl
  sottocategorie {
    nome
    slug
    descrizioneVolantino
    immaginiVolantinoDigitale
    immagineVolantino
  }
}
    `;
export const CreateAdesioneB2CDocument = gql`
    mutation CreateAdesioneB2C($adesioneInput: CreateAdesioneB2CInput!) {
  createAdesioneB2c(adesioneInput: $adesioneInput) {
    status
    message
  }
}
    `;
export type CreateAdesioneB2CMutationFn = Apollo.MutationFunction<CreateAdesioneB2CMutation, CreateAdesioneB2CMutationVariables>;

/**
 * __useCreateAdesioneB2CMutation__
 *
 * To run a mutation, you first call `useCreateAdesioneB2CMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdesioneB2CMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdesioneB2CMutation, { data, loading, error }] = useCreateAdesioneB2CMutation({
 *   variables: {
 *      adesioneInput: // value for 'adesioneInput'
 *   },
 * });
 */
export function useCreateAdesioneB2CMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdesioneB2CMutation, CreateAdesioneB2CMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdesioneB2CMutation, CreateAdesioneB2CMutationVariables>(CreateAdesioneB2CDocument, options);
      }
export type CreateAdesioneB2CMutationHookResult = ReturnType<typeof useCreateAdesioneB2CMutation>;
export type CreateAdesioneB2CMutationResult = Apollo.MutationResult<CreateAdesioneB2CMutation>;
export type CreateAdesioneB2CMutationOptions = Apollo.BaseMutationOptions<CreateAdesioneB2CMutation, CreateAdesioneB2CMutationVariables>;
export const AddItemDocument = gql`
    mutation AddItem($idProdotto: Int!, $quantita: Int!) {
  addItem(idProdotto: $idProdotto, quantita: $quantita) {
    status
    message
  }
}
    `;
export type AddItemMutationFn = Apollo.MutationFunction<AddItemMutation, AddItemMutationVariables>;

/**
 * __useAddItemMutation__
 *
 * To run a mutation, you first call `useAddItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemMutation, { data, loading, error }] = useAddItemMutation({
 *   variables: {
 *      idProdotto: // value for 'idProdotto'
 *      quantita: // value for 'quantita'
 *   },
 * });
 */
export function useAddItemMutation(baseOptions?: Apollo.MutationHookOptions<AddItemMutation, AddItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemMutation, AddItemMutationVariables>(AddItemDocument, options);
      }
export type AddItemMutationHookResult = ReturnType<typeof useAddItemMutation>;
export type AddItemMutationResult = Apollo.MutationResult<AddItemMutation>;
export type AddItemMutationOptions = Apollo.BaseMutationOptions<AddItemMutation, AddItemMutationVariables>;
export const CartDocument = gql`
    query Cart {
  cart {
    totaleScontato
    prezzo
    scontoAssoluto
    hasOmaggio
    items {
      prodotto {
        prodotto {
          ...ProdottoCard
          promoApplicata {
            pk
            codice
            alias
            titolo
            descrizione
            valore
            percentuale
            promoDipendenti
          }
        }
      }
      omaggio
      quantita
    }
    promoApplicata {
      pk
      codice
      alias
      titolo
      descrizione
      valore
      percentuale
      promoDipendenti
    }
    correlati {
      ...ProdottoCard
    }
    scontoBundles {
      scontoAssoluto
      promoApplicata {
        alias
      }
    }
  }
}
    ${ProdottoCardFragmentDoc}`;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartQuery(baseOptions?: Apollo.QueryHookOptions<CartQuery, CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const RemoveItemDocument = gql`
    mutation RemoveItem($idProdotto: Int!, $omaggio: Boolean!) {
  removeItem(idProdotto: $idProdotto, omaggio: $omaggio) {
    status
    message
  }
}
    `;
export type RemoveItemMutationFn = Apollo.MutationFunction<RemoveItemMutation, RemoveItemMutationVariables>;

/**
 * __useRemoveItemMutation__
 *
 * To run a mutation, you first call `useRemoveItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemMutation, { data, loading, error }] = useRemoveItemMutation({
 *   variables: {
 *      idProdotto: // value for 'idProdotto'
 *      omaggio: // value for 'omaggio'
 *   },
 * });
 */
export function useRemoveItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemMutation, RemoveItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveItemMutation, RemoveItemMutationVariables>(RemoveItemDocument, options);
      }
export type RemoveItemMutationHookResult = ReturnType<typeof useRemoveItemMutation>;
export type RemoveItemMutationResult = Apollo.MutationResult<RemoveItemMutation>;
export type RemoveItemMutationOptions = Apollo.BaseMutationOptions<RemoveItemMutation, RemoveItemMutationVariables>;
export const SetPromoCodeDocument = gql`
    mutation SetPromoCode($promoCode: String!) {
  setPromoCode(promoCode: $promoCode) {
    status
    message
  }
}
    `;
export type SetPromoCodeMutationFn = Apollo.MutationFunction<SetPromoCodeMutation, SetPromoCodeMutationVariables>;

/**
 * __useSetPromoCodeMutation__
 *
 * To run a mutation, you first call `useSetPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPromoCodeMutation, { data, loading, error }] = useSetPromoCodeMutation({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useSetPromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<SetPromoCodeMutation, SetPromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPromoCodeMutation, SetPromoCodeMutationVariables>(SetPromoCodeDocument, options);
      }
export type SetPromoCodeMutationHookResult = ReturnType<typeof useSetPromoCodeMutation>;
export type SetPromoCodeMutationResult = Apollo.MutationResult<SetPromoCodeMutation>;
export type SetPromoCodeMutationOptions = Apollo.BaseMutationOptions<SetPromoCodeMutation, SetPromoCodeMutationVariables>;
export const RemovePromoCodeDocument = gql`
    mutation RemovePromoCode {
  removePromoCode {
    status
    message
  }
}
    `;
export type RemovePromoCodeMutationFn = Apollo.MutationFunction<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>;

/**
 * __useRemovePromoCodeMutation__
 *
 * To run a mutation, you first call `useRemovePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePromoCodeMutation, { data, loading, error }] = useRemovePromoCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemovePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>(RemovePromoCodeDocument, options);
      }
export type RemovePromoCodeMutationHookResult = ReturnType<typeof useRemovePromoCodeMutation>;
export type RemovePromoCodeMutationResult = Apollo.MutationResult<RemovePromoCodeMutation>;
export type RemovePromoCodeMutationOptions = Apollo.BaseMutationOptions<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>;
export const ChangeItemSizeDocument = gql`
    mutation ChangeItemSize($idProdottoNew: Int, $idProdottoOld: Int, $omaggio: Boolean) {
  changeItemSize(
    idProdottoNew: $idProdottoNew
    idProdottoOld: $idProdottoOld
    omaggio: $omaggio
  ) {
    status
    message
  }
}
    `;
export type ChangeItemSizeMutationFn = Apollo.MutationFunction<ChangeItemSizeMutation, ChangeItemSizeMutationVariables>;

/**
 * __useChangeItemSizeMutation__
 *
 * To run a mutation, you first call `useChangeItemSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeItemSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeItemSizeMutation, { data, loading, error }] = useChangeItemSizeMutation({
 *   variables: {
 *      idProdottoNew: // value for 'idProdottoNew'
 *      idProdottoOld: // value for 'idProdottoOld'
 *      omaggio: // value for 'omaggio'
 *   },
 * });
 */
export function useChangeItemSizeMutation(baseOptions?: Apollo.MutationHookOptions<ChangeItemSizeMutation, ChangeItemSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeItemSizeMutation, ChangeItemSizeMutationVariables>(ChangeItemSizeDocument, options);
      }
export type ChangeItemSizeMutationHookResult = ReturnType<typeof useChangeItemSizeMutation>;
export type ChangeItemSizeMutationResult = Apollo.MutationResult<ChangeItemSizeMutation>;
export type ChangeItemSizeMutationOptions = Apollo.BaseMutationOptions<ChangeItemSizeMutation, ChangeItemSizeMutationVariables>;
export const HomeDataDocument = gql`
    query HomeData {
  categorie(inHome: true) {
    edges {
      node {
        pk
        boxTitolo
        url
        previewImage
      }
    }
  }
  prodottiTopDelMese {
    pk
    boxTitolo
    prodottiTopDelMese {
      ...ProdottoCard
    }
  }
}
    ${ProdottoCardFragmentDoc}`;

/**
 * __useHomeDataQuery__
 *
 * To run a query within a React component, call `useHomeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeDataQuery(baseOptions?: Apollo.QueryHookOptions<HomeDataQuery, HomeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeDataQuery, HomeDataQueryVariables>(HomeDataDocument, options);
      }
export function useHomeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeDataQuery, HomeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeDataQuery, HomeDataQueryVariables>(HomeDataDocument, options);
        }
export type HomeDataQueryHookResult = ReturnType<typeof useHomeDataQuery>;
export type HomeDataLazyQueryHookResult = ReturnType<typeof useHomeDataLazyQuery>;
export type HomeDataQueryResult = Apollo.QueryResult<HomeDataQuery, HomeDataQueryVariables>;
export const CategoriaDocument = gql`
    query Categoria($path: String!, $preview: Boolean) {
  categoria(path: $path, preview: $preview) {
    pk
    nome
    descrizione
    guidaBreve
    guidaDettagliata
    sottoTitolo
    url
    mainImage
    depth
    template
    adminUrl
    model
    boxTitolo
    alias
    modelClass
    offertaMarketingBox {
      intro
      helper
      name: titolo
      description: testo
      image
      url
      ctaLabel
    }
    parent {
      pk
      nome
      url
      alias
      boxTitolo
      parent {
        boxTitolo
        parent {
          boxTitolo
        }
      }
    }
    children {
      pk
      nome
      url
      previewImage
      depth
      numeroProdotti
    }
    siblings {
      pk
      nome
      url
    }
    pagina {
      adminUrl
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
        canonicalUrl
        h1
      }
      hreflangs {
        hrefLang
        href
      }
    }
  }
}
    `;

/**
 * __useCategoriaQuery__
 *
 * To run a query within a React component, call `useCategoriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriaQuery({
 *   variables: {
 *      path: // value for 'path'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useCategoriaQuery(baseOptions: Apollo.QueryHookOptions<CategoriaQuery, CategoriaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriaQuery, CategoriaQueryVariables>(CategoriaDocument, options);
      }
export function useCategoriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriaQuery, CategoriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriaQuery, CategoriaQueryVariables>(CategoriaDocument, options);
        }
export type CategoriaQueryHookResult = ReturnType<typeof useCategoriaQuery>;
export type CategoriaLazyQueryHookResult = ReturnType<typeof useCategoriaLazyQuery>;
export type CategoriaQueryResult = Apollo.QueryResult<CategoriaQuery, CategoriaQueryVariables>;
export const CategorieDocument = gql`
    query Categorie {
  categorie {
    edges {
      node {
        pk
        path
      }
    }
  }
}
    `;

/**
 * __useCategorieQuery__
 *
 * To run a query within a React component, call `useCategorieQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieQuery(baseOptions?: Apollo.QueryHookOptions<CategorieQuery, CategorieQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieQuery, CategorieQueryVariables>(CategorieDocument, options);
      }
export function useCategorieLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieQuery, CategorieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieQuery, CategorieQueryVariables>(CategorieDocument, options);
        }
export type CategorieQueryHookResult = ReturnType<typeof useCategorieQuery>;
export type CategorieLazyQueryHookResult = ReturnType<typeof useCategorieLazyQuery>;
export type CategorieQueryResult = Apollo.QueryResult<CategorieQuery, CategorieQueryVariables>;
export const CheckoutDocument = gql`
    query Checkout {
  checkout {
    totaleSenzaPromozioni
    scontoAssoluto
    totaleScontato
    scontoPercentuale
    totaleScontatoNetto
    totaleProdottiScontato
    items {
      prodotto {
        prodotto {
          ...ProdottoCard
        }
      }
      quantita
    }
    promoApplicata {
      pk
      codice
      alias
      titolo
      descrizione
      valore
      percentuale
      promoDipendenti
    }
    sistemiSpedizione {
      pk
      alias
      chiave
      nome
      descrizione
      descrizioneEstesa
      prezzo
      prezzoScontato
      scontoPercentuale
      scontoAssoluto
      promoApplicata {
        pk
        codice
        alias
        titolo
        descrizione
        valore
        percentuale
      }
    }
    sistemaSpedizione {
      pk
      alias
      chiave
      nome
      descrizione
      descrizioneEstesa
      prezzo
      prezzoScontato
      scontoPercentuale
      scontoAssoluto
      promoApplicata {
        pk
        codice
        alias
        titolo
        descrizione
        valore
        percentuale
      }
    }
    sistemaPagamento {
      pk
      alias
      nome
      descrizione
    }
    indirizzoSpedizione {
      pk
      nome
      cognome
      indirizzo
      provincia
      note
      citta
      cap
      telefono
    }
    indirizzoFatturazione {
      pk
      nome
      cognome
      indirizzo
      provincia
      note
      citta
      cap
      telefono
    }
    sistemiPagamento {
      pk
      descrizione
      rivenditore {
        pk
      }
      famiglia {
        nome
        chiave
      }
    }
    rivenditori {
      ragioneSociale
      indirizzo
      citta
      provincia
      longitudine
      latitudine
      pk
      sistemiPagamento {
        pk
        alias
        nome
        descrizione
        famiglia {
          nome
        }
      }
    }
    rivenditore {
      ragioneSociale
      pk
      indirizzo
      citta
      provincia
      sistemiPagamentoGrouped {
        pk
        descrizione
        rivenditore {
          pk
        }
        famiglia {
          nome
          chiave
        }
      }
    }
    scontoBundles {
      scontoAssoluto
      promoApplicata {
        alias
      }
    }
  }
}
    ${ProdottoCardFragmentDoc}`;

/**
 * __useCheckoutQuery__
 *
 * To run a query within a React component, call `useCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckoutQuery(baseOptions?: Apollo.QueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
      }
export function useCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
        }
export type CheckoutQueryHookResult = ReturnType<typeof useCheckoutQuery>;
export type CheckoutLazyQueryHookResult = ReturnType<typeof useCheckoutLazyQuery>;
export type CheckoutQueryResult = Apollo.QueryResult<CheckoutQuery, CheckoutQueryVariables>;
export const SetModalitaSpedizioneDocument = gql`
    mutation SetModalitaSpedizione($idModalitaSpedizione: Int!, $idRivenditore: Int) {
  setModalitaSpedizione(
    idModalitaSpedizione: $idModalitaSpedizione
    idRivenditore: $idRivenditore
  ) {
    status
    message
  }
}
    `;
export type SetModalitaSpedizioneMutationFn = Apollo.MutationFunction<SetModalitaSpedizioneMutation, SetModalitaSpedizioneMutationVariables>;

/**
 * __useSetModalitaSpedizioneMutation__
 *
 * To run a mutation, you first call `useSetModalitaSpedizioneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetModalitaSpedizioneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setModalitaSpedizioneMutation, { data, loading, error }] = useSetModalitaSpedizioneMutation({
 *   variables: {
 *      idModalitaSpedizione: // value for 'idModalitaSpedizione'
 *      idRivenditore: // value for 'idRivenditore'
 *   },
 * });
 */
export function useSetModalitaSpedizioneMutation(baseOptions?: Apollo.MutationHookOptions<SetModalitaSpedizioneMutation, SetModalitaSpedizioneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetModalitaSpedizioneMutation, SetModalitaSpedizioneMutationVariables>(SetModalitaSpedizioneDocument, options);
      }
export type SetModalitaSpedizioneMutationHookResult = ReturnType<typeof useSetModalitaSpedizioneMutation>;
export type SetModalitaSpedizioneMutationResult = Apollo.MutationResult<SetModalitaSpedizioneMutation>;
export type SetModalitaSpedizioneMutationOptions = Apollo.BaseMutationOptions<SetModalitaSpedizioneMutation, SetModalitaSpedizioneMutationVariables>;
export const SetIndirizziDocument = gql`
    mutation SetIndirizzi($indirizzoSpedizione: Int, $indirizzoFatturazione: Int, $same: Boolean, $spedizione: Boolean) {
  setIndirizzi(
    indirizzoSpedizione: $indirizzoSpedizione
    indirizzoFatturazione: $indirizzoFatturazione
    same: $same
    spedizione: $spedizione
  ) {
    status
    message
  }
}
    `;
export type SetIndirizziMutationFn = Apollo.MutationFunction<SetIndirizziMutation, SetIndirizziMutationVariables>;

/**
 * __useSetIndirizziMutation__
 *
 * To run a mutation, you first call `useSetIndirizziMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIndirizziMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIndirizziMutation, { data, loading, error }] = useSetIndirizziMutation({
 *   variables: {
 *      indirizzoSpedizione: // value for 'indirizzoSpedizione'
 *      indirizzoFatturazione: // value for 'indirizzoFatturazione'
 *      same: // value for 'same'
 *      spedizione: // value for 'spedizione'
 *   },
 * });
 */
export function useSetIndirizziMutation(baseOptions?: Apollo.MutationHookOptions<SetIndirizziMutation, SetIndirizziMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIndirizziMutation, SetIndirizziMutationVariables>(SetIndirizziDocument, options);
      }
export type SetIndirizziMutationHookResult = ReturnType<typeof useSetIndirizziMutation>;
export type SetIndirizziMutationResult = Apollo.MutationResult<SetIndirizziMutation>;
export type SetIndirizziMutationOptions = Apollo.BaseMutationOptions<SetIndirizziMutation, SetIndirizziMutationVariables>;
export const CreateIndirizzoDocument = gql`
    mutation CreateIndirizzo($input: IndirizzoInput!) {
  createIndirizzo(input: $input) {
    indirizzo {
      nome
      cognome
      indirizzo
      isFatturazione
    }
  }
}
    `;
export type CreateIndirizzoMutationFn = Apollo.MutationFunction<CreateIndirizzoMutation, CreateIndirizzoMutationVariables>;

/**
 * __useCreateIndirizzoMutation__
 *
 * To run a mutation, you first call `useCreateIndirizzoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndirizzoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndirizzoMutation, { data, loading, error }] = useCreateIndirizzoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndirizzoMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndirizzoMutation, CreateIndirizzoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndirizzoMutation, CreateIndirizzoMutationVariables>(CreateIndirizzoDocument, options);
      }
export type CreateIndirizzoMutationHookResult = ReturnType<typeof useCreateIndirizzoMutation>;
export type CreateIndirizzoMutationResult = Apollo.MutationResult<CreateIndirizzoMutation>;
export type CreateIndirizzoMutationOptions = Apollo.BaseMutationOptions<CreateIndirizzoMutation, CreateIndirizzoMutationVariables>;
export const SetCheckoutDocument = gql`
    mutation SetCheckout($idRivenditore: Int!, $idSistemaPagamento: Int!) {
  setCheckout(
    idRivenditore: $idRivenditore
    idSistemaPagamento: $idSistemaPagamento
  ) {
    url
    status
    message
  }
}
    `;
export type SetCheckoutMutationFn = Apollo.MutationFunction<SetCheckoutMutation, SetCheckoutMutationVariables>;

/**
 * __useSetCheckoutMutation__
 *
 * To run a mutation, you first call `useSetCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCheckoutMutation, { data, loading, error }] = useSetCheckoutMutation({
 *   variables: {
 *      idRivenditore: // value for 'idRivenditore'
 *      idSistemaPagamento: // value for 'idSistemaPagamento'
 *   },
 * });
 */
export function useSetCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<SetCheckoutMutation, SetCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCheckoutMutation, SetCheckoutMutationVariables>(SetCheckoutDocument, options);
      }
export type SetCheckoutMutationHookResult = ReturnType<typeof useSetCheckoutMutation>;
export type SetCheckoutMutationResult = Apollo.MutationResult<SetCheckoutMutation>;
export type SetCheckoutMutationOptions = Apollo.BaseMutationOptions<SetCheckoutMutation, SetCheckoutMutationVariables>;
export const SetSistemaPagamentoDocument = gql`
    mutation SetSistemaPagamento($idSistemaPagamento: Int!) {
  setSistemaPagamento(idSistemaPagamento: $idSistemaPagamento) {
    status
    message
  }
}
    `;
export type SetSistemaPagamentoMutationFn = Apollo.MutationFunction<SetSistemaPagamentoMutation, SetSistemaPagamentoMutationVariables>;

/**
 * __useSetSistemaPagamentoMutation__
 *
 * To run a mutation, you first call `useSetSistemaPagamentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSistemaPagamentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSistemaPagamentoMutation, { data, loading, error }] = useSetSistemaPagamentoMutation({
 *   variables: {
 *      idSistemaPagamento: // value for 'idSistemaPagamento'
 *   },
 * });
 */
export function useSetSistemaPagamentoMutation(baseOptions?: Apollo.MutationHookOptions<SetSistemaPagamentoMutation, SetSistemaPagamentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSistemaPagamentoMutation, SetSistemaPagamentoMutationVariables>(SetSistemaPagamentoDocument, options);
      }
export type SetSistemaPagamentoMutationHookResult = ReturnType<typeof useSetSistemaPagamentoMutation>;
export type SetSistemaPagamentoMutationResult = Apollo.MutationResult<SetSistemaPagamentoMutation>;
export type SetSistemaPagamentoMutationOptions = Apollo.BaseMutationOptions<SetSistemaPagamentoMutation, SetSistemaPagamentoMutationVariables>;
export const SistemiSpedizioneDocument = gql`
    query SistemiSpedizione {
  sistemiSpedizione {
    pk
    alias
    chiave
    nome
    descrizioneEstesa
    prezzo
    prezzoScontato
  }
}
    `;

/**
 * __useSistemiSpedizioneQuery__
 *
 * To run a query within a React component, call `useSistemiSpedizioneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSistemiSpedizioneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSistemiSpedizioneQuery({
 *   variables: {
 *   },
 * });
 */
export function useSistemiSpedizioneQuery(baseOptions?: Apollo.QueryHookOptions<SistemiSpedizioneQuery, SistemiSpedizioneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SistemiSpedizioneQuery, SistemiSpedizioneQueryVariables>(SistemiSpedizioneDocument, options);
      }
export function useSistemiSpedizioneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SistemiSpedizioneQuery, SistemiSpedizioneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SistemiSpedizioneQuery, SistemiSpedizioneQueryVariables>(SistemiSpedizioneDocument, options);
        }
export type SistemiSpedizioneQueryHookResult = ReturnType<typeof useSistemiSpedizioneQuery>;
export type SistemiSpedizioneLazyQueryHookResult = ReturnType<typeof useSistemiSpedizioneLazyQuery>;
export type SistemiSpedizioneQueryResult = Apollo.QueryResult<SistemiSpedizioneQuery, SistemiSpedizioneQueryVariables>;
export const RivenditoriGeolocatedDocument = gql`
    query RivenditoriGeolocated($utenteGeo: String!) {
  rivenditoriGeolocated(utenteGeo: $utenteGeo) {
    ragioneSociale
    indirizzo
    citta
    provincia
    pk
    latitudine
    longitudine
    sistemiPagamento {
      pk
      alias
      nome
      descrizione
      image
      famiglia {
        nome
      }
    }
  }
}
    `;

/**
 * __useRivenditoriGeolocatedQuery__
 *
 * To run a query within a React component, call `useRivenditoriGeolocatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRivenditoriGeolocatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRivenditoriGeolocatedQuery({
 *   variables: {
 *      utenteGeo: // value for 'utenteGeo'
 *   },
 * });
 */
export function useRivenditoriGeolocatedQuery(baseOptions: Apollo.QueryHookOptions<RivenditoriGeolocatedQuery, RivenditoriGeolocatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RivenditoriGeolocatedQuery, RivenditoriGeolocatedQueryVariables>(RivenditoriGeolocatedDocument, options);
      }
export function useRivenditoriGeolocatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RivenditoriGeolocatedQuery, RivenditoriGeolocatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RivenditoriGeolocatedQuery, RivenditoriGeolocatedQueryVariables>(RivenditoriGeolocatedDocument, options);
        }
export type RivenditoriGeolocatedQueryHookResult = ReturnType<typeof useRivenditoriGeolocatedQuery>;
export type RivenditoriGeolocatedLazyQueryHookResult = ReturnType<typeof useRivenditoriGeolocatedLazyQuery>;
export type RivenditoriGeolocatedQueryResult = Apollo.QueryResult<RivenditoriGeolocatedQuery, RivenditoriGeolocatedQueryVariables>;
export const CreateAddressDocument = gql`
    mutation CreateAddress($address: CreateAddressInput!) {
  createAddress(address: $address) {
    status
    message
    pk
  }
}
    `;
export type CreateAddressMutationFn = Apollo.MutationFunction<CreateAddressMutation, CreateAddressMutationVariables>;

/**
 * __useCreateAddressMutation__
 *
 * To run a mutation, you first call `useCreateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressMutation, { data, loading, error }] = useCreateAddressMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useCreateAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddressMutation, CreateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddressMutation, CreateAddressMutationVariables>(CreateAddressDocument, options);
      }
export type CreateAddressMutationHookResult = ReturnType<typeof useCreateAddressMutation>;
export type CreateAddressMutationResult = Apollo.MutationResult<CreateAddressMutation>;
export type CreateAddressMutationOptions = Apollo.BaseMutationOptions<CreateAddressMutation, CreateAddressMutationVariables>;
export const ValidaIndirizzoDocument = gql`
    mutation ValidaIndirizzo($address: ValidaIndirizzoInput!) {
  validaIndirizzo(address: $address) {
    status
    message
    valid
    details
  }
}
    `;
export type ValidaIndirizzoMutationFn = Apollo.MutationFunction<ValidaIndirizzoMutation, ValidaIndirizzoMutationVariables>;

/**
 * __useValidaIndirizzoMutation__
 *
 * To run a mutation, you first call `useValidaIndirizzoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidaIndirizzoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validaIndirizzoMutation, { data, loading, error }] = useValidaIndirizzoMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useValidaIndirizzoMutation(baseOptions?: Apollo.MutationHookOptions<ValidaIndirizzoMutation, ValidaIndirizzoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidaIndirizzoMutation, ValidaIndirizzoMutationVariables>(ValidaIndirizzoDocument, options);
      }
export type ValidaIndirizzoMutationHookResult = ReturnType<typeof useValidaIndirizzoMutation>;
export type ValidaIndirizzoMutationResult = Apollo.MutationResult<ValidaIndirizzoMutation>;
export type ValidaIndirizzoMutationOptions = Apollo.BaseMutationOptions<ValidaIndirizzoMutation, ValidaIndirizzoMutationVariables>;
export const ValidaCodicePostaleDocument = gql`
    mutation ValidaCodicePostale($postalCode: String!, $countryCode: String!, $stateCode: String!, $carrierCode: String!) {
  validaCodicePostale(
    postalCode: $postalCode
    countryCode: $countryCode
    stateCode: $stateCode
    carrierCode: $carrierCode
  ) {
    status
    message
    valid
    details
  }
}
    `;
export type ValidaCodicePostaleMutationFn = Apollo.MutationFunction<ValidaCodicePostaleMutation, ValidaCodicePostaleMutationVariables>;

/**
 * __useValidaCodicePostaleMutation__
 *
 * To run a mutation, you first call `useValidaCodicePostaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidaCodicePostaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validaCodicePostaleMutation, { data, loading, error }] = useValidaCodicePostaleMutation({
 *   variables: {
 *      postalCode: // value for 'postalCode'
 *      countryCode: // value for 'countryCode'
 *      stateCode: // value for 'stateCode'
 *      carrierCode: // value for 'carrierCode'
 *   },
 * });
 */
export function useValidaCodicePostaleMutation(baseOptions?: Apollo.MutationHookOptions<ValidaCodicePostaleMutation, ValidaCodicePostaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidaCodicePostaleMutation, ValidaCodicePostaleMutationVariables>(ValidaCodicePostaleDocument, options);
      }
export type ValidaCodicePostaleMutationHookResult = ReturnType<typeof useValidaCodicePostaleMutation>;
export type ValidaCodicePostaleMutationResult = Apollo.MutationResult<ValidaCodicePostaleMutation>;
export type ValidaCodicePostaleMutationOptions = Apollo.BaseMutationOptions<ValidaCodicePostaleMutation, ValidaCodicePostaleMutationVariables>;
export const CategorieHelpOnlineDocument = gql`
    query CategorieHelpOnline {
  categorieHelpOnline {
    pk
    nome
    url
    descrizione
    risposte {
      pk
      nome
      risposta
    }
  }
}
    `;

/**
 * __useCategorieHelpOnlineQuery__
 *
 * To run a query within a React component, call `useCategorieHelpOnlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieHelpOnlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieHelpOnlineQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieHelpOnlineQuery(baseOptions?: Apollo.QueryHookOptions<CategorieHelpOnlineQuery, CategorieHelpOnlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieHelpOnlineQuery, CategorieHelpOnlineQueryVariables>(CategorieHelpOnlineDocument, options);
      }
export function useCategorieHelpOnlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieHelpOnlineQuery, CategorieHelpOnlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieHelpOnlineQuery, CategorieHelpOnlineQueryVariables>(CategorieHelpOnlineDocument, options);
        }
export type CategorieHelpOnlineQueryHookResult = ReturnType<typeof useCategorieHelpOnlineQuery>;
export type CategorieHelpOnlineLazyQueryHookResult = ReturnType<typeof useCategorieHelpOnlineLazyQuery>;
export type CategorieHelpOnlineQueryResult = Apollo.QueryResult<CategorieHelpOnlineQuery, CategorieHelpOnlineQueryVariables>;
export const CategoriaHelpOnlineDocument = gql`
    query CategoriaHelpOnline($categoriaSlug: String!) {
  categoriaHelpOnline(categoriaSlug: $categoriaSlug) {
    categorie {
      pk
      nome
      url
    }
    categoria {
      pk
      nome
      url
      risposte {
        pk
        nome
        risposta
        slug
      }
      pagina {
        adminUrl
        breadcrumbs {
          label
          url
        }
        seo {
          title
          description
          image
          noindex
          canonicalUrl
        }
      }
    }
  }
}
    `;

/**
 * __useCategoriaHelpOnlineQuery__
 *
 * To run a query within a React component, call `useCategoriaHelpOnlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriaHelpOnlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriaHelpOnlineQuery({
 *   variables: {
 *      categoriaSlug: // value for 'categoriaSlug'
 *   },
 * });
 */
export function useCategoriaHelpOnlineQuery(baseOptions: Apollo.QueryHookOptions<CategoriaHelpOnlineQuery, CategoriaHelpOnlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriaHelpOnlineQuery, CategoriaHelpOnlineQueryVariables>(CategoriaHelpOnlineDocument, options);
      }
export function useCategoriaHelpOnlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriaHelpOnlineQuery, CategoriaHelpOnlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriaHelpOnlineQuery, CategoriaHelpOnlineQueryVariables>(CategoriaHelpOnlineDocument, options);
        }
export type CategoriaHelpOnlineQueryHookResult = ReturnType<typeof useCategoriaHelpOnlineQuery>;
export type CategoriaHelpOnlineLazyQueryHookResult = ReturnType<typeof useCategoriaHelpOnlineLazyQuery>;
export type CategoriaHelpOnlineQueryResult = Apollo.QueryResult<CategoriaHelpOnlineQuery, CategoriaHelpOnlineQueryVariables>;
export const FeedbackDocument = gql`
    mutation Feedback($idRisposta: ID!, $utile: Boolean!) {
  feedback(idRisposta: $idRisposta, utile: $utile) {
    status
    message
  }
}
    `;
export type FeedbackMutationFn = Apollo.MutationFunction<FeedbackMutation, FeedbackMutationVariables>;

/**
 * __useFeedbackMutation__
 *
 * To run a mutation, you first call `useFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feedbackMutation, { data, loading, error }] = useFeedbackMutation({
 *   variables: {
 *      idRisposta: // value for 'idRisposta'
 *      utile: // value for 'utile'
 *   },
 * });
 */
export function useFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<FeedbackMutation, FeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeedbackMutation, FeedbackMutationVariables>(FeedbackDocument, options);
      }
export type FeedbackMutationHookResult = ReturnType<typeof useFeedbackMutation>;
export type FeedbackMutationResult = Apollo.MutationResult<FeedbackMutation>;
export type FeedbackMutationOptions = Apollo.BaseMutationOptions<FeedbackMutation, FeedbackMutationVariables>;
export const CategorieRicercaManualiDocument = gql`
    query CategorieRicercaManuali {
  categorieRicercaManuali {
    pk
    nome
  }
}
    `;

/**
 * __useCategorieRicercaManualiQuery__
 *
 * To run a query within a React component, call `useCategorieRicercaManualiQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieRicercaManualiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieRicercaManualiQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieRicercaManualiQuery(baseOptions?: Apollo.QueryHookOptions<CategorieRicercaManualiQuery, CategorieRicercaManualiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieRicercaManualiQuery, CategorieRicercaManualiQueryVariables>(CategorieRicercaManualiDocument, options);
      }
export function useCategorieRicercaManualiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieRicercaManualiQuery, CategorieRicercaManualiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieRicercaManualiQuery, CategorieRicercaManualiQueryVariables>(CategorieRicercaManualiDocument, options);
        }
export type CategorieRicercaManualiQueryHookResult = ReturnType<typeof useCategorieRicercaManualiQuery>;
export type CategorieRicercaManualiLazyQueryHookResult = ReturnType<typeof useCategorieRicercaManualiLazyQuery>;
export type CategorieRicercaManualiQueryResult = Apollo.QueryResult<CategorieRicercaManualiQuery, CategorieRicercaManualiQueryVariables>;
export const GetCategorieByParentDocument = gql`
    query GetCategorieByParent($parentId: Int!, $inMenu: Boolean) {
  categorieByParent(parentId: $parentId, inMenu: $inMenu) {
    pk
    nome
  }
}
    `;

/**
 * __useGetCategorieByParentQuery__
 *
 * To run a query within a React component, call `useGetCategorieByParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategorieByParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategorieByParentQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      inMenu: // value for 'inMenu'
 *   },
 * });
 */
export function useGetCategorieByParentQuery(baseOptions: Apollo.QueryHookOptions<GetCategorieByParentQuery, GetCategorieByParentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategorieByParentQuery, GetCategorieByParentQueryVariables>(GetCategorieByParentDocument, options);
      }
export function useGetCategorieByParentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategorieByParentQuery, GetCategorieByParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategorieByParentQuery, GetCategorieByParentQueryVariables>(GetCategorieByParentDocument, options);
        }
export type GetCategorieByParentQueryHookResult = ReturnType<typeof useGetCategorieByParentQuery>;
export type GetCategorieByParentLazyQueryHookResult = ReturnType<typeof useGetCategorieByParentLazyQuery>;
export type GetCategorieByParentQueryResult = Apollo.QueryResult<GetCategorieByParentQuery, GetCategorieByParentQueryVariables>;
export const ProdottiRicercaManualiDocument = gql`
    query ProdottiRicercaManuali($idCategoria: Int!) {
  prodottiRicercaManuali(idCategoria: $idCategoria) {
    pk
    alias
    documenti {
      pk
      url
      nomeDocumento
      lingue {
        id
        codice
      }
    }
  }
}
    `;

/**
 * __useProdottiRicercaManualiQuery__
 *
 * To run a query within a React component, call `useProdottiRicercaManualiQuery` and pass it any options that fit your needs.
 * When your component renders, `useProdottiRicercaManualiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProdottiRicercaManualiQuery({
 *   variables: {
 *      idCategoria: // value for 'idCategoria'
 *   },
 * });
 */
export function useProdottiRicercaManualiQuery(baseOptions: Apollo.QueryHookOptions<ProdottiRicercaManualiQuery, ProdottiRicercaManualiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProdottiRicercaManualiQuery, ProdottiRicercaManualiQueryVariables>(ProdottiRicercaManualiDocument, options);
      }
export function useProdottiRicercaManualiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProdottiRicercaManualiQuery, ProdottiRicercaManualiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProdottiRicercaManualiQuery, ProdottiRicercaManualiQueryVariables>(ProdottiRicercaManualiDocument, options);
        }
export type ProdottiRicercaManualiQueryHookResult = ReturnType<typeof useProdottiRicercaManualiQuery>;
export type ProdottiRicercaManualiLazyQueryHookResult = ReturnType<typeof useProdottiRicercaManualiLazyQuery>;
export type ProdottiRicercaManualiQueryResult = Apollo.QueryResult<ProdottiRicercaManualiQuery, ProdottiRicercaManualiQueryVariables>;
export const NazioniManualiDocument = gql`
    query NazioniManuali {
  nazioniManuali {
    pk
    nome
  }
}
    `;

/**
 * __useNazioniManualiQuery__
 *
 * To run a query within a React component, call `useNazioniManualiQuery` and pass it any options that fit your needs.
 * When your component renders, `useNazioniManualiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNazioniManualiQuery({
 *   variables: {
 *   },
 * });
 */
export function useNazioniManualiQuery(baseOptions?: Apollo.QueryHookOptions<NazioniManualiQuery, NazioniManualiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NazioniManualiQuery, NazioniManualiQueryVariables>(NazioniManualiDocument, options);
      }
export function useNazioniManualiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NazioniManualiQuery, NazioniManualiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NazioniManualiQuery, NazioniManualiQueryVariables>(NazioniManualiDocument, options);
        }
export type NazioniManualiQueryHookResult = ReturnType<typeof useNazioniManualiQuery>;
export type NazioniManualiLazyQueryHookResult = ReturnType<typeof useNazioniManualiLazyQuery>;
export type NazioniManualiQueryResult = Apollo.QueryResult<NazioniManualiQuery, NazioniManualiQueryVariables>;
export const CreateContattoManualeDocument = gql`
    mutation CreateContattoManuale($contattoInput: CreateContattoManualeInput!) {
  createContattoManuale(contattoInput: $contattoInput) {
    status
    message
  }
}
    `;
export type CreateContattoManualeMutationFn = Apollo.MutationFunction<CreateContattoManualeMutation, CreateContattoManualeMutationVariables>;

/**
 * __useCreateContattoManualeMutation__
 *
 * To run a mutation, you first call `useCreateContattoManualeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContattoManualeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContattoManualeMutation, { data, loading, error }] = useCreateContattoManualeMutation({
 *   variables: {
 *      contattoInput: // value for 'contattoInput'
 *   },
 * });
 */
export function useCreateContattoManualeMutation(baseOptions?: Apollo.MutationHookOptions<CreateContattoManualeMutation, CreateContattoManualeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContattoManualeMutation, CreateContattoManualeMutationVariables>(CreateContattoManualeDocument, options);
      }
export type CreateContattoManualeMutationHookResult = ReturnType<typeof useCreateContattoManualeMutation>;
export type CreateContattoManualeMutationResult = Apollo.MutationResult<CreateContattoManualeMutation>;
export type CreateContattoManualeMutationOptions = Apollo.BaseMutationOptions<CreateContattoManualeMutation, CreateContattoManualeMutationVariables>;
export const NewsBySlugDocument = gql`
    query NewsBySlug($slug: String!, $preview: Boolean) {
  newsBySlug(slug: $slug, preview: $preview) {
    ...NewsCard
    mainImage
    model
    modelClass
    adminUrl
    contenutoIndicizzabile
    documentiVisibili {
      pk
      url
      titolo
    }
    pagina {
      adminUrl
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
        canonicalUrl
      }
      hreflangs {
        hrefLang
        href
      }
    }
    pagebuilders {
      key
      json_draft: jsonDraft
      json_published: jsonPublished
      text
    }
    correlati {
      ...NewsCard
    }
  }
}
    ${NewsCardFragmentDoc}`;

/**
 * __useNewsBySlugQuery__
 *
 * To run a query within a React component, call `useNewsBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useNewsBySlugQuery(baseOptions: Apollo.QueryHookOptions<NewsBySlugQuery, NewsBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsBySlugQuery, NewsBySlugQueryVariables>(NewsBySlugDocument, options);
      }
export function useNewsBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsBySlugQuery, NewsBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsBySlugQuery, NewsBySlugQueryVariables>(NewsBySlugDocument, options);
        }
export type NewsBySlugQueryHookResult = ReturnType<typeof useNewsBySlugQuery>;
export type NewsBySlugLazyQueryHookResult = ReturnType<typeof useNewsBySlugLazyQuery>;
export type NewsBySlugQueryResult = Apollo.QueryResult<NewsBySlugQuery, NewsBySlugQueryVariables>;
export const ListingNewsDocument = gql`
    query ListingNews($slug: String, $params: GenericScalar) {
  listingNews(slug: $slug, params: $params) {
    paginator {
      currentPage
      numPages
      itemsPerPage
      count
      pages {
        href
        page
      }
    }
    news {
      ...NewsCard
    }
    categorie {
      pk
      nome
      url
      slug
      isCatalogo
    }
    categoria {
      pk
      slug
      alias
      nome
      descrizione
      isCatalogo
      pagina {
        adminUrl
        breadcrumbs {
          label
          url
        }
        seo {
          title
          description
          image
          noindex
          canonicalUrl
        }
        mainImage
        descrizione
      }
    }
    root {
      url
    }
    canonicalUrl
  }
}
    ${NewsCardFragmentDoc}`;

/**
 * __useListingNewsQuery__
 *
 * To run a query within a React component, call `useListingNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingNewsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useListingNewsQuery(baseOptions?: Apollo.QueryHookOptions<ListingNewsQuery, ListingNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingNewsQuery, ListingNewsQueryVariables>(ListingNewsDocument, options);
      }
export function useListingNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingNewsQuery, ListingNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingNewsQuery, ListingNewsQueryVariables>(ListingNewsDocument, options);
        }
export type ListingNewsQueryHookResult = ReturnType<typeof useListingNewsQuery>;
export type ListingNewsLazyQueryHookResult = ReturnType<typeof useListingNewsLazyQuery>;
export type ListingNewsQueryResult = Apollo.QueryResult<ListingNewsQuery, ListingNewsQueryVariables>;
export const NewsEmakInformaBySlugDocument = gql`
    query NewsEmakInformaBySlug($slug: String!, $preview: Boolean) {
  newsEmakInformaBySlug(slug: $slug, preview: $preview) {
    ...NewsEmakInformaCard
    mainImage
    model
    pagina {
      adminUrl
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
        canonicalUrl
      }
    }
    pagebuilders {
      key
      json_draft: jsonDraft
      json_published: jsonPublished
      text
    }
    correlati {
      ...NewsEmakInformaCard
    }
  }
}
    ${NewsEmakInformaCardFragmentDoc}`;

/**
 * __useNewsEmakInformaBySlugQuery__
 *
 * To run a query within a React component, call `useNewsEmakInformaBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsEmakInformaBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsEmakInformaBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useNewsEmakInformaBySlugQuery(baseOptions: Apollo.QueryHookOptions<NewsEmakInformaBySlugQuery, NewsEmakInformaBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsEmakInformaBySlugQuery, NewsEmakInformaBySlugQueryVariables>(NewsEmakInformaBySlugDocument, options);
      }
export function useNewsEmakInformaBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsEmakInformaBySlugQuery, NewsEmakInformaBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsEmakInformaBySlugQuery, NewsEmakInformaBySlugQueryVariables>(NewsEmakInformaBySlugDocument, options);
        }
export type NewsEmakInformaBySlugQueryHookResult = ReturnType<typeof useNewsEmakInformaBySlugQuery>;
export type NewsEmakInformaBySlugLazyQueryHookResult = ReturnType<typeof useNewsEmakInformaBySlugLazyQuery>;
export type NewsEmakInformaBySlugQueryResult = Apollo.QueryResult<NewsEmakInformaBySlugQuery, NewsEmakInformaBySlugQueryVariables>;
export const ListingNewsEmakInformaDocument = gql`
    query ListingNewsEmakInforma($slug: String, $params: GenericScalar) {
  listingNewsEmakInforma(slug: $slug, params: $params) {
    paginator {
      currentPage
      numPages
      itemsPerPage
      count
      pages {
        href
        page
      }
    }
    news {
      ...NewsEmakInformaCard
    }
    root {
      url
    }
  }
}
    ${NewsEmakInformaCardFragmentDoc}`;

/**
 * __useListingNewsEmakInformaQuery__
 *
 * To run a query within a React component, call `useListingNewsEmakInformaQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingNewsEmakInformaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingNewsEmakInformaQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useListingNewsEmakInformaQuery(baseOptions?: Apollo.QueryHookOptions<ListingNewsEmakInformaQuery, ListingNewsEmakInformaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingNewsEmakInformaQuery, ListingNewsEmakInformaQueryVariables>(ListingNewsEmakInformaDocument, options);
      }
export function useListingNewsEmakInformaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingNewsEmakInformaQuery, ListingNewsEmakInformaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingNewsEmakInformaQuery, ListingNewsEmakInformaQueryVariables>(ListingNewsEmakInformaDocument, options);
        }
export type ListingNewsEmakInformaQueryHookResult = ReturnType<typeof useListingNewsEmakInformaQuery>;
export type ListingNewsEmakInformaLazyQueryHookResult = ReturnType<typeof useListingNewsEmakInformaLazyQuery>;
export type ListingNewsEmakInformaQueryResult = Apollo.QueryResult<ListingNewsEmakInformaQuery, ListingNewsEmakInformaQueryVariables>;
export const Last3NewsDocument = gql`
    query Last3News {
  last3News {
    ...NewsCard
  }
}
    ${NewsCardFragmentDoc}`;

/**
 * __useLast3NewsQuery__
 *
 * To run a query within a React component, call `useLast3NewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLast3NewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLast3NewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLast3NewsQuery(baseOptions?: Apollo.QueryHookOptions<Last3NewsQuery, Last3NewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Last3NewsQuery, Last3NewsQueryVariables>(Last3NewsDocument, options);
      }
export function useLast3NewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Last3NewsQuery, Last3NewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Last3NewsQuery, Last3NewsQueryVariables>(Last3NewsDocument, options);
        }
export type Last3NewsQueryHookResult = ReturnType<typeof useLast3NewsQuery>;
export type Last3NewsLazyQueryHookResult = ReturnType<typeof useLast3NewsLazyQuery>;
export type Last3NewsQueryResult = Apollo.QueryResult<Last3NewsQuery, Last3NewsQueryVariables>;
export const NewsletterSubscriptionDocument = gql`
    mutation NewsletterSubscription($email: String!) {
  newsletterSubscription(email: $email) {
    status
    message
  }
}
    `;
export type NewsletterSubscriptionMutationFn = Apollo.MutationFunction<NewsletterSubscriptionMutation, NewsletterSubscriptionMutationVariables>;

/**
 * __useNewsletterSubscriptionMutation__
 *
 * To run a mutation, you first call `useNewsletterSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsletterSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsletterSubscriptionMutation, { data, loading, error }] = useNewsletterSubscriptionMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useNewsletterSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<NewsletterSubscriptionMutation, NewsletterSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewsletterSubscriptionMutation, NewsletterSubscriptionMutationVariables>(NewsletterSubscriptionDocument, options);
      }
export type NewsletterSubscriptionMutationHookResult = ReturnType<typeof useNewsletterSubscriptionMutation>;
export type NewsletterSubscriptionMutationResult = Apollo.MutationResult<NewsletterSubscriptionMutation>;
export type NewsletterSubscriptionMutationOptions = Apollo.BaseMutationOptions<NewsletterSubscriptionMutation, NewsletterSubscriptionMutationVariables>;
export const LandingNewsletterSubscriptionDocument = gql`
    mutation LandingNewsletterSubscription($input: LandingNewsletterInput!) {
  landingNewsletterSubscription(input: $input) {
    status
    message
  }
}
    `;
export type LandingNewsletterSubscriptionMutationFn = Apollo.MutationFunction<LandingNewsletterSubscriptionMutation, LandingNewsletterSubscriptionMutationVariables>;

/**
 * __useLandingNewsletterSubscriptionMutation__
 *
 * To run a mutation, you first call `useLandingNewsletterSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLandingNewsletterSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [landingNewsletterSubscriptionMutation, { data, loading, error }] = useLandingNewsletterSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLandingNewsletterSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<LandingNewsletterSubscriptionMutation, LandingNewsletterSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LandingNewsletterSubscriptionMutation, LandingNewsletterSubscriptionMutationVariables>(LandingNewsletterSubscriptionDocument, options);
      }
export type LandingNewsletterSubscriptionMutationHookResult = ReturnType<typeof useLandingNewsletterSubscriptionMutation>;
export type LandingNewsletterSubscriptionMutationResult = Apollo.MutationResult<LandingNewsletterSubscriptionMutation>;
export type LandingNewsletterSubscriptionMutationOptions = Apollo.BaseMutationOptions<LandingNewsletterSubscriptionMutation, LandingNewsletterSubscriptionMutationVariables>;
export const OrdineCheckoutDocument = gql`
    query OrdineCheckout {
  ordineCheckout {
    pk
    prezzoTotale
    codice
    created
    prezzoTotaleScontato
    promozioneValorePercentuale
    promozioneValoreAssoluto
    promoCode
    scontoBundles
    aliasScontoBundles
    promozione {
      promoDipendenti
      codice
      valore
    }
    sistemaSpedizione {
      chiave
    }
    sistemaPagamento {
      alias
    }
    rivenditore {
      email
      indirizzo
      citta
      provincia
      ragioneSociale
      bonifico
    }
    righeOrdine {
      omaggio
      quantitaOrdinata
      prezzoTotaleScontato
      tipologia
      prodotto {
        prodotto {
          ...ProdottoCard
          notaRuote
        }
      }
    }
  }
}
    ${ProdottoCardFragmentDoc}`;

/**
 * __useOrdineCheckoutQuery__
 *
 * To run a query within a React component, call `useOrdineCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdineCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdineCheckoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrdineCheckoutQuery(baseOptions?: Apollo.QueryHookOptions<OrdineCheckoutQuery, OrdineCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdineCheckoutQuery, OrdineCheckoutQueryVariables>(OrdineCheckoutDocument, options);
      }
export function useOrdineCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdineCheckoutQuery, OrdineCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdineCheckoutQuery, OrdineCheckoutQueryVariables>(OrdineCheckoutDocument, options);
        }
export type OrdineCheckoutQueryHookResult = ReturnType<typeof useOrdineCheckoutQuery>;
export type OrdineCheckoutLazyQueryHookResult = ReturnType<typeof useOrdineCheckoutLazyQuery>;
export type OrdineCheckoutQueryResult = Apollo.QueryResult<OrdineCheckoutQuery, OrdineCheckoutQueryVariables>;
export const OrdiniDocument = gql`
    query Ordini {
  ordini {
    edges {
      node {
        pk
        data
        created
        codice
        prezzoTotaleScontato
        trackingUrl
        url
        stato {
          nome
          alias
          chiave
        }
        sistemaSpedizione {
          nome
          chiave
        }
        righeOrdine {
          pk
          tipologia
          prodotto {
            prodotto {
              nome
              previewImage
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrdiniQuery__
 *
 * To run a query within a React component, call `useOrdiniQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdiniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdiniQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrdiniQuery(baseOptions?: Apollo.QueryHookOptions<OrdiniQuery, OrdiniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdiniQuery, OrdiniQueryVariables>(OrdiniDocument, options);
      }
export function useOrdiniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdiniQuery, OrdiniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdiniQuery, OrdiniQueryVariables>(OrdiniDocument, options);
        }
export type OrdiniQueryHookResult = ReturnType<typeof useOrdiniQuery>;
export type OrdiniLazyQueryHookResult = ReturnType<typeof useOrdiniLazyQuery>;
export type OrdiniQueryResult = Apollo.QueryResult<OrdiniQuery, OrdiniQueryVariables>;
export const OrdineDocument = gql`
    query Ordine($codice: String!) {
  ordine(codice: $codice) {
    pk
    data
    codice
    url
    rendibile
    rivenditore {
      ragioneSociale
      telefono
      email
      url
    }
    indirizzoSpedizione {
      nome
      cognome
      indirizzo
      numeroCivico
      cap
      citta
      provincia
    }
    indirizzoFatturazione {
      nome
      cognome
      indirizzo
      numeroCivico
      cap
      citta
      provincia
    }
    sistemaSpedizione {
      nome
      chiave
    }
    sistemaPagamento {
      nome
      famiglia {
        nome
      }
    }
    trackingUrl
    stato {
      nome
      alias
      chiave
    }
    prezzoTotale
    prezzoTotaleScontato
    promozioneValoreAssoluto
    righeOrdine {
      pk
      tipologia
      quantitaOrdinata
      prezzoUnitario
      prezzoUnitarioScontato
      prezzoTotaleScontato
      omaggio
      prodotto {
        prodotto {
          nome
          promo
          pk
          prezzo
          prezzoUnitario
          prezzoOmnibus
          prezzoScontato
          codice
          disponibile
          categoria {
            alias
            boxTitolo
            parent {
              boxTitolo
              parent {
                boxTitolo
                parent {
                  boxTitolo
                }
              }
            }
          }
        }
      }
    }
    pagina {
      adminUrl
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
        canonicalUrl
      }
    }
  }
}
    `;

/**
 * __useOrdineQuery__
 *
 * To run a query within a React component, call `useOrdineQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdineQuery({
 *   variables: {
 *      codice: // value for 'codice'
 *   },
 * });
 */
export function useOrdineQuery(baseOptions: Apollo.QueryHookOptions<OrdineQuery, OrdineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdineQuery, OrdineQueryVariables>(OrdineDocument, options);
      }
export function useOrdineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdineQuery, OrdineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdineQuery, OrdineQueryVariables>(OrdineDocument, options);
        }
export type OrdineQueryHookResult = ReturnType<typeof useOrdineQuery>;
export type OrdineLazyQueryHookResult = ReturnType<typeof useOrdineLazyQuery>;
export type OrdineQueryResult = Apollo.QueryResult<OrdineQuery, OrdineQueryVariables>;
export const PaginaDocument = gql`
    query Pagina($chiave: String, $path: String, $contentTypeId: Int, $objectId: Int, $withChildren: Boolean, $withSiblings: Boolean, $includeSelf: Boolean, $preview: Boolean) {
  pagina(
    chiave: $chiave
    path: $path
    contentTypeId: $contentTypeId
    objectId: $objectId
    withChildren: $withChildren
    withSiblings: $withSiblings
    includeSelf: $includeSelf
    preview: $preview
  ) {
    pk
    model
    modelClass
    titolo
    nome
    descrizione
    url
    chiave
    mainImage
    previewImage
    template
    adminUrl
    visibile
    pubblicato
    visibilitaDal
    visibilitaAl
    testo
    intro
    ctaLabel
    ctaUrl
    children {
      pk
      titolo
      nome
      mainImage
      previewImage
      url
      chiave
      descrizione
      icon
      modelClass
    }
    siblings {
      pk
      titolo
      nome
      mainImage
      previewImage
      url
      icon
    }
    parent {
      titolo
      url
      icon
    }
    breadcrumbs {
      label
      url
    }
    seo {
      title
      description
      image
      noindex
      canonicalUrl
    }
    hreflangs {
      hrefLang
      href
    }
    pagebuilders {
      key
      json_draft: jsonDraft
      json_published: jsonPublished
      text
    }
    categorie {
      pk
      boxTitolo
      url
      previewImage
      depth
      parent {
        boxTitolo
        previewImage
      }
    }
    categorieLanding {
      pk
      nome
      prodottiLanding {
        ...ProdottoCard
      }
    }
  }
}
    ${ProdottoCardFragmentDoc}`;

/**
 * __usePaginaQuery__
 *
 * To run a query within a React component, call `usePaginaQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginaQuery({
 *   variables: {
 *      chiave: // value for 'chiave'
 *      path: // value for 'path'
 *      contentTypeId: // value for 'contentTypeId'
 *      objectId: // value for 'objectId'
 *      withChildren: // value for 'withChildren'
 *      withSiblings: // value for 'withSiblings'
 *      includeSelf: // value for 'includeSelf'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function usePaginaQuery(baseOptions?: Apollo.QueryHookOptions<PaginaQuery, PaginaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginaQuery, PaginaQueryVariables>(PaginaDocument, options);
      }
export function usePaginaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginaQuery, PaginaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginaQuery, PaginaQueryVariables>(PaginaDocument, options);
        }
export type PaginaQueryHookResult = ReturnType<typeof usePaginaQuery>;
export type PaginaLazyQueryHookResult = ReturnType<typeof usePaginaLazyQuery>;
export type PaginaQueryResult = Apollo.QueryResult<PaginaQuery, PaginaQueryVariables>;
export const PaginaByPkDocument = gql`
    query PaginaByPk($pk: Int!, $withChildren: Boolean, $preview: Boolean) {
  paginaByPk(pk: $pk, withChildren: $withChildren, preview: $preview) {
    pk
    model
    modelClass
    titolo
    nome
    descrizione
    url
    chiave
    mainImage
    previewImage
    template
    adminUrl
    visibile
    pubblicato
    visibilitaDal
    visibilitaAl
    testo
    children {
      pk
      titolo
      nome
      mainImage
      previewImage
      url
      chiave
      descrizione
      icon
      modelClass
    }
    breadcrumbs {
      label
      url
    }
    seo {
      title
      description
      image
      noindex
      canonicalUrl
    }
  }
}
    `;

/**
 * __usePaginaByPkQuery__
 *
 * To run a query within a React component, call `usePaginaByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginaByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginaByPkQuery({
 *   variables: {
 *      pk: // value for 'pk'
 *      withChildren: // value for 'withChildren'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function usePaginaByPkQuery(baseOptions: Apollo.QueryHookOptions<PaginaByPkQuery, PaginaByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginaByPkQuery, PaginaByPkQueryVariables>(PaginaByPkDocument, options);
      }
export function usePaginaByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginaByPkQuery, PaginaByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginaByPkQuery, PaginaByPkQueryVariables>(PaginaByPkDocument, options);
        }
export type PaginaByPkQueryHookResult = ReturnType<typeof usePaginaByPkQuery>;
export type PaginaByPkLazyQueryHookResult = ReturnType<typeof usePaginaByPkLazyQuery>;
export type PaginaByPkQueryResult = Apollo.QueryResult<PaginaByPkQuery, PaginaByPkQueryVariables>;
export const PagineCatchAllDocument = gql`
    query PagineCatchAll {
  pagine(tipologia: PAGE) {
    edges {
      node {
        path
        slug
      }
    }
  }
}
    `;

/**
 * __usePagineCatchAllQuery__
 *
 * To run a query within a React component, call `usePagineCatchAllQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagineCatchAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagineCatchAllQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagineCatchAllQuery(baseOptions?: Apollo.QueryHookOptions<PagineCatchAllQuery, PagineCatchAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagineCatchAllQuery, PagineCatchAllQueryVariables>(PagineCatchAllDocument, options);
      }
export function usePagineCatchAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagineCatchAllQuery, PagineCatchAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagineCatchAllQuery, PagineCatchAllQueryVariables>(PagineCatchAllDocument, options);
        }
export type PagineCatchAllQueryHookResult = ReturnType<typeof usePagineCatchAllQuery>;
export type PagineCatchAllLazyQueryHookResult = ReturnType<typeof usePagineCatchAllLazyQuery>;
export type PagineCatchAllQueryResult = Apollo.QueryResult<PagineCatchAllQuery, PagineCatchAllQueryVariables>;
export const PrezziProdottiDocument = gql`
    query PrezziProdotti($ids: [Int]!) {
  prezziProdotti(ids: $ids) {
    pk
    prezzoUnitario
    prezzo
    prezzoScontato
    prezzoOmnibus
    inPromoBundle
  }
}
    `;

/**
 * __usePrezziProdottiQuery__
 *
 * To run a query within a React component, call `usePrezziProdottiQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrezziProdottiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrezziProdottiQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePrezziProdottiQuery(baseOptions: Apollo.QueryHookOptions<PrezziProdottiQuery, PrezziProdottiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrezziProdottiQuery, PrezziProdottiQueryVariables>(PrezziProdottiDocument, options);
      }
export function usePrezziProdottiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrezziProdottiQuery, PrezziProdottiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrezziProdottiQuery, PrezziProdottiQueryVariables>(PrezziProdottiDocument, options);
        }
export type PrezziProdottiQueryHookResult = ReturnType<typeof usePrezziProdottiQuery>;
export type PrezziProdottiLazyQueryHookResult = ReturnType<typeof usePrezziProdottiLazyQuery>;
export type PrezziProdottiQueryResult = Apollo.QueryResult<PrezziProdottiQuery, PrezziProdottiQueryVariables>;
export const ProdottiTendinaDocument = gql`
    query ProdottiTendina($ids: [Int]!) {
  prodottiTendina(ids: $ids) {
    pk
    showTaglia
    showFormato
    prodottiTendina {
      pk
      labelTendina
      rif
      url
      prezzoUnitario
      prezzoScontato
      prezzo
    }
  }
}
    `;

/**
 * __useProdottiTendinaQuery__
 *
 * To run a query within a React component, call `useProdottiTendinaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProdottiTendinaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProdottiTendinaQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useProdottiTendinaQuery(baseOptions: Apollo.QueryHookOptions<ProdottiTendinaQuery, ProdottiTendinaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProdottiTendinaQuery, ProdottiTendinaQueryVariables>(ProdottiTendinaDocument, options);
      }
export function useProdottiTendinaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProdottiTendinaQuery, ProdottiTendinaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProdottiTendinaQuery, ProdottiTendinaQueryVariables>(ProdottiTendinaDocument, options);
        }
export type ProdottiTendinaQueryHookResult = ReturnType<typeof useProdottiTendinaQuery>;
export type ProdottiTendinaLazyQueryHookResult = ReturnType<typeof useProdottiTendinaLazyQuery>;
export type ProdottiTendinaQueryResult = Apollo.QueryResult<ProdottiTendinaQuery, ProdottiTendinaQueryVariables>;
export const ProdottoCardDocument = gql`
    query ProdottoCard($pk: Int!) {
  prodottoByPk(pk: $pk) {
    ...ProdottoCard
  }
}
    ${ProdottoCardFragmentDoc}`;

/**
 * __useProdottoCardQuery__
 *
 * To run a query within a React component, call `useProdottoCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useProdottoCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProdottoCardQuery({
 *   variables: {
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useProdottoCardQuery(baseOptions: Apollo.QueryHookOptions<ProdottoCardQuery, ProdottoCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProdottoCardQuery, ProdottoCardQueryVariables>(ProdottoCardDocument, options);
      }
export function useProdottoCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProdottoCardQuery, ProdottoCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProdottoCardQuery, ProdottoCardQueryVariables>(ProdottoCardDocument, options);
        }
export type ProdottoCardQueryHookResult = ReturnType<typeof useProdottoCardQuery>;
export type ProdottoCardLazyQueryHookResult = ReturnType<typeof useProdottoCardLazyQuery>;
export type ProdottoCardQueryResult = Apollo.QueryResult<ProdottoCardQuery, ProdottoCardQueryVariables>;
export const ProdottiComparatoreDocument = gql`
    query ProdottiComparatore($ids: [Int]!) {
  prodottiByIds(ids: $ids) {
    pk
    nome
    previewImage
    url
    prezzo
    prezzoUnitario
    prezzoScontato
    attributi {
      chiave
      valori {
        pk
        nome
        image
        attributo {
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useProdottiComparatoreQuery__
 *
 * To run a query within a React component, call `useProdottiComparatoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useProdottiComparatoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProdottiComparatoreQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useProdottiComparatoreQuery(baseOptions: Apollo.QueryHookOptions<ProdottiComparatoreQuery, ProdottiComparatoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProdottiComparatoreQuery, ProdottiComparatoreQueryVariables>(ProdottiComparatoreDocument, options);
      }
export function useProdottiComparatoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProdottiComparatoreQuery, ProdottiComparatoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProdottiComparatoreQuery, ProdottiComparatoreQueryVariables>(ProdottiComparatoreDocument, options);
        }
export type ProdottiComparatoreQueryHookResult = ReturnType<typeof useProdottiComparatoreQuery>;
export type ProdottiComparatoreLazyQueryHookResult = ReturnType<typeof useProdottiComparatoreLazyQuery>;
export type ProdottiComparatoreQueryResult = Apollo.QueryResult<ProdottiComparatoreQuery, ProdottiComparatoreQueryVariables>;
export const ChangeProdottoCardDocument = gql`
    query ChangeProdottoCard($pk: Int!, $ids: [Int]!) {
  prodottoByPk(pk: $pk) {
    ...ProdottoCard
  }
  prezziProdotti(ids: $ids) {
    pk
    prezzoUnitario
    prezzo
    prezzoScontato
    prezzoOmnibus
    inPromoBundle
  }
}
    ${ProdottoCardFragmentDoc}`;

/**
 * __useChangeProdottoCardQuery__
 *
 * To run a query within a React component, call `useChangeProdottoCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeProdottoCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeProdottoCardQuery({
 *   variables: {
 *      pk: // value for 'pk'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useChangeProdottoCardQuery(baseOptions: Apollo.QueryHookOptions<ChangeProdottoCardQuery, ChangeProdottoCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeProdottoCardQuery, ChangeProdottoCardQueryVariables>(ChangeProdottoCardDocument, options);
      }
export function useChangeProdottoCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeProdottoCardQuery, ChangeProdottoCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeProdottoCardQuery, ChangeProdottoCardQueryVariables>(ChangeProdottoCardDocument, options);
        }
export type ChangeProdottoCardQueryHookResult = ReturnType<typeof useChangeProdottoCardQuery>;
export type ChangeProdottoCardLazyQueryHookResult = ReturnType<typeof useChangeProdottoCardLazyQuery>;
export type ChangeProdottoCardQueryResult = Apollo.QueryResult<ChangeProdottoCardQuery, ChangeProdottoCardQueryVariables>;
export const ProdottiDocument = gql`
    query Prodotti {
  prodotti {
    pk
    alias
    codice
    slug
  }
}
    `;

/**
 * __useProdottiQuery__
 *
 * To run a query within a React component, call `useProdottiQuery` and pass it any options that fit your needs.
 * When your component renders, `useProdottiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProdottiQuery({
 *   variables: {
 *   },
 * });
 */
export function useProdottiQuery(baseOptions?: Apollo.QueryHookOptions<ProdottiQuery, ProdottiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProdottiQuery, ProdottiQueryVariables>(ProdottiDocument, options);
      }
export function useProdottiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProdottiQuery, ProdottiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProdottiQuery, ProdottiQueryVariables>(ProdottiDocument, options);
        }
export type ProdottiQueryHookResult = ReturnType<typeof useProdottiQuery>;
export type ProdottiLazyQueryHookResult = ReturnType<typeof useProdottiLazyQuery>;
export type ProdottiQueryResult = Apollo.QueryResult<ProdottiQuery, ProdottiQueryVariables>;
export const ProdottoDocument = gql`
    query Prodotto($slug: String!, $preview: Boolean) {
  prodotto(slug: $slug, preview: $preview) {
    ...ProdottoCard
    descrizioneBreve
    descrizione
    peso
    rif
    adminUrl
    modelClass
    isAccessorio
    isAbbigliamento
    showGuidaTaglie
    notaRuote
    isLubrificante
    categoria {
      alias
      boxTitolo
      url
      parent {
        boxTitolo
        parent {
          boxTitolo
          parent {
            boxTitolo
          }
        }
      }
    }
    detailImages {
      pk
      image
    }
    videoImages {
      pk
      descrizione
    }
    attributi {
      chiave
      valori {
        pk
        nome
        image
        parent {
          pk
        }
        attributo {
          nome
        }
      }
    }
    use {
      pk
      nome
      image
    }
    documenti {
      pk
      nomeDocumento
      url
      lingue {
        codice
      }
    }
    plusPoints {
      pk
      titolo
      descrizione
      immagine
    }
    volantini {
      pk
      intro
      immagine
      url
    }
    tabellaMotori {
      testo
    }
    categorieCorrelate {
      boxTitolo
      url
    }
    prodottiCompatibili {
      nome
      url
      categoriaCompatibili {
        boxTitolo
        nome
      }
    }
    pagina {
      adminUrl
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
        canonicalUrl
      }
    }
    suggestedForYou {
      ...ProdottoCard
    }
    boughtTogether {
      ...ProdottoCard
    }
    valuta {
      isoCode
      simbolo
    }
  }
}
    ${ProdottoCardFragmentDoc}`;

/**
 * __useProdottoQuery__
 *
 * To run a query within a React component, call `useProdottoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProdottoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProdottoQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useProdottoQuery(baseOptions: Apollo.QueryHookOptions<ProdottoQuery, ProdottoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProdottoQuery, ProdottoQueryVariables>(ProdottoDocument, options);
      }
export function useProdottoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProdottoQuery, ProdottoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProdottoQuery, ProdottoQueryVariables>(ProdottoDocument, options);
        }
export type ProdottoQueryHookResult = ReturnType<typeof useProdottoQuery>;
export type ProdottoLazyQueryHookResult = ReturnType<typeof useProdottoLazyQuery>;
export type ProdottoQueryResult = Apollo.QueryResult<ProdottoQuery, ProdottoQueryVariables>;
export const PromoBundleProdottoDocument = gql`
    query PromoBundleProdotto($pk: Int!) {
  prodottoByPk(pk: $pk) {
    promoBundle {
      pk
      valore
      descrizioneProdotto
      prodottiBundle {
        pk
        nome
        previewImage
        descrizioneBreve
        prezzo
        prezzoUnitario
        prezzoOmnibus
        prezzoScontato
      }
    }
  }
}
    `;

/**
 * __usePromoBundleProdottoQuery__
 *
 * To run a query within a React component, call `usePromoBundleProdottoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoBundleProdottoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoBundleProdottoQuery({
 *   variables: {
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function usePromoBundleProdottoQuery(baseOptions: Apollo.QueryHookOptions<PromoBundleProdottoQuery, PromoBundleProdottoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoBundleProdottoQuery, PromoBundleProdottoQueryVariables>(PromoBundleProdottoDocument, options);
      }
export function usePromoBundleProdottoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoBundleProdottoQuery, PromoBundleProdottoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoBundleProdottoQuery, PromoBundleProdottoQueryVariables>(PromoBundleProdottoDocument, options);
        }
export type PromoBundleProdottoQueryHookResult = ReturnType<typeof usePromoBundleProdottoQuery>;
export type PromoBundleProdottoLazyQueryHookResult = ReturnType<typeof usePromoBundleProdottoLazyQuery>;
export type PromoBundleProdottoQueryResult = Apollo.QueryResult<PromoBundleProdottoQuery, PromoBundleProdottoQueryVariables>;
export const LastPromoPopupDocument = gql`
    query LastPromoPopup {
  lastPromoPopup {
    pk
    titolo
    descrizione
    image
    mobileImage
    ctaLabel1
    ctaLabel2
    url1
    url2
    linkedObjectId1
    linkedObjectId2
  }
}
    `;

/**
 * __useLastPromoPopupQuery__
 *
 * To run a query within a React component, call `useLastPromoPopupQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastPromoPopupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastPromoPopupQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastPromoPopupQuery(baseOptions?: Apollo.QueryHookOptions<LastPromoPopupQuery, LastPromoPopupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastPromoPopupQuery, LastPromoPopupQueryVariables>(LastPromoPopupDocument, options);
      }
export function useLastPromoPopupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastPromoPopupQuery, LastPromoPopupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastPromoPopupQuery, LastPromoPopupQueryVariables>(LastPromoPopupDocument, options);
        }
export type LastPromoPopupQueryHookResult = ReturnType<typeof useLastPromoPopupQuery>;
export type LastPromoPopupLazyQueryHookResult = ReturnType<typeof useLastPromoPopupLazyQuery>;
export type LastPromoPopupQueryResult = Apollo.QueryResult<LastPromoPopupQuery, LastPromoPopupQueryVariables>;
export const MotivazioniResoDocument = gql`
    query MotivazioniReso {
  motivazioniReso {
    pk
    nome
  }
}
    `;

/**
 * __useMotivazioniResoQuery__
 *
 * To run a query within a React component, call `useMotivazioniResoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMotivazioniResoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMotivazioniResoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMotivazioniResoQuery(baseOptions?: Apollo.QueryHookOptions<MotivazioniResoQuery, MotivazioniResoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MotivazioniResoQuery, MotivazioniResoQueryVariables>(MotivazioniResoDocument, options);
      }
export function useMotivazioniResoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MotivazioniResoQuery, MotivazioniResoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MotivazioniResoQuery, MotivazioniResoQueryVariables>(MotivazioniResoDocument, options);
        }
export type MotivazioniResoQueryHookResult = ReturnType<typeof useMotivazioniResoQuery>;
export type MotivazioniResoLazyQueryHookResult = ReturnType<typeof useMotivazioniResoLazyQuery>;
export type MotivazioniResoQueryResult = Apollo.QueryResult<MotivazioniResoQuery, MotivazioniResoQueryVariables>;
export const RichiediResoDocument = gql`
    mutation RichiediReso($richiestaReso: RichiediResoInput!) {
  richiediReso(richiestaReso: $richiestaReso) {
    message
    status
  }
}
    `;
export type RichiediResoMutationFn = Apollo.MutationFunction<RichiediResoMutation, RichiediResoMutationVariables>;

/**
 * __useRichiediResoMutation__
 *
 * To run a mutation, you first call `useRichiediResoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRichiediResoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [richiediResoMutation, { data, loading, error }] = useRichiediResoMutation({
 *   variables: {
 *      richiestaReso: // value for 'richiestaReso'
 *   },
 * });
 */
export function useRichiediResoMutation(baseOptions?: Apollo.MutationHookOptions<RichiediResoMutation, RichiediResoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RichiediResoMutation, RichiediResoMutationVariables>(RichiediResoDocument, options);
      }
export type RichiediResoMutationHookResult = ReturnType<typeof useRichiediResoMutation>;
export type RichiediResoMutationResult = Apollo.MutationResult<RichiediResoMutation>;
export type RichiediResoMutationOptions = Apollo.BaseMutationOptions<RichiediResoMutation, RichiediResoMutationVariables>;
export const MotivazioniNazioniDocument = gql`
    query MotivazioniNazioni {
  motivazioniNazioni {
    motivazioniContattoCustom {
      pk
      nome
      descrizione
    }
    nazioni {
      pk
      nome
    }
  }
}
    `;

/**
 * __useMotivazioniNazioniQuery__
 *
 * To run a query within a React component, call `useMotivazioniNazioniQuery` and pass it any options that fit your needs.
 * When your component renders, `useMotivazioniNazioniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMotivazioniNazioniQuery({
 *   variables: {
 *   },
 * });
 */
export function useMotivazioniNazioniQuery(baseOptions?: Apollo.QueryHookOptions<MotivazioniNazioniQuery, MotivazioniNazioniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MotivazioniNazioniQuery, MotivazioniNazioniQueryVariables>(MotivazioniNazioniDocument, options);
      }
export function useMotivazioniNazioniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MotivazioniNazioniQuery, MotivazioniNazioniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MotivazioniNazioniQuery, MotivazioniNazioniQueryVariables>(MotivazioniNazioniDocument, options);
        }
export type MotivazioniNazioniQueryHookResult = ReturnType<typeof useMotivazioniNazioniQuery>;
export type MotivazioniNazioniLazyQueryHookResult = ReturnType<typeof useMotivazioniNazioniLazyQuery>;
export type MotivazioniNazioniQueryResult = Apollo.QueryResult<MotivazioniNazioniQuery, MotivazioniNazioniQueryVariables>;
export const CreateContattoCustomDocument = gql`
    mutation CreateContattoCustom($contattoInput: CreateContattoInput!) {
  createContattoCustom(contattoInput: $contattoInput) {
    status
    message
  }
}
    `;
export type CreateContattoCustomMutationFn = Apollo.MutationFunction<CreateContattoCustomMutation, CreateContattoCustomMutationVariables>;

/**
 * __useCreateContattoCustomMutation__
 *
 * To run a mutation, you first call `useCreateContattoCustomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContattoCustomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContattoCustomMutation, { data, loading, error }] = useCreateContattoCustomMutation({
 *   variables: {
 *      contattoInput: // value for 'contattoInput'
 *   },
 * });
 */
export function useCreateContattoCustomMutation(baseOptions?: Apollo.MutationHookOptions<CreateContattoCustomMutation, CreateContattoCustomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContattoCustomMutation, CreateContattoCustomMutationVariables>(CreateContattoCustomDocument, options);
      }
export type CreateContattoCustomMutationHookResult = ReturnType<typeof useCreateContattoCustomMutation>;
export type CreateContattoCustomMutationResult = Apollo.MutationResult<CreateContattoCustomMutation>;
export type CreateContattoCustomMutationOptions = Apollo.BaseMutationOptions<CreateContattoCustomMutation, CreateContattoCustomMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    pk
    email
    nome
    cognome
    isStaff
    edit
    showToolbar
    isImpersonate
    isRivenditore
    cf
    piva
    guest
    privato
    progressoProfilo
    dateJoined
    dataPrimoOrdine
    dataUltimoOrdine
    numeroProdottiWishlist
    indirizziFatturazione {
      pk
      nome
      cognome
      indirizzo
      note
      provincia
      nazione {
        pk
        nome
        isoCode
      }
      citta
      cap
      telefono
      isDefault
      isFatturazione
    }
    indirizziSpedizione {
      pk
      nome
      cognome
      indirizzo
      provincia
      note
      nazione {
        pk
        nome
        isoCode
      }
      citta
      cap
      telefono
      isDefault
      isFatturazione
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const DashboardUtenteDocument = gql`
    query dashboardUtente {
  me {
    pk
    nome
    progressoProfilo
    ultimoOrdine {
      id
      pk
      codice
      created
      prezzoTotaleScontato
      trackingUrl
      url
      stato {
        pk
        nome
      }
      sistemaSpedizione {
        nome
        chiave
      }
      righeOrdine {
        prodotto {
          prodotto {
            previewImage
          }
        }
      }
    }
    cognome
    cf
    ragioneSociale
    piva
    sdi
    pec
    professionista
    dataDiNascita
    interessi {
      pk
    }
  }
}
    `;

/**
 * __useDashboardUtenteQuery__
 *
 * To run a query within a React component, call `useDashboardUtenteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardUtenteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardUtenteQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardUtenteQuery(baseOptions?: Apollo.QueryHookOptions<DashboardUtenteQuery, DashboardUtenteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardUtenteQuery, DashboardUtenteQueryVariables>(DashboardUtenteDocument, options);
      }
export function useDashboardUtenteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardUtenteQuery, DashboardUtenteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardUtenteQuery, DashboardUtenteQueryVariables>(DashboardUtenteDocument, options);
        }
export type DashboardUtenteQueryHookResult = ReturnType<typeof useDashboardUtenteQuery>;
export type DashboardUtenteLazyQueryHookResult = ReturnType<typeof useDashboardUtenteLazyQuery>;
export type DashboardUtenteQueryResult = Apollo.QueryResult<DashboardUtenteQuery, DashboardUtenteQueryVariables>;
export const ProfiloUtenteDocument = gql`
    query profiloUtente {
  me {
    pk
    progressoProfilo
    email
    nome
    cognome
    privato
    nome
    cognome
    cf
    ragioneSociale
    piva
    sdi
    pec
    professionista
    dataDiNascita
    interessi {
      pk
    }
  }
}
    `;

/**
 * __useProfiloUtenteQuery__
 *
 * To run a query within a React component, call `useProfiloUtenteQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfiloUtenteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfiloUtenteQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfiloUtenteQuery(baseOptions?: Apollo.QueryHookOptions<ProfiloUtenteQuery, ProfiloUtenteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfiloUtenteQuery, ProfiloUtenteQueryVariables>(ProfiloUtenteDocument, options);
      }
export function useProfiloUtenteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfiloUtenteQuery, ProfiloUtenteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfiloUtenteQuery, ProfiloUtenteQueryVariables>(ProfiloUtenteDocument, options);
        }
export type ProfiloUtenteQueryHookResult = ReturnType<typeof useProfiloUtenteQuery>;
export type ProfiloUtenteLazyQueryHookResult = ReturnType<typeof useProfiloUtenteLazyQuery>;
export type ProfiloUtenteQueryResult = Apollo.QueryResult<ProfiloUtenteQuery, ProfiloUtenteQueryVariables>;
export const PrivacyUtenteDocument = gql`
    query privacyUtente {
  me {
    pk
    consensoMkt
    consensoProfilazione
  }
}
    `;

/**
 * __usePrivacyUtenteQuery__
 *
 * To run a query within a React component, call `usePrivacyUtenteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivacyUtenteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivacyUtenteQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrivacyUtenteQuery(baseOptions?: Apollo.QueryHookOptions<PrivacyUtenteQuery, PrivacyUtenteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivacyUtenteQuery, PrivacyUtenteQueryVariables>(PrivacyUtenteDocument, options);
      }
export function usePrivacyUtenteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivacyUtenteQuery, PrivacyUtenteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivacyUtenteQuery, PrivacyUtenteQueryVariables>(PrivacyUtenteDocument, options);
        }
export type PrivacyUtenteQueryHookResult = ReturnType<typeof usePrivacyUtenteQuery>;
export type PrivacyUtenteLazyQueryHookResult = ReturnType<typeof usePrivacyUtenteLazyQuery>;
export type PrivacyUtenteQueryResult = Apollo.QueryResult<PrivacyUtenteQuery, PrivacyUtenteQueryVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    status
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const LoginDocument = gql`
    mutation Login($username: String!, $password: String!) {
  tokenAuth(username: $username, password: $password) {
    token
    user {
      pk
      nome
      cognome
      email
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const SocialAuthDocument = gql`
    mutation SocialAuth($provider: String!, $accessToken: String!) {
  socialAuth(provider: $provider, accessToken: $accessToken) {
    token
    user {
      id
    }
  }
}
    `;
export type SocialAuthMutationFn = Apollo.MutationFunction<SocialAuthMutation, SocialAuthMutationVariables>;

/**
 * __useSocialAuthMutation__
 *
 * To run a mutation, you first call `useSocialAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialAuthMutation, { data, loading, error }] = useSocialAuthMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useSocialAuthMutation(baseOptions?: Apollo.MutationHookOptions<SocialAuthMutation, SocialAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SocialAuthMutation, SocialAuthMutationVariables>(SocialAuthDocument, options);
      }
export type SocialAuthMutationHookResult = ReturnType<typeof useSocialAuthMutation>;
export type SocialAuthMutationResult = Apollo.MutationResult<SocialAuthMutation>;
export type SocialAuthMutationOptions = Apollo.BaseMutationOptions<SocialAuthMutation, SocialAuthMutationVariables>;
export const CreateUtenteDocument = gql`
    mutation CreateUtente($input: SignInInput!) {
  createUtente(input: $input) {
    utente {
      id
      email
      nome
      cognome
      ragioneSociale
    }
    message
    status
    statusCode
  }
}
    `;
export type CreateUtenteMutationFn = Apollo.MutationFunction<CreateUtenteMutation, CreateUtenteMutationVariables>;

/**
 * __useCreateUtenteMutation__
 *
 * To run a mutation, you first call `useCreateUtenteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUtenteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUtenteMutation, { data, loading, error }] = useCreateUtenteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUtenteMutation(baseOptions?: Apollo.MutationHookOptions<CreateUtenteMutation, CreateUtenteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUtenteMutation, CreateUtenteMutationVariables>(CreateUtenteDocument, options);
      }
export type CreateUtenteMutationHookResult = ReturnType<typeof useCreateUtenteMutation>;
export type CreateUtenteMutationResult = Apollo.MutationResult<CreateUtenteMutation>;
export type CreateUtenteMutationOptions = Apollo.BaseMutationOptions<CreateUtenteMutation, CreateUtenteMutationVariables>;
export const InteresseUtenteDocument = gql`
    query InteresseUtente {
  interessiUtente {
    pk
    alias
    descrizione
  }
}
    `;

/**
 * __useInteresseUtenteQuery__
 *
 * To run a query within a React component, call `useInteresseUtenteQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteresseUtenteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteresseUtenteQuery({
 *   variables: {
 *   },
 * });
 */
export function useInteresseUtenteQuery(baseOptions?: Apollo.QueryHookOptions<InteresseUtenteQuery, InteresseUtenteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InteresseUtenteQuery, InteresseUtenteQueryVariables>(InteresseUtenteDocument, options);
      }
export function useInteresseUtenteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InteresseUtenteQuery, InteresseUtenteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InteresseUtenteQuery, InteresseUtenteQueryVariables>(InteresseUtenteDocument, options);
        }
export type InteresseUtenteQueryHookResult = ReturnType<typeof useInteresseUtenteQuery>;
export type InteresseUtenteLazyQueryHookResult = ReturnType<typeof useInteresseUtenteLazyQuery>;
export type InteresseUtenteQueryResult = Apollo.QueryResult<InteresseUtenteQuery, InteresseUtenteQueryVariables>;
export const CompleteSignInDocument = gql`
    mutation CompleteSignIn($professionista: Boolean, $birthdate: String, $ambienteLavoro: Int) {
  completeSignIn(
    professionista: $professionista
    birthdate: $birthdate
    ambienteLavoro: $ambienteLavoro
  ) {
    status
    message
  }
}
    `;
export type CompleteSignInMutationFn = Apollo.MutationFunction<CompleteSignInMutation, CompleteSignInMutationVariables>;

/**
 * __useCompleteSignInMutation__
 *
 * To run a mutation, you first call `useCompleteSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSignInMutation, { data, loading, error }] = useCompleteSignInMutation({
 *   variables: {
 *      professionista: // value for 'professionista'
 *      birthdate: // value for 'birthdate'
 *      ambienteLavoro: // value for 'ambienteLavoro'
 *   },
 * });
 */
export function useCompleteSignInMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSignInMutation, CompleteSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSignInMutation, CompleteSignInMutationVariables>(CompleteSignInDocument, options);
      }
export type CompleteSignInMutationHookResult = ReturnType<typeof useCompleteSignInMutation>;
export type CompleteSignInMutationResult = Apollo.MutationResult<CompleteSignInMutation>;
export type CompleteSignInMutationOptions = Apollo.BaseMutationOptions<CompleteSignInMutation, CompleteSignInMutationVariables>;
export const RecuperaPasswordDocument = gql`
    mutation recuperaPassword($email: String!) {
  recuperaPassword(email: $email) {
    status
    statusCode
  }
}
    `;
export type RecuperaPasswordMutationFn = Apollo.MutationFunction<RecuperaPasswordMutation, RecuperaPasswordMutationVariables>;

/**
 * __useRecuperaPasswordMutation__
 *
 * To run a mutation, you first call `useRecuperaPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecuperaPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recuperaPasswordMutation, { data, loading, error }] = useRecuperaPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRecuperaPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RecuperaPasswordMutation, RecuperaPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecuperaPasswordMutation, RecuperaPasswordMutationVariables>(RecuperaPasswordDocument, options);
      }
export type RecuperaPasswordMutationHookResult = ReturnType<typeof useRecuperaPasswordMutation>;
export type RecuperaPasswordMutationResult = Apollo.MutationResult<RecuperaPasswordMutation>;
export type RecuperaPasswordMutationOptions = Apollo.BaseMutationOptions<RecuperaPasswordMutation, RecuperaPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($token: String!, $password: String!) {
  resetPassword(password: $password, token: $token) {
    status
    statusCode
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const MyAccountEditDocument = gql`
    mutation myAccountEdit($input: UtenteInput!) {
  myAccountEdit(input: $input) {
    status
    message
  }
}
    `;
export type MyAccountEditMutationFn = Apollo.MutationFunction<MyAccountEditMutation, MyAccountEditMutationVariables>;

/**
 * __useMyAccountEditMutation__
 *
 * To run a mutation, you first call `useMyAccountEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAccountEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAccountEditMutation, { data, loading, error }] = useMyAccountEditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyAccountEditMutation(baseOptions?: Apollo.MutationHookOptions<MyAccountEditMutation, MyAccountEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAccountEditMutation, MyAccountEditMutationVariables>(MyAccountEditDocument, options);
      }
export type MyAccountEditMutationHookResult = ReturnType<typeof useMyAccountEditMutation>;
export type MyAccountEditMutationResult = Apollo.MutationResult<MyAccountEditMutation>;
export type MyAccountEditMutationOptions = Apollo.BaseMutationOptions<MyAccountEditMutation, MyAccountEditMutationVariables>;
export const MyAccountChangePasswordDocument = gql`
    mutation myAccountChangePassword($oldPassword: String!, $newPassword: String!) {
  myAccountChangePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    status
    message
  }
}
    `;
export type MyAccountChangePasswordMutationFn = Apollo.MutationFunction<MyAccountChangePasswordMutation, MyAccountChangePasswordMutationVariables>;

/**
 * __useMyAccountChangePasswordMutation__
 *
 * To run a mutation, you first call `useMyAccountChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAccountChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAccountChangePasswordMutation, { data, loading, error }] = useMyAccountChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useMyAccountChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<MyAccountChangePasswordMutation, MyAccountChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAccountChangePasswordMutation, MyAccountChangePasswordMutationVariables>(MyAccountChangePasswordDocument, options);
      }
export type MyAccountChangePasswordMutationHookResult = ReturnType<typeof useMyAccountChangePasswordMutation>;
export type MyAccountChangePasswordMutationResult = Apollo.MutationResult<MyAccountChangePasswordMutation>;
export type MyAccountChangePasswordMutationOptions = Apollo.BaseMutationOptions<MyAccountChangePasswordMutation, MyAccountChangePasswordMutationVariables>;
export const MyAccountSetIndirizzoDefaultDocument = gql`
    mutation myAccountSetIndirizzoDefault($pk: Int!) {
  myAccountSetIndirizzoDefault(pk: $pk) {
    status
    message
  }
}
    `;
export type MyAccountSetIndirizzoDefaultMutationFn = Apollo.MutationFunction<MyAccountSetIndirizzoDefaultMutation, MyAccountSetIndirizzoDefaultMutationVariables>;

/**
 * __useMyAccountSetIndirizzoDefaultMutation__
 *
 * To run a mutation, you first call `useMyAccountSetIndirizzoDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAccountSetIndirizzoDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAccountSetIndirizzoDefaultMutation, { data, loading, error }] = useMyAccountSetIndirizzoDefaultMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useMyAccountSetIndirizzoDefaultMutation(baseOptions?: Apollo.MutationHookOptions<MyAccountSetIndirizzoDefaultMutation, MyAccountSetIndirizzoDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAccountSetIndirizzoDefaultMutation, MyAccountSetIndirizzoDefaultMutationVariables>(MyAccountSetIndirizzoDefaultDocument, options);
      }
export type MyAccountSetIndirizzoDefaultMutationHookResult = ReturnType<typeof useMyAccountSetIndirizzoDefaultMutation>;
export type MyAccountSetIndirizzoDefaultMutationResult = Apollo.MutationResult<MyAccountSetIndirizzoDefaultMutation>;
export type MyAccountSetIndirizzoDefaultMutationOptions = Apollo.BaseMutationOptions<MyAccountSetIndirizzoDefaultMutation, MyAccountSetIndirizzoDefaultMutationVariables>;
export const MyAccountDeleteIndirizzoDocument = gql`
    mutation myAccountDeleteIndirizzo($pk: Int!) {
  myAccountDeleteIndirizzo(pk: $pk) {
    status
    message
  }
}
    `;
export type MyAccountDeleteIndirizzoMutationFn = Apollo.MutationFunction<MyAccountDeleteIndirizzoMutation, MyAccountDeleteIndirizzoMutationVariables>;

/**
 * __useMyAccountDeleteIndirizzoMutation__
 *
 * To run a mutation, you first call `useMyAccountDeleteIndirizzoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAccountDeleteIndirizzoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAccountDeleteIndirizzoMutation, { data, loading, error }] = useMyAccountDeleteIndirizzoMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useMyAccountDeleteIndirizzoMutation(baseOptions?: Apollo.MutationHookOptions<MyAccountDeleteIndirizzoMutation, MyAccountDeleteIndirizzoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAccountDeleteIndirizzoMutation, MyAccountDeleteIndirizzoMutationVariables>(MyAccountDeleteIndirizzoDocument, options);
      }
export type MyAccountDeleteIndirizzoMutationHookResult = ReturnType<typeof useMyAccountDeleteIndirizzoMutation>;
export type MyAccountDeleteIndirizzoMutationResult = Apollo.MutationResult<MyAccountDeleteIndirizzoMutation>;
export type MyAccountDeleteIndirizzoMutationOptions = Apollo.BaseMutationOptions<MyAccountDeleteIndirizzoMutation, MyAccountDeleteIndirizzoMutationVariables>;
export const DeleteUtenteDocument = gql`
    mutation DeleteUtente {
  deleteUtente {
    message
  }
}
    `;
export type DeleteUtenteMutationFn = Apollo.MutationFunction<DeleteUtenteMutation, DeleteUtenteMutationVariables>;

/**
 * __useDeleteUtenteMutation__
 *
 * To run a mutation, you first call `useDeleteUtenteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUtenteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUtenteMutation, { data, loading, error }] = useDeleteUtenteMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUtenteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUtenteMutation, DeleteUtenteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUtenteMutation, DeleteUtenteMutationVariables>(DeleteUtenteDocument, options);
      }
export type DeleteUtenteMutationHookResult = ReturnType<typeof useDeleteUtenteMutation>;
export type DeleteUtenteMutationResult = Apollo.MutationResult<DeleteUtenteMutation>;
export type DeleteUtenteMutationOptions = Apollo.BaseMutationOptions<DeleteUtenteMutation, DeleteUtenteMutationVariables>;
export const GaranzieUtenteDocument = gql`
    query GaranzieUtente {
  garanzieUtente {
    pk
    numeroSerie
    created
    dataScadenza
    productRegistrationId
    prodotto {
      nome
      categoria {
        nome
      }
    }
  }
}
    `;

/**
 * __useGaranzieUtenteQuery__
 *
 * To run a query within a React component, call `useGaranzieUtenteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGaranzieUtenteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGaranzieUtenteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGaranzieUtenteQuery(baseOptions?: Apollo.QueryHookOptions<GaranzieUtenteQuery, GaranzieUtenteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GaranzieUtenteQuery, GaranzieUtenteQueryVariables>(GaranzieUtenteDocument, options);
      }
export function useGaranzieUtenteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GaranzieUtenteQuery, GaranzieUtenteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GaranzieUtenteQuery, GaranzieUtenteQueryVariables>(GaranzieUtenteDocument, options);
        }
export type GaranzieUtenteQueryHookResult = ReturnType<typeof useGaranzieUtenteQuery>;
export type GaranzieUtenteLazyQueryHookResult = ReturnType<typeof useGaranzieUtenteLazyQuery>;
export type GaranzieUtenteQueryResult = Apollo.QueryResult<GaranzieUtenteQuery, GaranzieUtenteQueryVariables>;
export const VideoDocument = gql`
    query Video($slug: String!, $preview: Boolean) {
  video(slug: $slug, preview: $preview) {
    pk
    titolo
    sottotitolo
    idYoutube
    adminUrl
    modelClass
    model
    categoria {
      nome
    }
    correlati {
      titolo
      url
      idYoutube
      categoria {
        nome
      }
    }
    pagebuilders {
      key
      json_draft: jsonDraft
      json_published: jsonPublished
      text
    }
    pagina {
      adminUrl
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
        canonicalUrl
      }
      hreflangs {
        hrefLang
        href
      }
    }
  }
}
    `;

/**
 * __useVideoQuery__
 *
 * To run a query within a React component, call `useVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useVideoQuery(baseOptions: Apollo.QueryHookOptions<VideoQuery, VideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoQuery, VideoQueryVariables>(VideoDocument, options);
      }
export function useVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoQuery, VideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoQuery, VideoQueryVariables>(VideoDocument, options);
        }
export type VideoQueryHookResult = ReturnType<typeof useVideoQuery>;
export type VideoLazyQueryHookResult = ReturnType<typeof useVideoLazyQuery>;
export type VideoQueryResult = Apollo.QueryResult<VideoQuery, VideoQueryVariables>;
export const ListingVideoTutorialDocument = gql`
    query ListingVideoTutorial($slug: String, $params: GenericScalar) {
  listingVideoTutorial(slug: $slug, params: $params) {
    paginator {
      currentPage
      numPages
      itemsPerPage
      count
      pages {
        href
        page
      }
    }
    videos {
      pk
      titolo
      sottotitolo
      idYoutube
      adminUrl
      modelClass
      url
      model
      categoria {
        nome
      }
    }
    categorie {
      pk
      nome
      url
      slug
    }
    categoria {
      pk
      slug
      alias
      nome
      pagina {
        adminUrl
        breadcrumbs {
          label
          url
        }
        seo {
          title
          description
          image
          noindex
          canonicalUrl
        }
        mainImage
        descrizione
      }
    }
    root {
      url
    }
    canonicalUrl
  }
}
    `;

/**
 * __useListingVideoTutorialQuery__
 *
 * To run a query within a React component, call `useListingVideoTutorialQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingVideoTutorialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingVideoTutorialQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useListingVideoTutorialQuery(baseOptions?: Apollo.QueryHookOptions<ListingVideoTutorialQuery, ListingVideoTutorialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingVideoTutorialQuery, ListingVideoTutorialQueryVariables>(ListingVideoTutorialDocument, options);
      }
export function useListingVideoTutorialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingVideoTutorialQuery, ListingVideoTutorialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingVideoTutorialQuery, ListingVideoTutorialQueryVariables>(ListingVideoTutorialDocument, options);
        }
export type ListingVideoTutorialQueryHookResult = ReturnType<typeof useListingVideoTutorialQuery>;
export type ListingVideoTutorialLazyQueryHookResult = ReturnType<typeof useListingVideoTutorialLazyQuery>;
export type ListingVideoTutorialQueryResult = Apollo.QueryResult<ListingVideoTutorialQuery, ListingVideoTutorialQueryVariables>;
export const VolantinoDocument = gql`
    query Volantino($slug: String!, $preview: Boolean) {
  volantino(slug: $slug, preview: $preview) {
    ...VolantinoCard
    adminUrl
    modelClass
    pagina {
      adminUrl
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
        canonicalUrl
      }
      hreflangs {
        hrefLang
        href
      }
    }
  }
}
    ${VolantinoCardFragmentDoc}`;

/**
 * __useVolantinoQuery__
 *
 * To run a query within a React component, call `useVolantinoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolantinoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolantinoQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useVolantinoQuery(baseOptions: Apollo.QueryHookOptions<VolantinoQuery, VolantinoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VolantinoQuery, VolantinoQueryVariables>(VolantinoDocument, options);
      }
export function useVolantinoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VolantinoQuery, VolantinoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VolantinoQuery, VolantinoQueryVariables>(VolantinoDocument, options);
        }
export type VolantinoQueryHookResult = ReturnType<typeof useVolantinoQuery>;
export type VolantinoLazyQueryHookResult = ReturnType<typeof useVolantinoLazyQuery>;
export type VolantinoQueryResult = Apollo.QueryResult<VolantinoQuery, VolantinoQueryVariables>;
export const SottocategoriaVolantinoDocument = gql`
    query SottocategoriaVolantino($slugVolantino: String!, $slug: String!, $preview: Boolean) {
  sottocategoriaVolantino(
    slugVolantino: $slugVolantino
    slug: $slug
    preview: $preview
  ) {
    nome
    slug
    descrizioneVolantino
    immagineVolantino
    pdfUrl
    plusPoints {
      titolo
      descrizione
      immagine
    }
    tabellaDatiTecnici {
      attributi
      prodotti {
        valori
        prodotto {
          ...ProdottoCard
        }
      }
    }
    accessoriCompatibili {
      ...ProdottoCard
    }
    volantinoVisualizzato {
      slug
      intro
      titolo
      descrizione
      immagine
      url
      pdfUrl
      pagina {
        seo {
          title
          description
          image
        }
      }
    }
    tabellaCompatibilita {
      nome
      descrizione
      dati {
        image
        products {
          nome
          rif
          compatibilita
        }
      }
    }
  }
}
    ${ProdottoCardFragmentDoc}`;

/**
 * __useSottocategoriaVolantinoQuery__
 *
 * To run a query within a React component, call `useSottocategoriaVolantinoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSottocategoriaVolantinoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSottocategoriaVolantinoQuery({
 *   variables: {
 *      slugVolantino: // value for 'slugVolantino'
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useSottocategoriaVolantinoQuery(baseOptions: Apollo.QueryHookOptions<SottocategoriaVolantinoQuery, SottocategoriaVolantinoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SottocategoriaVolantinoQuery, SottocategoriaVolantinoQueryVariables>(SottocategoriaVolantinoDocument, options);
      }
export function useSottocategoriaVolantinoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SottocategoriaVolantinoQuery, SottocategoriaVolantinoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SottocategoriaVolantinoQuery, SottocategoriaVolantinoQueryVariables>(SottocategoriaVolantinoDocument, options);
        }
export type SottocategoriaVolantinoQueryHookResult = ReturnType<typeof useSottocategoriaVolantinoQuery>;
export type SottocategoriaVolantinoLazyQueryHookResult = ReturnType<typeof useSottocategoriaVolantinoLazyQuery>;
export type SottocategoriaVolantinoQueryResult = Apollo.QueryResult<SottocategoriaVolantinoQuery, SottocategoriaVolantinoQueryVariables>;
export const VolantinoPdfDocument = gql`
    query VolantinoPdf($slug: String!, $preview: Boolean) {
  volantino(slug: $slug, preview: $preview) {
    ...VolantinoCard
    sottocategorie {
      nome
      slug
      descrizioneVolantino
      immaginiVolantinoDigitale
      immagineVolantino
      plusPoints {
        titolo
        descrizione
        immagine
      }
      tabellaDatiTecnici {
        attributi
        prodotti {
          valori
          prodotto {
            ...ProdottoCard
          }
        }
      }
    }
    tabellaCompatibilita {
      nome
      descrizione
      dati {
        image
        products {
          nome
          rif
          compatibilita
          prodotti
        }
      }
    }
    adminUrl
    modelClass
    pagina {
      adminUrl
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
        canonicalUrl
      }
      hreflangs {
        hrefLang
        href
      }
    }
  }
}
    ${VolantinoCardFragmentDoc}
${ProdottoCardFragmentDoc}`;

/**
 * __useVolantinoPdfQuery__
 *
 * To run a query within a React component, call `useVolantinoPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolantinoPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolantinoPdfQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useVolantinoPdfQuery(baseOptions: Apollo.QueryHookOptions<VolantinoPdfQuery, VolantinoPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VolantinoPdfQuery, VolantinoPdfQueryVariables>(VolantinoPdfDocument, options);
      }
export function useVolantinoPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VolantinoPdfQuery, VolantinoPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VolantinoPdfQuery, VolantinoPdfQueryVariables>(VolantinoPdfDocument, options);
        }
export type VolantinoPdfQueryHookResult = ReturnType<typeof useVolantinoPdfQuery>;
export type VolantinoPdfLazyQueryHookResult = ReturnType<typeof useVolantinoPdfLazyQuery>;
export type VolantinoPdfQueryResult = Apollo.QueryResult<VolantinoPdfQuery, VolantinoPdfQueryVariables>;
export const WishlistDocument = gql`
    query Wishlist {
  wishlist {
    items {
      prodotto {
        ...ProdottoCard
      }
    }
  }
}
    ${ProdottoCardFragmentDoc}`;

/**
 * __useWishlistQuery__
 *
 * To run a query within a React component, call `useWishlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWishlistQuery({
 *   variables: {
 *   },
 * });
 */
export function useWishlistQuery(baseOptions?: Apollo.QueryHookOptions<WishlistQuery, WishlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WishlistQuery, WishlistQueryVariables>(WishlistDocument, options);
      }
export function useWishlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WishlistQuery, WishlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WishlistQuery, WishlistQueryVariables>(WishlistDocument, options);
        }
export type WishlistQueryHookResult = ReturnType<typeof useWishlistQuery>;
export type WishlistLazyQueryHookResult = ReturnType<typeof useWishlistLazyQuery>;
export type WishlistQueryResult = Apollo.QueryResult<WishlistQuery, WishlistQueryVariables>;
export const WishlistButtonDocument = gql`
    query WishlistButton {
  wishlist {
    items {
      prodotto {
        pk
      }
    }
  }
}
    `;

/**
 * __useWishlistButtonQuery__
 *
 * To run a query within a React component, call `useWishlistButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishlistButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWishlistButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useWishlistButtonQuery(baseOptions?: Apollo.QueryHookOptions<WishlistButtonQuery, WishlistButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WishlistButtonQuery, WishlistButtonQueryVariables>(WishlistButtonDocument, options);
      }
export function useWishlistButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WishlistButtonQuery, WishlistButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WishlistButtonQuery, WishlistButtonQueryVariables>(WishlistButtonDocument, options);
        }
export type WishlistButtonQueryHookResult = ReturnType<typeof useWishlistButtonQuery>;
export type WishlistButtonLazyQueryHookResult = ReturnType<typeof useWishlistButtonLazyQuery>;
export type WishlistButtonQueryResult = Apollo.QueryResult<WishlistButtonQuery, WishlistButtonQueryVariables>;
export const AddWishlistItemDocument = gql`
    mutation AddWishlistItem($idProdotto: Int!) {
  addWishlistItem(idProdotto: $idProdotto) {
    status
    message
  }
}
    `;
export type AddWishlistItemMutationFn = Apollo.MutationFunction<AddWishlistItemMutation, AddWishlistItemMutationVariables>;

/**
 * __useAddWishlistItemMutation__
 *
 * To run a mutation, you first call `useAddWishlistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWishlistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWishlistItemMutation, { data, loading, error }] = useAddWishlistItemMutation({
 *   variables: {
 *      idProdotto: // value for 'idProdotto'
 *   },
 * });
 */
export function useAddWishlistItemMutation(baseOptions?: Apollo.MutationHookOptions<AddWishlistItemMutation, AddWishlistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWishlistItemMutation, AddWishlistItemMutationVariables>(AddWishlistItemDocument, options);
      }
export type AddWishlistItemMutationHookResult = ReturnType<typeof useAddWishlistItemMutation>;
export type AddWishlistItemMutationResult = Apollo.MutationResult<AddWishlistItemMutation>;
export type AddWishlistItemMutationOptions = Apollo.BaseMutationOptions<AddWishlistItemMutation, AddWishlistItemMutationVariables>;
export const RemoveWishlistItemDocument = gql`
    mutation RemoveWishlistItem($idProdotto: Int!) {
  removeWishlistItem(idProdotto: $idProdotto) {
    status
    message
  }
}
    `;
export type RemoveWishlistItemMutationFn = Apollo.MutationFunction<RemoveWishlistItemMutation, RemoveWishlistItemMutationVariables>;

/**
 * __useRemoveWishlistItemMutation__
 *
 * To run a mutation, you first call `useRemoveWishlistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWishlistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWishlistItemMutation, { data, loading, error }] = useRemoveWishlistItemMutation({
 *   variables: {
 *      idProdotto: // value for 'idProdotto'
 *   },
 * });
 */
export function useRemoveWishlistItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWishlistItemMutation, RemoveWishlistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWishlistItemMutation, RemoveWishlistItemMutationVariables>(RemoveWishlistItemDocument, options);
      }
export type RemoveWishlistItemMutationHookResult = ReturnType<typeof useRemoveWishlistItemMutation>;
export type RemoveWishlistItemMutationResult = Apollo.MutationResult<RemoveWishlistItemMutation>;
export type RemoveWishlistItemMutationOptions = Apollo.BaseMutationOptions<RemoveWishlistItemMutation, RemoveWishlistItemMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "CategoriaNode",
      "OrdineNode",
      "PaginaNode",
      "StatoNode",
      "UtenteNode"
    ]
  }
};
      export default result;
    